// @generated by protoc-gen-es v2.11.0 with parameter "ts_nocheck=true,target=ts"
// @generated from file api-request.proto (package Authentication, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type {
  AppClientType,
  EncryptedKeyType,
  EnterpriseRegistration,
  KeyType,
  TypedKey,
} from "./enterprise_pb";
import { file_enterprise } from "./enterprise_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api-request.proto.
 */
export const file_api_request: GenFile =
  /*@__PURE__*/
  fileDesc(
    "ChFhcGktcmVxdWVzdC5wcm90bxIOQXV0aGVudGljYXRpb24isAEKCkFwaVJlcXVlc3QSIAoYZW5jcnlwdGVkVHJhbnNtaXNzaW9uS2V5GAEgASgMEhMKC3B1YmxpY0tleUlkGAIgASgFEg4KBmxvY2FsZRgDIAEoCRIYChBlbmNyeXB0ZWRQYXlsb2FkGAQgASgMEhYKDmVuY3J5cHRpb25UeXBlGAUgASgFEhEKCXJlY2FwdGNoYRgGIAEoCRIWCg5zdWJFbnZpcm9ubWVudBgHIAEoCSJqChFBcGlSZXF1ZXN0UGF5bG9hZBIPCgdwYXlsb2FkGAEgASgMEh0KFWVuY3J5cHRlZFNlc3Npb25Ub2tlbhgCIAEoDBIRCgl0aW1lVG9rZW4YAyABKAwSEgoKYXBpVmVyc2lvbhgEIAEoBSI2CglUcmFuc2Zvcm0SCwoDa2V5GAEgASgMEhwKFGVuY3J5cHRlZERldmljZVRva2VuGAIgASgMIqABCg1EZXZpY2VSZXF1ZXN0EhUKDWNsaWVudFZlcnNpb24YASABKAkSEgoKZGV2aWNlTmFtZRgCIAEoCRIWCg5kZXZpY2VQbGF0Zm9ybRgDIAEoCRI6ChBjbGllbnRGb3JtRmFjdG9yGAQgASgOMiAuQXV0aGVudGljYXRpb24uQ2xpZW50Rm9ybUZhY3RvchIQCgh1c2VybmFtZRgFIAEoCSJUCgtBdXRoUmVxdWVzdBIVCg1jbGllbnRWZXJzaW9uGAEgASgJEhAKCHVzZXJuYW1lGAIgASgJEhwKFGVuY3J5cHRlZERldmljZVRva2VuGAMgASgMIsMBChROZXdVc2VyTWluaW11bVBhcmFtcxIZChFtaW5pbXVtSXRlcmF0aW9ucxgBIAEoBRIaChJwYXNzd29yZE1hdGNoUmVnZXgYAiADKAkSIAoYcGFzc3dvcmRNYXRjaERlc2NyaXB0aW9uGAMgAygJEhoKEmlzRW50ZXJwcmlzZURvbWFpbhgEIAEoCBIeChZlbnRlcnByaXNlRWNjUHVibGljS2V5GAUgASgMEhYKDmZvcmJpZEtleVR5cGUyGAYgASgIIokBCg9QcmVMb2dpblJlcXVlc3QSMAoLYXV0aFJlcXVlc3QYASABKAsyGy5BdXRoZW50aWNhdGlvbi5BdXRoUmVxdWVzdBIsCglsb2dpblR5cGUYAiABKA4yGS5BdXRoZW50aWNhdGlvbi5Mb2dpblR5cGUSFgoOdHdvRmFjdG9yVG9rZW4YAyABKAwigAIKDExvZ2luUmVxdWVzdBIwCgthdXRoUmVxdWVzdBgBIAEoCzIbLkF1dGhlbnRpY2F0aW9uLkF1dGhSZXF1ZXN0EiwKCWxvZ2luVHlwZRgCIAEoDjIZLkF1dGhlbnRpY2F0aW9uLkxvZ2luVHlwZRIfChdhdXRoZW50aWNhdGlvbkhhc2hQcmltZRgDIAEoDBIbChNlbmNyeXB0ZWRMb2dpblRva2VuGAQgASgMEhQKDGF1dGhSZXNwb25zZRgFIAEoDBIWCg5tY0VudGVycHJpc2VJZBgGIAEoBRISCgpwdXNoX3Rva2VuGAcgASgJEhAKCHBsYXRmb3JtGAggASgJIlwKDkRldmljZVJlc3BvbnNlEhwKFGVuY3J5cHRlZERldmljZVRva2VuGAEgASgMEiwKBnN0YXR1cxgCIAEoDjIcLkF1dGhlbnRpY2F0aW9uLkRldmljZVN0YXR1cyJWCgRTYWx0EhIKCml0ZXJhdGlvbnMYASABKAUSDAoEc2FsdBgCIAEoDBIRCglhbGdvcml0aG0YAyABKAUSCwoDdWlkGAQgASgMEgwKBG5hbWUYBSABKAkiIAoQVHdvRmFjdG9yQ2hhbm5lbBIMCgR0eXBlGAEgASgFIvwCChFTdGFydExvZ2luUmVxdWVzdBIcChRlbmNyeXB0ZWREZXZpY2VUb2tlbhgBIAEoDBIQCgh1c2VybmFtZRgCIAEoCRIVCg1jbGllbnRWZXJzaW9uGAMgASgJEhkKEW1lc3NhZ2VTZXNzaW9uVWlkGAQgASgMEhsKE2VuY3J5cHRlZExvZ2luVG9rZW4YBSABKAwSLAoJbG9naW5UeXBlGAYgASgOMhkuQXV0aGVudGljYXRpb24uTG9naW5UeXBlEhYKDm1jRW50ZXJwcmlzZUlkGAcgASgFEjAKC2xvZ2luTWV0aG9kGAggASgOMhsuQXV0aGVudGljYXRpb24uTG9naW5NZXRob2QSFQoNZm9yY2VOZXdMb2dpbhgJIAEoCBIRCgljbG9uZUNvZGUYCiABKAwSGAoQdjJUd29GYWN0b3JUb2tlbhgLIAEoCRISCgphY2NvdW50VWlkGAwgASgMEhgKEGZyb21TZXNzaW9uVG9rZW4YDSABKAwipwQKDUxvZ2luUmVzcG9uc2USLgoKbG9naW5TdGF0ZRgBIAEoDjIaLkF1dGhlbnRpY2F0aW9uLkxvZ2luU3RhdGUSEgoKYWNjb3VudFVpZBgCIAEoDBIXCg9wcmltYXJ5VXNlcm5hbWUYAyABKAkSGAoQZW5jcnlwdGVkRGF0YUtleRgEIAEoDBJCChRlbmNyeXB0ZWREYXRhS2V5VHlwZRgFIAEoDjIkLkF1dGhlbnRpY2F0aW9uLkVuY3J5cHRlZERhdGFLZXlUeXBlEhsKE2VuY3J5cHRlZExvZ2luVG9rZW4YBiABKAwSHQoVZW5jcnlwdGVkU2Vzc2lvblRva2VuGAcgASgMEjoKEHNlc3Npb25Ub2tlblR5cGUYCCABKA4yIC5BdXRoZW50aWNhdGlvbi5TZXNzaW9uVG9rZW5UeXBlEg8KB21lc3NhZ2UYCSABKAkSCwoDdXJsGAogASgJEjYKCGNoYW5uZWxzGAsgAygLMiQuQXV0aGVudGljYXRpb24uVHdvRmFjdG9yQ2hhbm5lbEluZm8SIgoEc2FsdBgMIAMoCzIULkF1dGhlbnRpY2F0aW9uLlNhbHQSEQoJY2xvbmVDb2RlGA0gASgMEhoKEnN0YXRlU3BlY2lmaWNWYWx1ZRgOIAEoCRIYChBzc29DbGllbnRWZXJzaW9uGA8gASgJEiAKGHNlc3Npb25Ub2tlblR5cGVNb2RpZmllchgQIAEoCSJfChFTd2l0Y2hMaXN0RWxlbWVudBIQCgh1c2VybmFtZRgBIAEoCRIQCghmdWxsTmFtZRgCIAEoCRIUCgxhdXRoUmVxdWlyZWQYAyABKAgSEAoIaXNMaW5rZWQYBCABKAgiSQoSU3dpdGNoTGlzdFJlc3BvbnNlEjMKCGVsZW1lbnRzGAEgAygLMiEuQXV0aGVudGljYXRpb24uU3dpdGNoTGlzdEVsZW1lbnQijAEKC1Nzb1VzZXJJbmZvEhMKC2NvbXBhbnlOYW1lGAEgASgJEhMKC3NhbWxSZXF1ZXN0GAIgASgJEhcKD3NhbWxSZXF1ZXN0VHlwZRgDIAEoCRIVCg1zc29Eb21haW5OYW1lGAQgASgJEhAKCGxvZ2luVXJsGAUgASgJEhEKCWxvZ291dFVybBgGIAEoCSLWAQoQUHJlTG9naW5SZXNwb25zZRIyCgxkZXZpY2VTdGF0dXMYASABKA4yHC5BdXRoZW50aWNhdGlvbi5EZXZpY2VTdGF0dXMSIgoEc2FsdBgCIAMoCzIULkF1dGhlbnRpY2F0aW9uLlNhbHQSOAoOT0JTT0xFVEVfRklFTEQYAyADKAsyIC5BdXRoZW50aWNhdGlvbi5Ud29GYWN0b3JDaGFubmVsEjAKC3Nzb1VzZXJJbmZvGAQgASgLMhsuQXV0aGVudGljYXRpb24uU3NvVXNlckluZm8iJgoSTG9naW5Bc1VzZXJSZXF1ZXN0EhAKCHVzZXJuYW1lGAEgASgJIlcKE0xvZ2luQXNVc2VyUmVzcG9uc2USHQoVZW5jcnlwdGVkU2Vzc2lvblRva2VuGAEgASgMEiEKGWVuY3J5cHRlZFNoYXJlZEFjY291bnRLZXkYAiABKAwihAEKF1ZhbGlkYXRlQXV0aEhhc2hSZXF1ZXN0EjYKDnBhc3N3b3JkTWV0aG9kGAEgASgOMh4uQXV0aGVudGljYXRpb24uUGFzc3dvcmRNZXRob2QSFAoMYXV0aFJlc3BvbnNlGAIgASgMEhsKE2VuY3J5cHRlZExvZ2luVG9rZW4YAyABKAwixAIKFFR3b0ZhY3RvckNoYW5uZWxJbmZvEjkKC2NoYW5uZWxUeXBlGAEgASgOMiQuQXV0aGVudGljYXRpb24uVHdvRmFjdG9yQ2hhbm5lbFR5cGUSEwoLY2hhbm5lbF91aWQYAiABKAwSEwoLY2hhbm5lbE5hbWUYAyABKAkSEQoJY2hhbGxlbmdlGAQgASgJEhQKDGNhcGFiaWxpdGllcxgFIAMoCRITCgtwaG9uZU51bWJlchgGIAEoCRI6Cg1tYXhFeHBpcmF0aW9uGAcgASgOMiMuQXV0aGVudGljYXRpb24uVHdvRmFjdG9yRXhwaXJhdGlvbhIRCgljcmVhdGVkT24YCCABKAMSOgoNbGFzdEZyZXF1ZW5jeRgJIAEoDjIjLkF1dGhlbnRpY2F0aW9uLlR3b0ZhY3RvckV4cGlyYXRpb24iZAoSVHdvRmFjdG9yRHVvU3RhdHVzEhQKDGNhcGFiaWxpdGllcxgBIAMoCRITCgtwaG9uZU51bWJlchgCIAEoCRISCgplbnJvbGxfdXJsGAMgASgJEg8KB21lc3NhZ2UYBCABKAkixwEKE1R3b0ZhY3RvckFkZFJlcXVlc3QSOQoLY2hhbm5lbFR5cGUYASABKA4yJC5BdXRoZW50aWNhdGlvbi5Ud29GYWN0b3JDaGFubmVsVHlwZRITCgtjaGFubmVsX3VpZBgCIAEoDBITCgtjaGFubmVsTmFtZRgDIAEoCRITCgtwaG9uZU51bWJlchgEIAEoCRI2CgtkdW9QdXNoVHlwZRgFIAEoDjIhLkF1dGhlbnRpY2F0aW9uLlR3b0ZhY3RvclB1c2hUeXBlIkIKFlR3b0ZhY3RvclJlbmFtZVJlcXVlc3QSEwoLY2hhbm5lbF91aWQYASABKAwSEwoLY2hhbm5lbE5hbWUYAiABKAkiPQoUVHdvRmFjdG9yQWRkUmVzcG9uc2USEQoJY2hhbGxlbmdlGAEgASgJEhIKCmJhY2t1cEtleXMYAiADKAkiLQoWVHdvRmFjdG9yRGVsZXRlUmVxdWVzdBITCgtjaGFubmVsX3VpZBgBIAEoDCJhChVUd29GYWN0b3JMaXN0UmVzcG9uc2USNgoIY2hhbm5lbHMYASADKAsyJC5BdXRoZW50aWNhdGlvbi5Ud29GYWN0b3JDaGFubmVsSW5mbxIQCghleHBpcmVPbhgCIAEoAyJZCiBUd29GYWN0b3JVcGRhdGVFeHBpcmF0aW9uUmVxdWVzdBI1CghleHBpcmVJbhgBIAEoDjIjLkF1dGhlbnRpY2F0aW9uLlR3b0ZhY3RvckV4cGlyYXRpb24iyQEKGFR3b0ZhY3RvclZhbGlkYXRlUmVxdWVzdBIbChNlbmNyeXB0ZWRMb2dpblRva2VuGAEgASgMEjUKCXZhbHVlVHlwZRgCIAEoDjIiLkF1dGhlbnRpY2F0aW9uLlR3b0ZhY3RvclZhbHVlVHlwZRINCgV2YWx1ZRgDIAEoCRITCgtjaGFubmVsX3VpZBgEIAEoDBI1CghleHBpcmVJbhgFIAEoDjIjLkF1dGhlbnRpY2F0aW9uLlR3b0ZhY3RvckV4cGlyYXRpb24iOAoZVHdvRmFjdG9yVmFsaWRhdGVSZXNwb25zZRIbChNlbmNyeXB0ZWRMb2dpblRva2VuGAEgASgMIrgBChhUd29GYWN0b3JTZW5kUHVzaFJlcXVlc3QSGwoTZW5jcnlwdGVkTG9naW5Ub2tlbhgBIAEoDBIzCghwdXNoVHlwZRgCIAEoDjIhLkF1dGhlbnRpY2F0aW9uLlR3b0ZhY3RvclB1c2hUeXBlEhMKC2NoYW5uZWxfdWlkGAMgASgMEjUKCGV4cGlyZUluGAQgASgOMiMuQXV0aGVudGljYXRpb24uVHdvRmFjdG9yRXhwaXJhdGlvbiKDAQoHTGljZW5zZRIPCgdjcmVhdGVkGAEgASgDEhIKCmV4cGlyYXRpb24YAiABKAMSNAoNbGljZW5zZVN0YXR1cxgDIAEoDjIdLkF1dGhlbnRpY2F0aW9uLkxpY2Vuc2VTdGF0dXMSDAoEcGFpZBgEIAEoCBIPCgdtZXNzYWdlGAUgASgJIkcKD093bmVybGVzc1JlY29yZBIRCglyZWNvcmRVaWQYASABKAwSEQoJcmVjb3JkS2V5GAIgASgMEg4KBnN0YXR1cxgDIAEoBSJMChBPd25lcmxlc3NSZWNvcmRzEjgKD293bmVybGVzc1JlY29yZBgBIAMoCzIfLkF1dGhlbnRpY2F0aW9uLk93bmVybGVzc1JlY29yZCLXAQoPVXNlckF1dGhSZXF1ZXN0EgsKA3VpZBgBIAEoDBIMCgRzYWx0GAIgASgMEhIKCml0ZXJhdGlvbnMYAyABKAUSGgoSZW5jcnlwdGVkQ2xpZW50S2V5GAQgASgMEhAKCGF1dGhIYXNoGAUgASgMEhgKEGVuY3J5cHRlZERhdGFLZXkYBiABKAwSLAoJbG9naW5UeXBlGAcgASgOMhkuQXV0aGVudGljYXRpb24uTG9naW5UeXBlEgwKBG5hbWUYCCABKAkSEQoJYWxnb3JpdGhtGAkgASgFIhkKClVpZFJlcXVlc3QSCwoDdWlkGAEgAygMIv8BChNEZXZpY2VVcGRhdGVSZXF1ZXN0EhwKFGVuY3J5cHRlZERldmljZVRva2VuGAEgASgMEhUKDWNsaWVudFZlcnNpb24YAiABKAkSEgoKZGV2aWNlTmFtZRgDIAEoCRIXCg9kZXZpY2VQdWJsaWNLZXkYBCABKAwSMgoMZGV2aWNlU3RhdHVzGAUgASgOMhwuQXV0aGVudGljYXRpb24uRGV2aWNlU3RhdHVzEhYKDmRldmljZVBsYXRmb3JtGAYgASgJEjoKEGNsaWVudEZvcm1GYWN0b3IYByABKA4yIC5BdXRoZW50aWNhdGlvbi5DbGllbnRGb3JtRmFjdG9yIoACChREZXZpY2VVcGRhdGVSZXNwb25zZRIcChRlbmNyeXB0ZWREZXZpY2VUb2tlbhgBIAEoDBIVCg1jbGllbnRWZXJzaW9uGAIgASgJEhIKCmRldmljZU5hbWUYAyABKAkSFwoPZGV2aWNlUHVibGljS2V5GAQgASgMEjIKDGRldmljZVN0YXR1cxgFIAEoDjIcLkF1dGhlbnRpY2F0aW9uLkRldmljZVN0YXR1cxIWCg5kZXZpY2VQbGF0Zm9ybRgGIAEoCRI6ChBjbGllbnRGb3JtRmFjdG9yGAcgASgOMiAuQXV0aGVudGljYXRpb24uQ2xpZW50Rm9ybUZhY3RvciLVAQodUmVnaXN0ZXJEZXZpY2VJblJlZ2lvblJlcXVlc3QSHAoUZW5jcnlwdGVkRGV2aWNlVG9rZW4YASABKAwSFQoNY2xpZW50VmVyc2lvbhgCIAEoCRISCgpkZXZpY2VOYW1lGAMgASgJEhcKD2RldmljZVB1YmxpY0tleRgEIAEoDBIWCg5kZXZpY2VQbGF0Zm9ybRgFIAEoCRI6ChBjbGllbnRGb3JtRmFjdG9yGAYgASgOMiAuQXV0aGVudGljYXRpb24uQ2xpZW50Rm9ybUZhY3RvciL4AgoTUmVnaXN0cmF0aW9uUmVxdWVzdBIwCgthdXRoUmVxdWVzdBgBIAEoCzIbLkF1dGhlbnRpY2F0aW9uLkF1dGhSZXF1ZXN0EjgKD3VzZXJBdXRoUmVxdWVzdBgCIAEoCzIfLkF1dGhlbnRpY2F0aW9uLlVzZXJBdXRoUmVxdWVzdBIaChJlbmNyeXB0ZWRDbGllbnRLZXkYAyABKAwSGwoTZW5jcnlwdGVkUHJpdmF0ZUtleRgEIAEoDBIRCglwdWJsaWNLZXkYBSABKAwSGAoQdmVyaWZpY2F0aW9uQ29kZRgGIAEoCRIeChZkZXByZWNhdGVkQXV0aEhhc2hIYXNoGAcgASgMEiQKHGRlcHJlY2F0ZWRFbmNyeXB0ZWRDbGllbnRLZXkYCCABKAwSJQodZGVwcmVjYXRlZEVuY3J5cHRlZFByaXZhdGVLZXkYCSABKAwSIgoaZGVwcmVjYXRlZEVuY3J5cHRpb25QYXJhbXMYCiABKAwi0AEKFkNvbnZlcnRVc2VyVG9WM1JlcXVlc3QSMAoLYXV0aFJlcXVlc3QYASABKAsyGy5BdXRoZW50aWNhdGlvbi5BdXRoUmVxdWVzdBI4Cg91c2VyQXV0aFJlcXVlc3QYAiABKAsyHy5BdXRoZW50aWNhdGlvbi5Vc2VyQXV0aFJlcXVlc3QSGgoSZW5jcnlwdGVkQ2xpZW50S2V5GAMgASgMEhsKE2VuY3J5cHRlZFByaXZhdGVLZXkYBCABKAwSEQoJcHVibGljS2V5GAUgASgMIiQKEFJldmlzaW9uUmVzcG9uc2USEAoIcmV2aXNpb24YASABKAMiJgoSQ2hhbmdlRW1haWxSZXF1ZXN0EhAKCG5ld0VtYWlsGAEgASgJIjgKE0NoYW5nZUVtYWlsUmVzcG9uc2USIQoZZW5jcnlwdGVkQ2hhbmdlRW1haWxUb2tlbhgBIAEoDCI2Ch1FbWFpbFZlcmlmaWNhdGlvbkxpbmtSZXNwb25zZRIVCg1lbWFpbFZlcmlmaWVkGAEgASgIIikKDFNlY3VyaXR5RGF0YRILCgN1aWQYASABKAwSDAoEZGF0YRgCIAEoDCJAChFTZWN1cml0eVNjb3JlRGF0YRILCgN1aWQYASABKAwSDAoEZGF0YRgCIAEoDBIQCghyZXZpc2lvbhgDIAEoAyKLAgoTU2VjdXJpdHlEYXRhUmVxdWVzdBI4ChJyZWNvcmRTZWN1cml0eURhdGEYASADKAsyHC5BdXRoZW50aWNhdGlvbi5TZWN1cml0eURhdGESQAoabWFzdGVyUGFzc3dvcmRTZWN1cml0eURhdGEYAiADKAsyHC5BdXRoZW50aWNhdGlvbi5TZWN1cml0eURhdGESNAoOZW5jcnlwdGlvblR5cGUYAyABKA4yHC5FbnRlcnByaXNlLkVuY3J5cHRlZEtleVR5cGUSQgoXcmVjb3JkU2VjdXJpdHlTY29yZURhdGEYBCADKAsyIS5BdXRoZW50aWNhdGlvbi5TZWN1cml0eVNjb3JlRGF0YSLGAgodU2VjdXJpdHlSZXBvcnRJbmNyZW1lbnRhbERhdGESGAoQZW50ZXJwcmlzZVVzZXJJZBgBIAEoAxIbChNjdXJyZW50U2VjdXJpdHlEYXRhGAIgASgMEiMKG2N1cnJlbnRTZWN1cml0eURhdGFSZXZpc2lvbhgDIAEoAxIXCg9vbGRTZWN1cml0eURhdGEYBCABKAwSHwoXb2xkU2VjdXJpdHlEYXRhUmV2aXNpb24YBSABKAMSPwoZY3VycmVudERhdGFFbmNyeXB0aW9uVHlwZRgGIAEoDjIcLkVudGVycHJpc2UuRW5jcnlwdGVkS2V5VHlwZRI7ChVvbGREYXRhRW5jcnlwdGlvblR5cGUYByABKA4yHC5FbnRlcnByaXNlLkVuY3J5cHRlZEtleVR5cGUSEQoJcmVjb3JkVWlkGAggASgMIp8CCg5TZWN1cml0eVJlcG9ydBIYChBlbnRlcnByaXNlVXNlcklkGAEgASgDEhsKE2VuY3J5cHRlZFJlcG9ydERhdGEYAiABKAwSEAoIcmV2aXNpb24YAyABKAMSEQoJdHdvRmFjdG9yGAQgASgJEhEKCWxhc3RMb2dpbhgFIAEoAxIeChZudW1iZXJPZlJldXNlZFBhc3N3b3JkGAYgASgFElQKHXNlY3VyaXR5UmVwb3J0SW5jcmVtZW50YWxEYXRhGAcgAygLMi0uQXV0aGVudGljYXRpb24uU2VjdXJpdHlSZXBvcnRJbmNyZW1lbnRhbERhdGESDgoGdXNlcklkGAggASgFEhgKEGhhc09sZEVuY3J5cHRpb24YCSABKAgibgoZU2VjdXJpdHlSZXBvcnRTYXZlUmVxdWVzdBI2Cg5zZWN1cml0eVJlcG9ydBgBIAMoCzIeLkF1dGhlbnRpY2F0aW9uLlNlY3VyaXR5UmVwb3J0EhkKEWNvbnRpbnVhdGlvblRva2VuGAIgASgMIikKFVNlY3VyaXR5UmVwb3J0UmVxdWVzdBIQCghmcm9tUGFnZRgBIAEoAyL1AQoWU2VjdXJpdHlSZXBvcnRSZXNwb25zZRIcChRlbnRlcnByaXNlUHJpdmF0ZUtleRgBIAEoDBI2Cg5zZWN1cml0eVJlcG9ydBgCIAMoCzIeLkF1dGhlbnRpY2F0aW9uLlNlY3VyaXR5UmVwb3J0EhQKDGFzT2ZSZXZpc2lvbhgDIAEoAxIQCghmcm9tUGFnZRgEIAEoAxIOCgZ0b1BhZ2UYBSABKAMSEAoIY29tcGxldGUYBiABKAgSHwoXZW50ZXJwcmlzZUVjY1ByaXZhdGVLZXkYByABKAwSGgoSaGFzSW5jcmVtZW50YWxEYXRhGAggASgIIjsKHkluY3JlbWVudGFsU2VjdXJpdHlEYXRhUmVxdWVzdBIZChFjb250aW51YXRpb25Ub2tlbhgBIAEoDCKSAQofSW5jcmVtZW50YWxTZWN1cml0eURhdGFSZXNwb25zZRJUCh1zZWN1cml0eVJlcG9ydEluY3JlbWVudGFsRGF0YRgBIAMoCzItLkF1dGhlbnRpY2F0aW9uLlNlY3VyaXR5UmVwb3J0SW5jcmVtZW50YWxEYXRhEhkKEWNvbnRpbnVhdGlvblRva2VuGAIgASgMIicKFlJldXNlZFBhc3N3b3Jkc1JlcXVlc3QSDQoFY291bnQYASABKAUiPgoUU3VtbWFyeUNvbnNvbGVSZXBvcnQSEgoKcmVwb3J0VHlwZRgBIAEoBRISCgpyZXBvcnREYXRhGAIgASgMInwKEkNoYW5nZVRvS2V5VHlwZU9uZRIvCgpvYmplY3RUeXBlGAEgASgOMhsuQXV0aGVudGljYXRpb24uT2JqZWN0VHlwZXMSEgoKcHJpbWFyeVVpZBgCIAEoDBIUCgxzZWNvbmRhcnlVaWQYAyABKAwSCwoDa2V5GAQgASgMIlsKGUNoYW5nZVRvS2V5VHlwZU9uZVJlcXVlc3QSPgoSY2hhbmdlVG9LZXlUeXBlT25lGAEgAygLMiIuQXV0aGVudGljYXRpb24uQ2hhbmdlVG9LZXlUeXBlT25lIlUKGENoYW5nZVRvS2V5VHlwZU9uZVN0YXR1cxILCgN1aWQYASABKAwSDAoEdHlwZRgCIAEoCRIOCgZzdGF0dXMYAyABKAkSDgoGcmVhc29uGAQgASgJImgKGkNoYW5nZVRvS2V5VHlwZU9uZVJlc3BvbnNlEkoKGGNoYW5nZVRvS2V5VHlwZU9uZVN0YXR1cxgBIAMoCzIoLkF1dGhlbnRpY2F0aW9uLkNoYW5nZVRvS2V5VHlwZU9uZVN0YXR1cyK5AQoYR2V0Q2hhbmdlS2V5VHlwZXNSZXF1ZXN0Ej0KEG9ubHlUaGVzZU9iamVjdHMYASADKA4yIy5BdXRoZW50aWNhdGlvbi5FbmNyeXB0ZWRPYmplY3RUeXBlEg0KBWxpbWl0GAIgASgFEhoKEmluY2x1ZGVSZWNvbW1lbmRlZBgDIAEoCBITCgtpbmNsdWRlS2V5cxgEIAEoCBIeChZpbmNsdWRlQWxsb3dlZEtleVR5cGVzGAUgASgIIoIBChlHZXRDaGFuZ2VLZXlUeXBlc1Jlc3BvbnNlEisKBGtleXMYASADKAsyHS5BdXRoZW50aWNhdGlvbi5DaGFuZ2VLZXlUeXBlEjgKD2FsbG93ZWRLZXlUeXBlcxgCIAMoCzIfLkF1dGhlbnRpY2F0aW9uLkFsbG93ZWRLZXlUeXBlcyKBAQoPQWxsb3dlZEtleVR5cGVzEjcKCm9iamVjdFR5cGUYASABKA4yIy5BdXRoZW50aWNhdGlvbi5FbmNyeXB0ZWRPYmplY3RUeXBlEjUKD2FsbG93ZWRLZXlUeXBlcxgCIAMoDjIcLkVudGVycHJpc2UuRW5jcnlwdGVkS2V5VHlwZSI9Cg5DaGFuZ2VLZXlUeXBlcxIrCgRrZXlzGAEgAygLMh0uQXV0aGVudGljYXRpb24uQ2hhbmdlS2V5VHlwZSLWAQoNQ2hhbmdlS2V5VHlwZRI3CgpvYmplY3RUeXBlGAEgASgOMiMuQXV0aGVudGljYXRpb24uRW5jcnlwdGVkT2JqZWN0VHlwZRILCgN1aWQYAiABKAwSFAoMc2Vjb25kYXJ5VWlkGAMgASgMEgsKA2tleRgEIAEoDBItCgdrZXlUeXBlGAUgASgOMhwuRW50ZXJwcmlzZS5FbmNyeXB0ZWRLZXlUeXBlEi0KBnN0YXR1cxgGIAEoDjIdLkF1dGhlbnRpY2F0aW9uLkdlbmVyaWNTdGF0dXMiIQoGU2V0S2V5EgoKAmlkGAEgASgDEgsKA2tleRgCIAEoDCI1Cg1TZXRLZXlSZXF1ZXN0EiQKBGtleXMYASADKAsyFi5BdXRoZW50aWNhdGlvbi5TZXRLZXkikgUKEUNyZWF0ZVVzZXJSZXF1ZXN0EhAKCHVzZXJuYW1lGAEgASgJEhQKDGF1dGhWZXJpZmllchgCIAEoDBIYChBlbmNyeXB0aW9uUGFyYW1zGAMgASgMEhQKDHJzYVB1YmxpY0tleRgEIAEoDBIeChZyc2FFbmNyeXB0ZWRQcml2YXRlS2V5GAUgASgMEhQKDGVjY1B1YmxpY0tleRgGIAEoDBIeChZlY2NFbmNyeXB0ZWRQcml2YXRlS2V5GAcgASgMEhwKFGVuY3J5cHRlZERldmljZVRva2VuGAggASgMEhoKEmVuY3J5cHRlZENsaWVudEtleRgJIAEoDBIVCg1jbGllbnRWZXJzaW9uGAogASgJEh4KFmVuY3J5cHRlZERldmljZURhdGFLZXkYCyABKAwSGwoTZW5jcnlwdGVkTG9naW5Ub2tlbhgMIAEoDBIZChFtZXNzYWdlU2Vzc2lvblVpZBgNIAEoDBIXCg9pbnN0YWxsUmVmZXJyZXIYDiABKAkSDgoGbWNjTU5DGA8gASgFEgsKA21mZxgQIAEoCRINCgVtb2RlbBgRIAEoCRINCgVicmFuZBgSIAEoCRIPCgdwcm9kdWN0GBMgASgJEg4KBmRldmljZRgUIAEoCRIPCgdjYXJyaWVyGBUgASgJEhgKEHZlcmlmaWNhdGlvbkNvZGUYFiABKAkSQgoWZW50ZXJwcmlzZVJlZ2lzdHJhdGlvbhgXIAEoCzIiLkVudGVycHJpc2UuRW50ZXJwcmlzZVJlZ2lzdHJhdGlvbhIiChplbmNyeXB0ZWRWZXJpZmljYXRpb25Ub2tlbhgYIAEoDBIeChZlbnRlcnByaXNlVXNlcnNEYXRhS2V5GBkgASgMIlcKIU5vZGVFbmZvcmNlbWVudEFkZE9yVXBkYXRlUmVxdWVzdBIOCgZub2RlSWQYASABKAMSEwoLZW5mb3JjZW1lbnQYAiABKAkSDQoFdmFsdWUYAyABKAkiQwocTm9kZUVuZm9yY2VtZW50UmVtb3ZlUmVxdWVzdBIOCgZub2RlSWQYASABKAMSEwoLZW5mb3JjZW1lbnQYAiABKAkinwEKD0FwaVJlcXVlc3RCeUtleRINCgVrZXlJZBgBIAEoBRIPCgdwYXlsb2FkGAIgASgMEhAKCHVzZXJuYW1lGAMgASgJEg4KBmxvY2FsZRgEIAEoCRI8ChFzdXBwb3J0ZWRMYW5ndWFnZRgFIAEoDjIhLkF1dGhlbnRpY2F0aW9uLlN1cHBvcnRlZExhbmd1YWdlEgwKBHR5cGUYBiABKAUixwEKFUFwaVJlcXVlc3RCeUtBdG9LQUtleRIsCgxzb3VyY2VSZWdpb24YASABKA4yFi5BdXRoZW50aWNhdGlvbi5SZWdpb24SDwoHcGF5bG9hZBgCIAEoDBI8ChFzdXBwb3J0ZWRMYW5ndWFnZRgDIAEoDjIhLkF1dGhlbnRpY2F0aW9uLlN1cHBvcnRlZExhbmd1YWdlEjEKEWRlc3RpbmF0aW9uUmVnaW9uGAQgASgOMhYuQXV0aGVudGljYXRpb24uUmVnaW9uIi4KD01lbWNhY2hlUmVxdWVzdBILCgNrZXkYASABKAkSDgoGdXNlcklkGAIgASgFIi4KEE1lbWNhY2hlUmVzcG9uc2USCwoDa2V5GAEgASgJEg0KBXZhbHVlGAIgASgJIncKHE1hc3RlclBhc3N3b3JkUmVlbnRyeVJlcXVlc3QSFgoOcGJrZGYyUGFzc3dvcmQYASABKAkSPwoGYWN0aW9uGAIgASgOMi8uQXV0aGVudGljYXRpb24uTWFzdGVyUGFzc3dvcmRSZWVudHJ5QWN0aW9uVHlwZSJcCh1NYXN0ZXJQYXNzd29yZFJlZW50cnlSZXNwb25zZRI7CgZzdGF0dXMYASABKA4yKy5BdXRoZW50aWNhdGlvbi5NYXN0ZXJQYXNzd29yZFJlZW50cnlTdGF0dXMiswEKGURldmljZVJlZ2lzdHJhdGlvblJlcXVlc3QSFQoNY2xpZW50VmVyc2lvbhgBIAEoCRISCgpkZXZpY2VOYW1lGAIgASgJEhcKD2RldmljZVB1YmxpY0tleRgDIAEoDBIWCg5kZXZpY2VQbGF0Zm9ybRgEIAEoCRI6ChBjbGllbnRGb3JtRmFjdG9yGAUgASgOMiAuQXV0aGVudGljYXRpb24uQ2xpZW50Rm9ybUZhY3RvciKaAQoZRGV2aWNlVmVyaWZpY2F0aW9uUmVxdWVzdBIcChRlbmNyeXB0ZWREZXZpY2VUb2tlbhgBIAEoDBIQCgh1c2VybmFtZRgCIAEoCRIbChN2ZXJpZmljYXRpb25DaGFubmVsGAMgASgJEhkKEW1lc3NhZ2VTZXNzaW9uVWlkGAQgASgMEhUKDWNsaWVudFZlcnNpb24YBSABKAkisgEKGkRldmljZVZlcmlmaWNhdGlvblJlc3BvbnNlEhwKFGVuY3J5cHRlZERldmljZVRva2VuGAEgASgMEhAKCHVzZXJuYW1lGAIgASgJEhkKEW1lc3NhZ2VTZXNzaW9uVWlkGAMgASgMEhUKDWNsaWVudFZlcnNpb24YBCABKAkSMgoMZGV2aWNlU3RhdHVzGAUgASgOMhwuQXV0aGVudGljYXRpb24uRGV2aWNlU3RhdHVzIsgBChVEZXZpY2VBcHByb3ZhbFJlcXVlc3QSDQoFZW1haWwYASABKAkSGAoQdHdvRmFjdG9yQ2hhbm5lbBgCIAEoCRIVCg1jbGllbnRWZXJzaW9uGAMgASgJEg4KBmxvY2FsZRgEIAEoCRIcChRlbmNyeXB0ZWREZXZpY2VUb2tlbhgFIAEoDBIQCgh0b3RwQ29kZRgGIAEoCRIQCghkZXZpY2VJcBgHIAEoCRIdChVkZXZpY2VUb2tlbkV4cGlyZURheXMYCCABKAkiOQoWRGV2aWNlQXBwcm92YWxSZXNwb25zZRIfChdlbmNyeXB0ZWRUd29GYWN0b3JUb2tlbhgBIAEoDCJ+ChRBcHByb3ZlRGV2aWNlUmVxdWVzdBIcChRlbmNyeXB0ZWREZXZpY2VUb2tlbhgBIAEoDBIeChZlbmNyeXB0ZWREZXZpY2VEYXRhS2V5GAIgASgMEhQKDGRlbnlBcHByb3ZhbBgDIAEoCBISCgpsaW5rRGV2aWNlGAQgASgIIkUKGkVudGVycHJpc2VVc2VyQWxpYXNSZXF1ZXN0EhgKEGVudGVycHJpc2VVc2VySWQYASABKAMSDQoFYWxpYXMYAiABKAkiWQodRW50ZXJwcmlzZVVzZXJBZGRBbGlhc1JlcXVlc3QSGAoQZW50ZXJwcmlzZVVzZXJJZBgBIAEoAxINCgVhbGlhcxgCIAEoCRIPCgdwcmltYXJ5GAMgASgIIncKH0VudGVycHJpc2VVc2VyQWRkQWxpYXNSZXF1ZXN0VjISVAodZW50ZXJwcmlzZVVzZXJBZGRBbGlhc1JlcXVlc3QYASADKAsyLS5BdXRoZW50aWNhdGlvbi5FbnRlcnByaXNlVXNlckFkZEFsaWFzUmVxdWVzdCJIChxFbnRlcnByaXNlVXNlckFkZEFsaWFzU3RhdHVzEhgKEGVudGVycHJpc2VVc2VySWQYASABKAMSDgoGc3RhdHVzGAIgASgJIl4KHkVudGVycHJpc2VVc2VyQWRkQWxpYXNSZXNwb25zZRI8CgZzdGF0dXMYASADKAsyLC5BdXRoZW50aWNhdGlvbi5FbnRlcnByaXNlVXNlckFkZEFsaWFzU3RhdHVzIiYKBkRldmljZRIcChRlbmNyeXB0ZWREZXZpY2VUb2tlbhgBIAEoDCJcChxSZWdpc3RlckRldmljZURhdGFLZXlSZXF1ZXN0EhwKFGVuY3J5cHRlZERldmljZVRva2VuGAEgASgMEh4KFmVuY3J5cHRlZERldmljZURhdGFLZXkYAiABKAwibgopVmFsaWRhdGVDcmVhdGVVc2VyVmVyaWZpY2F0aW9uQ29kZVJlcXVlc3QSEAoIdXNlcm5hbWUYASABKAkSFQoNY2xpZW50VmVyc2lvbhgCIAEoCRIYChB2ZXJpZmljYXRpb25Db2RlGAMgASgJIqMBCiVWYWxpZGF0ZURldmljZVZlcmlmaWNhdGlvbkNvZGVSZXF1ZXN0EhAKCHVzZXJuYW1lGAEgASgJEhUKDWNsaWVudFZlcnNpb24YAiABKAkSGAoQdmVyaWZpY2F0aW9uQ29kZRgDIAEoCRIZChFtZXNzYWdlU2Vzc2lvblVpZBgEIAEoDBIcChRlbmNyeXB0ZWREZXZpY2VUb2tlbhgFIAEoDCJZChlTZW5kU2Vzc2lvbk1lc3NhZ2VSZXF1ZXN0EhkKEW1lc3NhZ2VTZXNzaW9uVWlkGAEgASgMEg8KB2NvbW1hbmQYAiABKAkSEAoIdXNlcm5hbWUYAyABKAkiTQoRR2xvYmFsVXNlckFjY291bnQSEAoIdXNlcm5hbWUYASABKAkSEgoKYWNjb3VudFVpZBgCIAEoDBISCgpyZWdpb25OYW1lGAMgASgJIjcKD0FjY291bnRVc2VybmFtZRIQCgh1c2VybmFtZRgBIAEoCRISCgpkYXRlQWN0aXZlGAIgASgJIlAKGVNzb1NlcnZpY2VQcm92aWRlclJlcXVlc3QSDAoEbmFtZRgBIAEoCRIVCg1jbGllbnRWZXJzaW9uGAIgASgJEg4KBmxvY2FsZRgDIAEoCSJhChpTc29TZXJ2aWNlUHJvdmlkZXJSZXNwb25zZRIMCgRuYW1lGAEgASgJEg0KBXNwVXJsGAIgASgJEg8KB2lzQ2xvdWQYAyABKAgSFQoNY2xpZW50VmVyc2lvbhgEIAEoCSI0ChJVc2VyU2V0dGluZ1JlcXVlc3QSDwoHc2V0dGluZxgBIAEoCRINCgV2YWx1ZRgCIAEoCSJmCg1UaHJvdHRsZVN0YXRlEioKBHR5cGUYASABKA4yHC5BdXRoZW50aWNhdGlvbi5UaHJvdHRsZVR5cGUSCwoDa2V5GAIgASgJEg0KBXZhbHVlGAMgASgJEg0KBXN0YXRlGAQgASgIIrUBCg5UaHJvdHRsZVN0YXRlMhILCgNrZXkYASABKAkSFgoOa2V5RGVzY3JpcHRpb24YAiABKAkSDQoFdmFsdWUYAyABKAkSGAoQdmFsdWVEZXNjcmlwdGlvbhgEIAEoCRISCgppZGVudGlmaWVyGAUgASgJEg4KBmxvY2tlZBgGIAEoCBIaChJpbmNsdWRlZEluQWxsQ2xlYXIYByABKAgSFQoNZXhwaXJlU2Vjb25kcxgIIAEoBSKXAQoRRGV2aWNlSW5mb3JtYXRpb24SEAoIZGV2aWNlSWQYASABKAMSEgoKZGV2aWNlTmFtZRgCIAEoCRIVCg1jbGllbnRWZXJzaW9uGAMgASgJEhEKCWxhc3RMb2dpbhgEIAEoAxIyCgxkZXZpY2VTdGF0dXMYBSABKA4yHC5BdXRoZW50aWNhdGlvbi5EZXZpY2VTdGF0dXMiKgoLVXNlclNldHRpbmcSDAoEbmFtZRgBIAEoCRINCgV2YWx1ZRgCIAEoCCIuChJVc2VyRGF0YUtleVJlcXVlc3QSGAoQZW50ZXJwcmlzZVVzZXJJZBgBIAMoAyIrChhVc2VyRGF0YUtleUJ5Tm9kZVJlcXVlc3QSDwoHbm9kZUlkcxgBIAMoAyKAAQobRW50ZXJwcmlzZVVzZXJJZERhdGFLZXlQYWlyEhgKEGVudGVycHJpc2VVc2VySWQYASABKAMSGAoQZW5jcnlwdGVkRGF0YUtleRgCIAEoDBItCgdrZXlUeXBlGAMgASgOMhwuRW50ZXJwcmlzZS5FbmNyeXB0ZWRLZXlUeXBlIpUBCgtVc2VyRGF0YUtleRIOCgZyb2xlSWQYASABKAMSDwoHcm9sZUtleRgCIAEoDBISCgpwcml2YXRlS2V5GAMgASgJElEKHGVudGVycHJpc2VVc2VySWREYXRhS2V5UGFpcnMYBCADKAsyKy5BdXRoZW50aWNhdGlvbi5FbnRlcnByaXNlVXNlcklkRGF0YUtleVBhaXIiegoTVXNlckRhdGFLZXlSZXNwb25zZRIxCgx1c2VyRGF0YUtleXMYASADKAsyGy5BdXRoZW50aWNhdGlvbi5Vc2VyRGF0YUtleRIUCgxhY2Nlc3NEZW5pZWQYAiADKAMSGgoSbm9FbmNyeXB0ZWREYXRhS2V5GAMgAygDIkgKKU1hc3RlclBhc3N3b3JkUmVjb3ZlcnlWZXJpZmljYXRpb25SZXF1ZXN0EhsKE2VuY3J5cHRlZExvZ2luVG9rZW4YASABKAwiVQocR2V0U2VjdXJpdHlRdWVzdGlvblYzUmVxdWVzdBIbChNlbmNyeXB0ZWRMb2dpblRva2VuGAEgASgMEhgKEHZlcmlmaWNhdGlvbkNvZGUYAiABKAkicgodR2V0U2VjdXJpdHlRdWVzdGlvblYzUmVzcG9uc2USGAoQc2VjdXJpdHlRdWVzdGlvbhgBIAEoCRIVCg1iYWNrdXBLZXlEYXRlGAIgASgDEgwKBHNhbHQYAyABKAwSEgoKaXRlcmF0aW9ucxgEIAEoBSJuChlHZXREYXRhS2V5QmFja3VwVjNSZXF1ZXN0EhsKE2VuY3J5cHRlZExvZ2luVG9rZW4YASABKAwSGAoQdmVyaWZpY2F0aW9uQ29kZRgCIAEoCRIaChJzZWN1cml0eUFuc3dlckhhc2gYAyABKAwidgoNUGFzc3dvcmRSdWxlcxIQCghydWxlVHlwZRgBIAEoCRINCgVtYXRjaBgCIAEoCBIPCgdwYXR0ZXJuGAMgASgJEhMKC2Rlc2NyaXB0aW9uGAQgASgJEg8KB21pbmltdW0YBSABKAUSDQoFdmFsdWUYBiABKAkiyQIKGkdldERhdGFLZXlCYWNrdXBWM1Jlc3BvbnNlEhUKDWRhdGFLZXlCYWNrdXAYASABKAwSGQoRZGF0YUtleUJhY2t1cERhdGUYAiABKAMSEQoJcHVibGljS2V5GAMgASgMEhsKE2VuY3J5cHRlZFByaXZhdGVLZXkYBCABKAwSEQoJY2xpZW50S2V5GAUgASgMEh0KFWVuY3J5cHRlZFNlc3Npb25Ub2tlbhgGIAEoDBI0Cg1wYXNzd29yZFJ1bGVzGAcgAygLMh0uQXV0aGVudGljYXRpb24uUGFzc3dvcmRSdWxlcxIaChJwYXNzd29yZFJ1bGVzSW50cm8YCCABKAkSHwoXbWluaW11bVBia2RmMkl0ZXJhdGlvbnMYCSABKAUSJAoHa2V5VHlwZRgKIAEoDjITLkVudGVycHJpc2UuS2V5VHlwZSIpChRHZXRQdWJsaWNLZXlzUmVxdWVzdBIRCgl1c2VybmFtZXMYASADKAkicgoRUHVibGljS2V5UmVzcG9uc2USEAoIdXNlcm5hbWUYASABKAkSEQoJcHVibGljS2V5GAIgASgMEhQKDHB1YmxpY0VjY0tleRgDIAEoDBIPCgdtZXNzYWdlGAQgASgJEhEKCWVycm9yQ29kZRgFIAEoCSJQChVHZXRQdWJsaWNLZXlzUmVzcG9uc2USNwoMa2V5UmVzcG9uc2VzGAEgAygLMiEuQXV0aGVudGljYXRpb24uUHVibGljS2V5UmVzcG9uc2UiRgoUU2V0RWNjS2V5UGFpclJlcXVlc3QSEQoJcHVibGljS2V5GAEgASgMEhsKE2VuY3J5cHRlZFByaXZhdGVLZXkYAiABKAwiSQoVU2V0RWNjS2V5UGFpcnNSZXF1ZXN0EjAKCHRlYW1LZXlzGAEgAygLMh4uQXV0aGVudGljYXRpb24uVGVhbUVjY0tleVBhaXIiUgoWU2V0RWNjS2V5UGFpcnNSZXNwb25zZRI4Cgh0ZWFtS2V5cxgBIAMoCzImLkF1dGhlbnRpY2F0aW9uLlRlYW1FY2NLZXlQYWlyUmVzcG9uc2UiUQoOVGVhbUVjY0tleVBhaXISDwoHdGVhbVVpZBgBIAEoDBIRCglwdWJsaWNLZXkYAiABKAwSGwoTZW5jcnlwdGVkUHJpdmF0ZUtleRgDIAEoDCJYChZUZWFtRWNjS2V5UGFpclJlc3BvbnNlEg8KB3RlYW1VaWQYASABKAwSLQoGc3RhdHVzGAIgASgOMh0uQXV0aGVudGljYXRpb24uR2VuZXJpY1N0YXR1cyJEChdHZXRLc21QdWJsaWNLZXlzUmVxdWVzdBIRCgljbGllbnRJZHMYASADKAwSFgoOY29udHJvbGxlclVpZHMYAiADKAwiVQoXRGV2aWNlUHVibGljS2V5UmVzcG9uc2USEAoIY2xpZW50SWQYASABKAwSEQoJcHVibGljS2V5GAIgASgMEhUKDWNvbnRyb2xsZXJVaWQYAyABKAwiWQoYR2V0S3NtUHVibGljS2V5c1Jlc3BvbnNlEj0KDGtleVJlc3BvbnNlcxgBIAMoCzInLkF1dGhlbnRpY2F0aW9uLkRldmljZVB1YmxpY0tleVJlc3BvbnNlIlgKE0FkZEFwcFNoYXJlc1JlcXVlc3QSFAoMYXBwUmVjb3JkVWlkGAEgASgMEisKBnNoYXJlcxgCIAMoCzIbLkF1dGhlbnRpY2F0aW9uLkFwcFNoYXJlQWRkIj4KFlJlbW92ZUFwcFNoYXJlc1JlcXVlc3QSFAoMYXBwUmVjb3JkVWlkGAEgASgMEg4KBnNoYXJlcxgCIAMoDCKHAQoLQXBwU2hhcmVBZGQSEQoJc2VjcmV0VWlkGAIgASgMEjcKCXNoYXJlVHlwZRgDIAEoDjIkLkF1dGhlbnRpY2F0aW9uLkFwcGxpY2F0aW9uU2hhcmVUeXBlEhoKEmVuY3J5cHRlZFNlY3JldEtleRgEIAEoDBIQCghlZGl0YWJsZRgFIAEoCCKJAQoIQXBwU2hhcmUSEQoJc2VjcmV0VWlkGAEgASgMEjcKCXNoYXJlVHlwZRgCIAEoDjIkLkF1dGhlbnRpY2F0aW9uLkFwcGxpY2F0aW9uU2hhcmVUeXBlEhAKCGVkaXRhYmxlGAMgASgIEhEKCWNyZWF0ZWRPbhgEIAEoAxIMCgRkYXRhGAUgASgMItkBChNBZGRBcHBDbGllbnRSZXF1ZXN0EhQKDGFwcFJlY29yZFVpZBgBIAEoDBIXCg9lbmNyeXB0ZWRBcHBLZXkYAiABKAwSEAoIY2xpZW50SWQYAyABKAwSDgoGbG9ja0lwGAQgASgIEhsKE2ZpcnN0QWNjZXNzRXhwaXJlT24YBSABKAMSFgoOYWNjZXNzRXhwaXJlT24YBiABKAMSCgoCaWQYByABKAkSMAoNYXBwQ2xpZW50VHlwZRgIIAEoDjIZLkVudGVycHJpc2UuQXBwQ2xpZW50VHlwZSJAChdSZW1vdmVBcHBDbGllbnRzUmVxdWVzdBIUCgxhcHBSZWNvcmRVaWQYASABKAwSDwoHY2xpZW50cxgCIAMoDCKqAQoXQWRkRXh0ZXJuYWxTaGFyZVJlcXVlc3QSEQoJcmVjb3JkVWlkGAEgASgMEhoKEmVuY3J5cHRlZFJlY29yZEtleRgCIAEoDBIQCghjbGllbnRJZBgDIAEoDBIWCg5hY2Nlc3NFeHBpcmVPbhgEIAEoAxIKCgJpZBgFIAEoCRIWCg5pc1NlbGZEZXN0cnVjdBgGIAEoCBISCgppc0VkaXRhYmxlGAcgASgIIpMCCglBcHBDbGllbnQSCgoCaWQYASABKAkSEAoIY2xpZW50SWQYAiABKAwSEQoJY3JlYXRlZE9uGAMgASgDEhMKC2ZpcnN0QWNjZXNzGAQgASgDEhIKCmxhc3RBY2Nlc3MYBSABKAMSEQoJcHVibGljS2V5GAYgASgMEg4KBmxvY2tJcBgHIAEoCBIRCglpcEFkZHJlc3MYCCABKAkSGwoTZmlyc3RBY2Nlc3NFeHBpcmVPbhgJIAEoAxIWCg5hY2Nlc3NFeHBpcmVPbhgKIAEoAxIwCg1hcHBDbGllbnRUeXBlGAsgASgOMhkuRW50ZXJwcmlzZS5BcHBDbGllbnRUeXBlEg8KB2NhbkVkaXQYDCABKAgiKQoRR2V0QXBwSW5mb1JlcXVlc3QSFAoMYXBwUmVjb3JkVWlkGAEgAygMIo4BCgdBcHBJbmZvEhQKDGFwcFJlY29yZFVpZBgBIAEoDBIoCgZzaGFyZXMYAiADKAsyGC5BdXRoZW50aWNhdGlvbi5BcHBTaGFyZRIqCgdjbGllbnRzGAMgAygLMhkuQXV0aGVudGljYXRpb24uQXBwQ2xpZW50EhcKD2lzRXh0ZXJuYWxTaGFyZRgEIAEoCCI+ChJHZXRBcHBJbmZvUmVzcG9uc2USKAoHYXBwSW5mbxgBIAMoCzIXLkF1dGhlbnRpY2F0aW9uLkFwcEluZm8i1QEKEkFwcGxpY2F0aW9uU3VtbWFyeRIUCgxhcHBSZWNvcmRVaWQYASABKAwSEgoKbGFzdEFjY2VzcxgCIAEoAxIUCgxyZWNvcmRTaGFyZXMYAyABKAUSFAoMZm9sZGVyU2hhcmVzGAQgASgFEhUKDWZvbGRlclJlY29yZHMYBSABKAUSEwoLY2xpZW50Q291bnQYBiABKAUSGgoSZXhwaXJlZENsaWVudENvdW50GAcgASgFEhAKCHVzZXJuYW1lGAggASgJEg8KB2FwcERhdGEYCSABKAwiYAoeR2V0QXBwbGljYXRpb25zU3VtbWFyeVJlc3BvbnNlEj4KEmFwcGxpY2F0aW9uU3VtbWFyeRgBIAMoCzIiLkF1dGhlbnRpY2F0aW9uLkFwcGxpY2F0aW9uU3VtbWFyeSIvChtHZXRWZXJpZmljYXRpb25Ub2tlblJlcXVlc3QSEAoIdXNlcm5hbWUYASABKAkiQgocR2V0VmVyaWZpY2F0aW9uVG9rZW5SZXNwb25zZRIiChplbmNyeXB0ZWRWZXJpZmljYXRpb25Ub2tlbhgBIAEoDCInChZTZW5kU2hhcmVJbnZpdGVSZXF1ZXN0Eg0KBWVtYWlsGAEgASgJIsUBChhUaW1lTGltaXRlZEFjY2Vzc1JlcXVlc3QSEgoKYWNjb3VudFVpZBgBIAMoDBIPCgd0ZWFtVWlkGAIgAygMEhEKCXJlY29yZFVpZBgDIAMoDBIXCg9zaGFyZWRPYmplY3RVaWQYBCABKAwSRAoVdGltZUxpbWl0ZWRBY2Nlc3NUeXBlGAUgASgOMiUuQXV0aGVudGljYXRpb24uVGltZUxpbWl0ZWRBY2Nlc3NUeXBlEhIKCmV4cGlyYXRpb24YBiABKAMiNwoXVGltZUxpbWl0ZWRBY2Nlc3NTdGF0dXMSCwoDdWlkGAEgASgMEg8KB21lc3NhZ2UYAiABKAki+AEKGVRpbWVMaW1pdGVkQWNjZXNzUmVzcG9uc2USEAoIcmV2aXNpb24YASABKAMSQQoQdXNlckFjY2Vzc1N0YXR1cxgCIAMoCzInLkF1dGhlbnRpY2F0aW9uLlRpbWVMaW1pdGVkQWNjZXNzU3RhdHVzEkEKEHRlYW1BY2Nlc3NTdGF0dXMYAyADKAsyJy5BdXRoZW50aWNhdGlvbi5UaW1lTGltaXRlZEFjY2Vzc1N0YXR1cxJDChJyZWNvcmRBY2Nlc3NTdGF0dXMYBCADKAsyJy5BdXRoZW50aWNhdGlvbi5UaW1lTGltaXRlZEFjY2Vzc1N0YXR1cyIrChZSZXF1ZXN0RG93bmxvYWRSZXF1ZXN0EhEKCWZpbGVOYW1lcxgBIAMoCSJnChdSZXF1ZXN0RG93bmxvYWRSZXNwb25zZRIOCgZyZXN1bHQYASABKAkSDwoHbWVzc2FnZRgCIAEoCRIrCglkb3dubG9hZHMYAyADKAsyGC5BdXRoZW50aWNhdGlvbi5Eb3dubG9hZCJECghEb3dubG9hZBIQCghmaWxlTmFtZRgBIAEoCRILCgN1cmwYAiABKAkSGQoRc3VjY2Vzc1N0YXR1c0NvZGUYAyABKAUiIwoRRGVsZXRlVXNlclJlcXVlc3QSDgoGcmVhc29uGAEgASgJIoQBChtDaGFuZ2VNYXN0ZXJQYXNzd29yZFJlcXVlc3QSFAoMYXV0aFZlcmlmaWVyGAEgASgMEhgKEGVuY3J5cHRpb25QYXJhbXMYAiABKAwSGwoTZnJvbVNlcnZpY2VQcm92aWRlchgDIAEoCBIYChBpdGVyYXRpb25zQ2hhbmdlGAQgASgIIj0KHENoYW5nZU1hc3RlclBhc3N3b3JkUmVzcG9uc2USHQoVZW5jcnlwdGVkU2Vzc2lvblRva2VuGAEgASgMIlkKG0FjY291bnRSZWNvdmVyeVNldHVwUmVxdWVzdBIgChhyZWNvdmVyeUVuY3J5cHRlZERhdGFLZXkYASABKAwSGAoQcmVjb3ZlcnlBdXRoSGFzaBgCIAEoDCKsAQohQWNjb3VudFJlY292ZXJ5VmVyaWZ5Q29kZVJlc3BvbnNlEjQKDWJhY2t1cEtleVR5cGUYASABKA4yHS5BdXRoZW50aWNhdGlvbi5CYWNrdXBLZXlUeXBlEhUKDWJhY2t1cEtleURhdGUYAiABKAMSGAoQc2VjdXJpdHlRdWVzdGlvbhgDIAEoCRIMCgRzYWx0GAQgASgMEhIKCml0ZXJhdGlvbnMYBSABKAUiLAobRW1lcmdlbmN5QWNjZXNzTG9naW5SZXF1ZXN0Eg0KBW93bmVyGAEgASgJIrUBChxFbWVyZ2VuY3lBY2Nlc3NMb2dpblJlc3BvbnNlEhQKDHNlc3Npb25Ub2tlbhgBIAEoDBIlCgdkYXRhS2V5GAIgASgLMhQuRW50ZXJwcmlzZS5UeXBlZEtleRIrCg1yc2FQcml2YXRlS2V5GAMgASgLMhQuRW50ZXJwcmlzZS5UeXBlZEtleRIrCg1lY2NQcml2YXRlS2V5GAQgASgLMhQuRW50ZXJwcmlzZS5UeXBlZEtleSKyAQoLVXNlclRlYW1LZXkSDwoHdGVhbVVpZBgBIAEoDBIQCgh1c2VybmFtZRgCIAEoCRIYChBlbnRlcnByaXNlVXNlcklkGAMgASgDEhsKE2VuY3J5cHRlZFRlYW1LZXlSU0EYBCABKAwSGgoSZW5jcnlwdGVkVGVhbUtleUVDGAUgASgMEi0KBnN0YXR1cxgGIAEoDjIdLkF1dGhlbnRpY2F0aW9uLkdlbmVyaWNTdGF0dXMiKQoWR2VuZXJpY1JlcXVlc3RSZXNwb25zZRIPCgdyZXF1ZXN0GAEgAygMImYKGlBhc3NrZXlSZWdpc3RyYXRpb25SZXF1ZXN0EkgKF2F1dGhlbnRpY2F0b3JBdHRhY2htZW50GAEgASgOMicuQXV0aGVudGljYXRpb24uQXV0aGVudGljYXRvckF0dGFjaG1lbnQiUAobUGFzc2tleVJlZ2lzdHJhdGlvblJlc3BvbnNlEhYKDmNoYWxsZW5nZVRva2VuGAEgASgMEhkKEXBrQ3JlYXRpb25PcHRpb25zGAIgASgJIoEBCh9QYXNza2V5UmVnaXN0cmF0aW9uRmluYWxpemF0aW9uEhYKDGZyaWVuZGx5TmFtZRgDIAEoCUgAEhYKDmNoYWxsZW5nZVRva2VuGAEgASgMEh0KFWF1dGhlbnRpY2F0b3JSZXNwb25zZRgCIAEoCUIPCg1fZnJpZW5kbHlOYW1lIq0CChxQYXNza2V5QXV0aGVudGljYXRpb25SZXF1ZXN0EhIKCHVzZXJuYW1lGAUgASgJSAASHQoTZW5jcnlwdGVkTG9naW5Ub2tlbhgGIAEoDEgBEkgKF2F1dGhlbnRpY2F0b3JBdHRhY2htZW50GAEgASgOMicuQXV0aGVudGljYXRpb24uQXV0aGVudGljYXRvckF0dGFjaG1lbnQSNgoOcGFzc2tleVB1cnBvc2UYAiABKA4yHi5BdXRoZW50aWNhdGlvbi5QYXNza2V5UHVycG9zZRIVCg1jbGllbnRWZXJzaW9uGAMgASgJEhwKFGVuY3J5cHRlZERldmljZVRva2VuGAQgASgMQgsKCV91c2VybmFtZUIWChRfZW5jcnlwdGVkTG9naW5Ub2tlbiKIAQodUGFzc2tleUF1dGhlbnRpY2F0aW9uUmVzcG9uc2USHQoTZW5jcnlwdGVkTG9naW5Ub2tlbhgDIAEoDEgAEhgKEHBrUmVxdWVzdE9wdGlvbnMYASABKAkSFgoOY2hhbGxlbmdlVG9rZW4YAiABKAxCFgoUX2VuY3J5cHRlZExvZ2luVG9rZW4ivAEKGFBhc3NrZXlWYWxpZGF0aW9uUmVxdWVzdBIdChNlbmNyeXB0ZWRMb2dpblRva2VuGAQgASgMSAASFgoOY2hhbGxlbmdlVG9rZW4YASABKAwSGQoRYXNzZXJ0aW9uUmVzcG9uc2UYAiABKAwSNgoOcGFzc2tleVB1cnBvc2UYAyABKA4yHi5BdXRoZW50aWNhdGlvbi5QYXNza2V5UHVycG9zZUIWChRfZW5jcnlwdGVkTG9naW5Ub2tlbiJJChlQYXNza2V5VmFsaWRhdGlvblJlc3BvbnNlEg8KB2lzVmFsaWQYASABKAgSGwoTZW5jcnlwdGVkTG9naW5Ub2tlbhgCIAEoDCJlChRVcGRhdGVQYXNza2V5UmVxdWVzdBIWCgxmcmllbmRseU5hbWUYAyABKAlIABIOCgZ1c2VySWQYASABKAUSFAoMY3JlZGVudGlhbElkGAIgASgMQg8KDV9mcmllbmRseU5hbWUiLQoSUGFzc2tleUxpc3RSZXF1ZXN0EhcKD2luY2x1ZGVEaXNhYmxlZBgBIAEoCCKkAQoLUGFzc2tleUluZm8SDgoGdXNlcklkGAEgASgFEhQKDGNyZWRlbnRpYWxJZBgCIAEoDBIUCgxmcmllbmRseU5hbWUYAyABKAkSDgoGQUFHVUlEGAQgASgJEhcKD2NyZWF0ZWRBdE1pbGxpcxgFIAEoAxIWCg5sYXN0VXNlZE1pbGxpcxgGIAEoAxIYChBkaXNhYmxlZEF0TWlsbGlzGAcgASgDIkcKE1Bhc3NrZXlMaXN0UmVzcG9uc2USMAoLcGFzc2tleUluZm8YASADKAsyGy5BdXRoZW50aWNhdGlvbi5QYXNza2V5SW5mbyJDCg9UcmFuc2xhdGlvbkluZm8SFgoOdHJhbnNsYXRpb25LZXkYASABKAkSGAoQdHJhbnNsYXRpb25WYWx1ZRgCIAEoCSIsChJUcmFuc2xhdGlvblJlcXVlc3QSFgoOdHJhbnNsYXRpb25LZXkYASADKAkiTwoTVHJhbnNsYXRpb25SZXNwb25zZRI4Cg90cmFuc2xhdGlvbkluZm8YASADKAsyHy5BdXRoZW50aWNhdGlvbi5UcmFuc2xhdGlvbkluZm8q0wIKEVN1cHBvcnRlZExhbmd1YWdlEgsKB0VOR0xJU0gQABIKCgZBUkFCSUMQARILCgdCUklUSVNIEAISCwoHQ0hJTkVTRRADEhUKEUNISU5FU0VfSE9OR19LT05HEAQSEgoOQ0hJTkVTRV9UQUlXQU4QBRIJCgVEVVRDSBAGEgoKBkZSRU5DSBAHEgoKBkdFUk1BThAIEgkKBUdSRUVLEAkSCgoGSEVCUkVXEAoSCwoHSVRBTElBThALEgwKCEpBUEFORVNFEAwSCgoGS09SRUFOEA0SCgoGUE9MSVNIEA4SDgoKUE9SVFVHVUVTRRAPEhUKEVBPUlRVR1VFU0VfQlJBWklMEBASDAoIUk9NQU5JQU4QERILCgdSVVNTSUFOEBISCgoGU0xPVkFLEBMSCwoHU1BBTklTSBAUEgsKB0ZJTk5JU0gQFRILCgdTV0VESVNIEBYqawoJTG9naW5UeXBlEgoKBk5PUk1BTBAAEgcKA1NTTxABEgcKA0JJTxACEg0KCUFMVEVSTkFURRADEgsKB09GRkxJTkUQBBITCg9GT1JHT1RfUEFTU1dPUkQQBRIPCgtQQVNTS0VZX0JJTxAGKnEKDERldmljZVN0YXR1cxIZChVERVZJQ0VfTkVFRFNfQVBQUk9WQUwQABINCglERVZJQ0VfT0sQARIbChdERVZJQ0VfRElTQUJMRURfQllfVVNFUhACEhoKFkRFVklDRV9MT0NLRURfQllfQURNSU4QAypBCg1MaWNlbnNlU3RhdHVzEgkKBU9USEVSEAASCgoGQUNUSVZFEAESCwoHRVhQSVJFRBACEgwKCERJU0FCTEVEEAMqNwoLQWNjb3VudFR5cGUSDAoIQ09OU1VNRVIQABIKCgZGQU1JTFkQARIOCgpFTlRFUlBSSVNFEAIqnwIKEFNlc3Npb25Ub2tlblR5cGUSEgoOTk9fUkVTVFJJQ1RJT04QABIUChBBQ0NPVU5UX1JFQ09WRVJZEAESEQoNU0hBUkVfQUNDT1VOVBACEgwKCFBVUkNIQVNFEAMSDAoIUkVTVFJJQ1QQBBIRCg1BQ0NFUFRfSU5WSVRFEAUSEgoOU1VQUE9SVF9TRVJWRVIQBhIXChNFTlRFUlBSSVNFX0NSRUFUSU9OEAcSHwobRVhQSVJFRF9CVVRfQUxMT1dFRF9UT19TWU5DEAgSGAoUQUNDRVBUX0ZBTUlMWV9JTlZJVEUQCRIhCh1FTlRFUlBSSVNFX0NSRUFUSU9OX1BVUkNIQVNFRBAKEhQKEEVNRVJHRU5DWV9BQ0NFU1MQCypHCgdWZXJzaW9uEhMKD2ludmFsaWRfdmVyc2lvbhAAEhMKD2RlZmF1bHRfdmVyc2lvbhABEhIKDnNlY29uZF92ZXJzaW9uEAIqNwofTWFzdGVyUGFzc3dvcmRSZWVudHJ5QWN0aW9uVHlwZRIKCgZVTk1BU0sQABIICgRDT1BZEAEqbAoLTG9naW5NZXRob2QSFwoTSU5WQUxJRF9MT0dJTk1FVEhPRBAAEhQKEEVYSVNUSU5HX0FDQ09VTlQQARIOCgpTU09fRE9NQUlOEAISDQoJQUZURVJfU1NPEAMSDwoLTkVXX0FDQ09VTlQQBCq+BAoKTG9naW5TdGF0ZRIWChJJTlZBTElEX0xPR0lOU1RBVEUQABIOCgpMT0dHRURfT1VUEAESHAoYREVWSUNFX0FQUFJPVkFMX1JFUVVJUkVEEAISEQoNREVWSUNFX0xPQ0tFRBADEhIKDkFDQ09VTlRfTE9DS0VEEAQSGQoVREVWSUNFX0FDQ09VTlRfTE9DS0VEEAUSCwoHVVBHUkFERRAGEhMKD0xJQ0VOU0VfRVhQSVJFRBAHEhMKD1JFR0lPTl9SRURJUkVDVBAIEhYKElJFRElSRUNUX0NMT1VEX1NTTxAJEhcKE1JFRElSRUNUX09OU0lURV9TU08QChIQCgxSRVFVSVJFU18yRkEQDBIWChJSRVFVSVJFU19BVVRIX0hBU0gQDRIVChFSRVFVSVJFU19VU0VSTkFNRRAOEhkKFUFGVEVSX0NMT1VEX1NTT19MT0dJThAPEh0KGVJFUVVJUkVTX0FDQ09VTlRfQ1JFQVRJT04QEBImCiJSRVFVSVJFU19ERVZJQ0VfRU5DUllQVEVEX0RBVEFfS0VZEBESFwoTTE9HSU5fVE9LRU5fRVhQSVJFRBASEh4KGlBBU1NLRVlfSU5JVElBVEVfQ0hBTExFTkdFEBMSGQoVUEFTU0tFWV9BVVRIX1JFUVVJUkVEEBQSIQodUEFTU0tFWV9WRVJJRllfQVVUSEVOVElDQVRJT04QFRIXChNBRlRFUl9QQVNTS0VZX0xPR0lOEBYSDQoJTE9HR0VEX0lOEGMqawoURW5jcnlwdGVkRGF0YUtleVR5cGUSCgoGTk9fS0VZEAASGAoUQllfREVWSUNFX1BVQkxJQ19LRVkQARIPCgtCWV9QQVNTV09SRBACEhAKDEJZX0FMVEVSTkFURRADEgoKBkJZX0JJTxAEKi0KDlBhc3N3b3JkTWV0aG9kEgsKB0VOVEVSRUQQABIOCgpCSU9NRVRSSUNTEAEquQEKEVR3b0ZhY3RvclB1c2hUeXBlEhQKEFRXT19GQV9QVVNIX05PTkUQABITCg9UV09fRkFfUFVTSF9TTVMQARIWChJUV09fRkFfUFVTSF9LRUVQRVIQAhIYChRUV09fRkFfUFVTSF9EVU9fUFVTSBADEhgKFFRXT19GQV9QVVNIX0RVT19URVhUEAQSGAoUVFdPX0ZBX1BVU0hfRFVPX0NBTEwQBRITCg9UV09fRkFfUFVTSF9ETkEQBirDAQoSVHdvRmFjdG9yVmFsdWVUeXBlEhQKEFRXT19GQV9DT0RFX05PTkUQABIUChBUV09fRkFfQ09ERV9UT1RQEAESEwoPVFdPX0ZBX0NPREVfU01TEAISEwoPVFdPX0ZBX0NPREVfRFVPEAMSEwoPVFdPX0ZBX0NPREVfUlNBEAQSEwoPVFdPX0ZBX1JFU1BfVTJGEAUSGAoUVFdPX0ZBX1JFU1BfV0VCQVVUSE4QBhITCg9UV09fRkFfQ09ERV9ETkEQByrhAQoUVHdvRmFjdG9yQ2hhbm5lbFR5cGUSEgoOVFdPX0ZBX0NUX05PTkUQABISCg5UV09fRkFfQ1RfVE9UUBABEhEKDVRXT19GQV9DVF9TTVMQAhIRCg1UV09fRkFfQ1RfRFVPEAMSEQoNVFdPX0ZBX0NUX1JTQRAEEhQKEFRXT19GQV9DVF9CQUNLVVAQBRIRCg1UV09fRkFfQ1RfVTJGEAYSFgoSVFdPX0ZBX0NUX1dFQkFVVEhOEAcSFAoQVFdPX0ZBX0NUX0tFRVBFUhAIEhEKDVRXT19GQV9DVF9ETkEQCSqrAQoTVHdvRmFjdG9yRXhwaXJhdGlvbhIaChZUV09fRkFfRVhQX0lNTUVESUFURUxZEAASGAoUVFdPX0ZBX0VYUF81X01JTlVURVMQARIXChNUV09fRkFfRVhQXzEyX0hPVVJTEAISFwoTVFdPX0ZBX0VYUF8yNF9IT1VSUxADEhYKElRXT19GQV9FWFBfMzBfREFZUxAEEhQKEFRXT19GQV9FWFBfTkVWRVIQBSpACgtMaWNlbnNlVHlwZRIJCgVWQVVMVBAAEggKBENIQVQQARILCgdTVE9SQUdFEAISDwoLQlJFQUNIV0FUQ0gQAyppCgtPYmplY3RUeXBlcxIKCgZSRUNPUkQQABIWChJTSEFSRURfRk9MREVSX1VTRVIQARIWChJTSEFSRURfRk9MREVSX1RFQU0QAhIPCgtVU0VSX0ZPTERFUhADEg0KCVRFQU1fVVNFUhAEKqECChNFbmNyeXB0ZWRPYmplY3RUeXBlEhMKD0VPVF9VTlNQRUNJRklFRBAAEhIKDkVPVF9SRUNPUkRfS0VZEAESHgoaRU9UX1NIQVJFRF9GT0xERVJfVVNFUl9LRVkQAhIeChpFT1RfU0hBUkVEX0ZPTERFUl9URUFNX0tFWRADEhUKEUVPVF9URUFNX1VTRVJfS0VZEAQSFwoTRU9UX1VTRVJfRk9MREVSX0tFWRAFEhUKEUVPVF9TRUNVUklUWV9EQVRBEAYSJQohRU9UX1NFQ1VSSVRZX0RBVEFfTUFTVEVSX1BBU1NXT1JEEAcSHAoYRU9UX0VNRVJHRU5DWV9BQ0NFU1NfS0VZEAgSFQoRRU9UX1YyX1JFQ09SRF9LRVkQCSpNChtNYXN0ZXJQYXNzd29yZFJlZW50cnlTdGF0dXMSDgoKTVBfVU5LTk9XThAAEg4KCk1QX1NVQ0NFU1MQARIOCgpNUF9GQUlMVVJFEAIqYAobQWx0ZXJuYXRlQXV0aGVudGljYXRpb25UeXBlEh0KGUFMVEVSTkFURV9NQVNURVJfUEFTU1dPUkQQABINCglCSU9NRVRSSUMQARITCg9BQ0NPVU5UX1JFQ09WRVIQAiqaAgoMVGhyb3R0bGVUeXBlEhsKF1BBU1NXT1JEX1JFVFJZX1RIUk9UVExFEAASIgoeUEFTU1dPUkRfUkVUUllfTEVHQUNZX1RIUk9UVExFEAESEwoPVFdPX0ZBX1RIUk9UVExFEAISGgoWVFdPX0ZBX0xFR0FDWV9USFJPVFRMRRADEhUKEVFBX1JFVFJZX1RIUk9UVExFEAQSHAoYQUNDT1VOVF9SRUNPVkVSX1RIUk9UVExFEAUSLgoqVkFMSURBVEVfREVWSUNFX1ZFUklGSUNBVElPTl9DT0RFX1RIUk9UVExFEAYSMwovVkFMSURBVEVfQ1JFQVRFX1VTRVJfVkVSSUZJQ0FUSU9OX0NPREVfVEhST1RUTEUQBypICgZSZWdpb24SCwoHVU5LTk9XThAAEgYKAmV1EAESBgoCdXMQAhIJCgV1c2dvdhADEgYKAmF1EAQSBgoCanAQBRIGCgJjYRAGKkQKFEFwcGxpY2F0aW9uU2hhcmVUeXBlEhUKEVNIQVJFX1RZUEVfUkVDT1JEEAASFQoRU0hBUkVfVFlQRV9GT0xERVIQASqkAQoVVGltZUxpbWl0ZWRBY2Nlc3NUeXBlEiQKIElOVkFMSURfVElNRV9MSU1JVEVEX0FDQ0VTU19UWVBFEAASGQoVVVNFUl9BQ0NFU1NfVE9fUkVDT1JEEAESJwojVVNFUl9PUl9URUFNX0FDQ0VTU19UT19TSEFSRURGT0xERVIQAhIhCh1SRUNPUkRfQUNDRVNTX1RPX1NIQVJFREZPTERFUhADKjwKDUJhY2t1cEtleVR5cGUSEgoOQktUX1NFQ19BTlNXRVIQABIXChNCS1RfUEFTU1BIUkFTRV9IQVNIEAEqVwoNR2VuZXJpY1N0YXR1cxILCgdTVUNDRVNTEAASEgoOSU5WQUxJRF9PQkpFQ1QQARISCg5BTFJFQURZX0VYSVNUUxACEhEKDUFDQ0VTU19ERU5JRUQQAypOChdBdXRoZW50aWNhdG9yQXR0YWNobWVudBISCg5DUk9TU19QTEFURk9STRAAEgwKCFBMQVRGT1JNEAESEQoNQUxMX1NVUFBPUlRFRBACKi0KDlBhc3NrZXlQdXJwb3NlEgwKCFBLX0xPR0lOEAASDQoJUEtfUkVBVVRIEAEqSwoQQ2xpZW50Rm9ybUZhY3RvchIMCghGRl9FTVBUWRAAEgwKCEZGX1BIT05FEAESDQoJRkZfVEFCTEVUEAISDAoIRkZfV0FUQ0gQA2IGcHJvdG8z",
    [file_enterprise],
  );

/**
 * @generated from message Authentication.ApiRequest
 */
export type ApiRequest = Message<"Authentication.ApiRequest"> & {
  /**
   * @generated from field: bytes encryptedTransmissionKey = 1;
   */
  encryptedTransmissionKey: Uint8Array;

  /**
   * @generated from field: int32 publicKeyId = 2;
   */
  publicKeyId: number;

  /**
   * @generated from field: string locale = 3;
   */
  locale: string;

  /**
   * @generated from field: bytes encryptedPayload = 4;
   */
  encryptedPayload: Uint8Array;

  /**
   * @generated from field: int32 encryptionType = 5;
   */
  encryptionType: number;

  /**
   * @generated from field: string recaptcha = 6;
   */
  recaptcha: string;

  /**
   * @generated from field: string subEnvironment = 7;
   */
  subEnvironment: string;
};

/**
 * Describes the message Authentication.ApiRequest.
 * Use `create(ApiRequestSchema)` to create a new message.
 */
export const ApiRequestSchema: GenMessage<ApiRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 0);

/**
 * @generated from message Authentication.ApiRequestPayload
 */
export type ApiRequestPayload = Message<"Authentication.ApiRequestPayload"> & {
  /**
   * @generated from field: bytes payload = 1;
   */
  payload: Uint8Array;

  /**
   * @generated from field: bytes encryptedSessionToken = 2;
   */
  encryptedSessionToken: Uint8Array;

  /**
   * @generated from field: bytes timeToken = 3;
   */
  timeToken: Uint8Array;

  /**
   * @generated from field: int32 apiVersion = 4;
   */
  apiVersion: number;
};

/**
 * Describes the message Authentication.ApiRequestPayload.
 * Use `create(ApiRequestPayloadSchema)` to create a new message.
 */
export const ApiRequestPayloadSchema: GenMessage<ApiRequestPayload> =
  /*@__PURE__*/
  messageDesc(file_api_request, 1);

/**
 * @generated from message Authentication.Transform
 */
export type Transform = Message<"Authentication.Transform"> & {
  /**
   * @generated from field: bytes key = 1;
   */
  key: Uint8Array;

  /**
   * @generated from field: bytes encryptedDeviceToken = 2;
   */
  encryptedDeviceToken: Uint8Array;
};

/**
 * Describes the message Authentication.Transform.
 * Use `create(TransformSchema)` to create a new message.
 */
export const TransformSchema: GenMessage<Transform> =
  /*@__PURE__*/
  messageDesc(file_api_request, 2);

/**
 * @generated from message Authentication.DeviceRequest
 */
export type DeviceRequest = Message<"Authentication.DeviceRequest"> & {
  /**
   * @generated from field: string clientVersion = 1;
   */
  clientVersion: string;

  /**
   * @generated from field: string deviceName = 2;
   */
  deviceName: string;

  /**
   * @generated from field: string devicePlatform = 3;
   */
  devicePlatform: string;

  /**
   * @generated from field: Authentication.ClientFormFactor clientFormFactor = 4;
   */
  clientFormFactor: ClientFormFactor;

  /**
   * @generated from field: string username = 5;
   */
  username: string;
};

/**
 * Describes the message Authentication.DeviceRequest.
 * Use `create(DeviceRequestSchema)` to create a new message.
 */
export const DeviceRequestSchema: GenMessage<DeviceRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 3);

/**
 * @generated from message Authentication.AuthRequest
 */
export type AuthRequest = Message<"Authentication.AuthRequest"> & {
  /**
   * @generated from field: string clientVersion = 1;
   */
  clientVersion: string;

  /**
   * @generated from field: string username = 2;
   */
  username: string;

  /**
   * @generated from field: bytes encryptedDeviceToken = 3;
   */
  encryptedDeviceToken: Uint8Array;
};

/**
 * Describes the message Authentication.AuthRequest.
 * Use `create(AuthRequestSchema)` to create a new message.
 */
export const AuthRequestSchema: GenMessage<AuthRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 4);

/**
 * @generated from message Authentication.NewUserMinimumParams
 */
export type NewUserMinimumParams = Message<"Authentication.NewUserMinimumParams"> & {
  /**
   * @generated from field: int32 minimumIterations = 1;
   */
  minimumIterations: number;

  /**
   * @generated from field: repeated string passwordMatchRegex = 2;
   */
  passwordMatchRegex: string[];

  /**
   * @generated from field: repeated string passwordMatchDescription = 3;
   */
  passwordMatchDescription: string[];

  /**
   * @generated from field: bool isEnterpriseDomain = 4;
   */
  isEnterpriseDomain: boolean;

  /**
   * @generated from field: bytes enterpriseEccPublicKey = 5;
   */
  enterpriseEccPublicKey: Uint8Array;

  /**
   * @generated from field: bool forbidKeyType2 = 6;
   */
  forbidKeyType2: boolean;
};

/**
 * Describes the message Authentication.NewUserMinimumParams.
 * Use `create(NewUserMinimumParamsSchema)` to create a new message.
 */
export const NewUserMinimumParamsSchema: GenMessage<NewUserMinimumParams> =
  /*@__PURE__*/
  messageDesc(file_api_request, 5);

/**
 * @generated from message Authentication.PreLoginRequest
 */
export type PreLoginRequest = Message<"Authentication.PreLoginRequest"> & {
  /**
   * @generated from field: Authentication.AuthRequest authRequest = 1;
   */
  authRequest?: AuthRequest;

  /**
   * @generated from field: Authentication.LoginType loginType = 2;
   */
  loginType: LoginType;

  /**
   * @generated from field: bytes twoFactorToken = 3;
   */
  twoFactorToken: Uint8Array;
};

/**
 * Describes the message Authentication.PreLoginRequest.
 * Use `create(PreLoginRequestSchema)` to create a new message.
 */
export const PreLoginRequestSchema: GenMessage<PreLoginRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 6);

/**
 * @generated from message Authentication.LoginRequest
 */
export type LoginRequest = Message<"Authentication.LoginRequest"> & {
  /**
   * @generated from field: Authentication.AuthRequest authRequest = 1;
   */
  authRequest?: AuthRequest;

  /**
   * @generated from field: Authentication.LoginType loginType = 2;
   */
  loginType: LoginType;

  /**
   * @generated from field: bytes authenticationHashPrime = 3;
   */
  authenticationHashPrime: Uint8Array;

  /**
   * @generated from field: bytes encryptedLoginToken = 4;
   */
  encryptedLoginToken: Uint8Array;

  /**
   * @generated from field: bytes authResponse = 5;
   */
  authResponse: Uint8Array;

  /**
   * @generated from field: int32 mcEnterpriseId = 6;
   */
  mcEnterpriseId: number;

  /**
   * @generated from field: string push_token = 7;
   */
  pushToken: string;

  /**
   * @generated from field: string platform = 8;
   */
  platform: string;
};

/**
 * Describes the message Authentication.LoginRequest.
 * Use `create(LoginRequestSchema)` to create a new message.
 */
export const LoginRequestSchema: GenMessage<LoginRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 7);

/**
 * @generated from message Authentication.DeviceResponse
 */
export type DeviceResponse = Message<"Authentication.DeviceResponse"> & {
  /**
   * @generated from field: bytes encryptedDeviceToken = 1;
   */
  encryptedDeviceToken: Uint8Array;

  /**
   * @generated from field: Authentication.DeviceStatus status = 2;
   */
  status: DeviceStatus;
};

/**
 * Describes the message Authentication.DeviceResponse.
 * Use `create(DeviceResponseSchema)` to create a new message.
 */
export const DeviceResponseSchema: GenMessage<DeviceResponse> =
  /*@__PURE__*/
  messageDesc(file_api_request, 8);

/**
 * @generated from message Authentication.Salt
 */
export type Salt = Message<"Authentication.Salt"> & {
  /**
   * @generated from field: int32 iterations = 1;
   */
  iterations: number;

  /**
   * @generated from field: bytes salt = 2;
   */
  salt: Uint8Array;

  /**
   * @generated from field: int32 algorithm = 3;
   */
  algorithm: number;

  /**
   * @generated from field: bytes uid = 4;
   */
  uid: Uint8Array;

  /**
   * @generated from field: string name = 5;
   */
  name: string;
};

/**
 * Describes the message Authentication.Salt.
 * Use `create(SaltSchema)` to create a new message.
 */
export const SaltSchema: GenMessage<Salt> = /*@__PURE__*/ messageDesc(file_api_request, 9);

/**
 * @generated from message Authentication.TwoFactorChannel
 */
export type TwoFactorChannel = Message<"Authentication.TwoFactorChannel"> & {
  /**
   * @generated from field: int32 type = 1;
   */
  type: number;
};

/**
 * Describes the message Authentication.TwoFactorChannel.
 * Use `create(TwoFactorChannelSchema)` to create a new message.
 */
export const TwoFactorChannelSchema: GenMessage<TwoFactorChannel> =
  /*@__PURE__*/
  messageDesc(file_api_request, 10);

/**
 * @generated from message Authentication.StartLoginRequest
 */
export type StartLoginRequest = Message<"Authentication.StartLoginRequest"> & {
  /**
   * @generated from field: bytes encryptedDeviceToken = 1;
   */
  encryptedDeviceToken: Uint8Array;

  /**
   * @generated from field: string username = 2;
   */
  username: string;

  /**
   * @generated from field: string clientVersion = 3;
   */
  clientVersion: string;

  /**
   * @generated from field: bytes messageSessionUid = 4;
   */
  messageSessionUid: Uint8Array;

  /**
   * @generated from field: bytes encryptedLoginToken = 5;
   */
  encryptedLoginToken: Uint8Array;

  /**
   * @generated from field: Authentication.LoginType loginType = 6;
   */
  loginType: LoginType;

  /**
   * @generated from field: int32 mcEnterpriseId = 7;
   */
  mcEnterpriseId: number;

  /**
   * @generated from field: Authentication.LoginMethod loginMethod = 8;
   */
  loginMethod: LoginMethod;

  /**
   * @generated from field: bool forceNewLogin = 9;
   */
  forceNewLogin: boolean;

  /**
   * @generated from field: bytes cloneCode = 10;
   */
  cloneCode: Uint8Array;

  /**
   * @generated from field: string v2TwoFactorToken = 11;
   */
  v2TwoFactorToken: string;

  /**
   * @generated from field: bytes accountUid = 12;
   */
  accountUid: Uint8Array;

  /**
   * @generated from field: bytes fromSessionToken = 13;
   */
  fromSessionToken: Uint8Array;
};

/**
 * Describes the message Authentication.StartLoginRequest.
 * Use `create(StartLoginRequestSchema)` to create a new message.
 */
export const StartLoginRequestSchema: GenMessage<StartLoginRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 11);

/**
 * @generated from message Authentication.LoginResponse
 */
export type LoginResponse = Message<"Authentication.LoginResponse"> & {
  /**
   * @generated from field: Authentication.LoginState loginState = 1;
   */
  loginState: LoginState;

  /**
   * @generated from field: bytes accountUid = 2;
   */
  accountUid: Uint8Array;

  /**
   * @generated from field: string primaryUsername = 3;
   */
  primaryUsername: string;

  /**
   * @generated from field: bytes encryptedDataKey = 4;
   */
  encryptedDataKey: Uint8Array;

  /**
   * @generated from field: Authentication.EncryptedDataKeyType encryptedDataKeyType = 5;
   */
  encryptedDataKeyType: EncryptedDataKeyType;

  /**
   * @generated from field: bytes encryptedLoginToken = 6;
   */
  encryptedLoginToken: Uint8Array;

  /**
   * @generated from field: bytes encryptedSessionToken = 7;
   */
  encryptedSessionToken: Uint8Array;

  /**
   * @generated from field: Authentication.SessionTokenType sessionTokenType = 8;
   */
  sessionTokenType: SessionTokenType;

  /**
   * @generated from field: string message = 9;
   */
  message: string;

  /**
   * @generated from field: string url = 10;
   */
  url: string;

  /**
   * @generated from field: repeated Authentication.TwoFactorChannelInfo channels = 11;
   */
  channels: TwoFactorChannelInfo[];

  /**
   * @generated from field: repeated Authentication.Salt salt = 12;
   */
  salt: Salt[];

  /**
   * @generated from field: bytes cloneCode = 13;
   */
  cloneCode: Uint8Array;

  /**
   * @generated from field: string stateSpecificValue = 14;
   */
  stateSpecificValue: string;

  /**
   * @generated from field: string ssoClientVersion = 15;
   */
  ssoClientVersion: string;

  /**
   * @generated from field: string sessionTokenTypeModifier = 16;
   */
  sessionTokenTypeModifier: string;
};

/**
 * Describes the message Authentication.LoginResponse.
 * Use `create(LoginResponseSchema)` to create a new message.
 */
export const LoginResponseSchema: GenMessage<LoginResponse> =
  /*@__PURE__*/
  messageDesc(file_api_request, 12);

/**
 * @generated from message Authentication.SwitchListElement
 */
export type SwitchListElement = Message<"Authentication.SwitchListElement"> & {
  /**
   * @generated from field: string username = 1;
   */
  username: string;

  /**
   * @generated from field: string fullName = 2;
   */
  fullName: string;

  /**
   * @generated from field: bool authRequired = 3;
   */
  authRequired: boolean;

  /**
   * @generated from field: bool isLinked = 4;
   */
  isLinked: boolean;
};

/**
 * Describes the message Authentication.SwitchListElement.
 * Use `create(SwitchListElementSchema)` to create a new message.
 */
export const SwitchListElementSchema: GenMessage<SwitchListElement> =
  /*@__PURE__*/
  messageDesc(file_api_request, 13);

/**
 * @generated from message Authentication.SwitchListResponse
 */
export type SwitchListResponse = Message<"Authentication.SwitchListResponse"> & {
  /**
   * @generated from field: repeated Authentication.SwitchListElement elements = 1;
   */
  elements: SwitchListElement[];
};

/**
 * Describes the message Authentication.SwitchListResponse.
 * Use `create(SwitchListResponseSchema)` to create a new message.
 */
export const SwitchListResponseSchema: GenMessage<SwitchListResponse> =
  /*@__PURE__*/
  messageDesc(file_api_request, 14);

/**
 * @generated from message Authentication.SsoUserInfo
 */
export type SsoUserInfo = Message<"Authentication.SsoUserInfo"> & {
  /**
   * @generated from field: string companyName = 1;
   */
  companyName: string;

  /**
   * @generated from field: string samlRequest = 2;
   */
  samlRequest: string;

  /**
   * @generated from field: string samlRequestType = 3;
   */
  samlRequestType: string;

  /**
   * @generated from field: string ssoDomainName = 4;
   */
  ssoDomainName: string;

  /**
   * @generated from field: string loginUrl = 5;
   */
  loginUrl: string;

  /**
   * @generated from field: string logoutUrl = 6;
   */
  logoutUrl: string;
};

/**
 * Describes the message Authentication.SsoUserInfo.
 * Use `create(SsoUserInfoSchema)` to create a new message.
 */
export const SsoUserInfoSchema: GenMessage<SsoUserInfo> =
  /*@__PURE__*/
  messageDesc(file_api_request, 15);

/**
 * @generated from message Authentication.PreLoginResponse
 */
export type PreLoginResponse = Message<"Authentication.PreLoginResponse"> & {
  /**
   * @generated from field: Authentication.DeviceStatus deviceStatus = 1;
   */
  deviceStatus: DeviceStatus;

  /**
   * @generated from field: repeated Authentication.Salt salt = 2;
   */
  salt: Salt[];

  /**
   * @generated from field: repeated Authentication.TwoFactorChannel OBSOLETE_FIELD = 3;
   */
  OBSOLETEFIELD: TwoFactorChannel[];

  /**
   * @generated from field: Authentication.SsoUserInfo ssoUserInfo = 4;
   */
  ssoUserInfo?: SsoUserInfo;
};

/**
 * Describes the message Authentication.PreLoginResponse.
 * Use `create(PreLoginResponseSchema)` to create a new message.
 */
export const PreLoginResponseSchema: GenMessage<PreLoginResponse> =
  /*@__PURE__*/
  messageDesc(file_api_request, 16);

/**
 * @generated from message Authentication.LoginAsUserRequest
 */
export type LoginAsUserRequest = Message<"Authentication.LoginAsUserRequest"> & {
  /**
   * @generated from field: string username = 1;
   */
  username: string;
};

/**
 * Describes the message Authentication.LoginAsUserRequest.
 * Use `create(LoginAsUserRequestSchema)` to create a new message.
 */
export const LoginAsUserRequestSchema: GenMessage<LoginAsUserRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 17);

/**
 * @generated from message Authentication.LoginAsUserResponse
 */
export type LoginAsUserResponse = Message<"Authentication.LoginAsUserResponse"> & {
  /**
   * @generated from field: bytes encryptedSessionToken = 1;
   */
  encryptedSessionToken: Uint8Array;

  /**
   * @generated from field: bytes encryptedSharedAccountKey = 2;
   */
  encryptedSharedAccountKey: Uint8Array;
};

/**
 * Describes the message Authentication.LoginAsUserResponse.
 * Use `create(LoginAsUserResponseSchema)` to create a new message.
 */
export const LoginAsUserResponseSchema: GenMessage<LoginAsUserResponse> =
  /*@__PURE__*/
  messageDesc(file_api_request, 18);

/**
 * @generated from message Authentication.ValidateAuthHashRequest
 */
export type ValidateAuthHashRequest = Message<"Authentication.ValidateAuthHashRequest"> & {
  /**
   * @generated from field: Authentication.PasswordMethod passwordMethod = 1;
   */
  passwordMethod: PasswordMethod;

  /**
   * @generated from field: bytes authResponse = 2;
   */
  authResponse: Uint8Array;

  /**
   * @generated from field: bytes encryptedLoginToken = 3;
   */
  encryptedLoginToken: Uint8Array;
};

/**
 * Describes the message Authentication.ValidateAuthHashRequest.
 * Use `create(ValidateAuthHashRequestSchema)` to create a new message.
 */
export const ValidateAuthHashRequestSchema: GenMessage<ValidateAuthHashRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 19);

/**
 * @generated from message Authentication.TwoFactorChannelInfo
 */
export type TwoFactorChannelInfo = Message<"Authentication.TwoFactorChannelInfo"> & {
  /**
   * @generated from field: Authentication.TwoFactorChannelType channelType = 1;
   */
  channelType: TwoFactorChannelType;

  /**
   * @generated from field: bytes channel_uid = 2;
   */
  channelUid: Uint8Array;

  /**
   * @generated from field: string channelName = 3;
   */
  channelName: string;

  /**
   * @generated from field: string challenge = 4;
   */
  challenge: string;

  /**
   * @generated from field: repeated string capabilities = 5;
   */
  capabilities: string[];

  /**
   * @generated from field: string phoneNumber = 6;
   */
  phoneNumber: string;

  /**
   * @generated from field: Authentication.TwoFactorExpiration maxExpiration = 7;
   */
  maxExpiration: TwoFactorExpiration;

  /**
   * @generated from field: int64 createdOn = 8;
   */
  createdOn: bigint;

  /**
   * @generated from field: Authentication.TwoFactorExpiration lastFrequency = 9;
   */
  lastFrequency: TwoFactorExpiration;
};

/**
 * Describes the message Authentication.TwoFactorChannelInfo.
 * Use `create(TwoFactorChannelInfoSchema)` to create a new message.
 */
export const TwoFactorChannelInfoSchema: GenMessage<TwoFactorChannelInfo> =
  /*@__PURE__*/
  messageDesc(file_api_request, 20);

/**
 * @generated from message Authentication.TwoFactorDuoStatus
 */
export type TwoFactorDuoStatus = Message<"Authentication.TwoFactorDuoStatus"> & {
  /**
   * @generated from field: repeated string capabilities = 1;
   */
  capabilities: string[];

  /**
   * @generated from field: string phoneNumber = 2;
   */
  phoneNumber: string;

  /**
   * @generated from field: string enroll_url = 3;
   */
  enrollUrl: string;

  /**
   * @generated from field: string message = 4;
   */
  message: string;
};

/**
 * Describes the message Authentication.TwoFactorDuoStatus.
 * Use `create(TwoFactorDuoStatusSchema)` to create a new message.
 */
export const TwoFactorDuoStatusSchema: GenMessage<TwoFactorDuoStatus> =
  /*@__PURE__*/
  messageDesc(file_api_request, 21);

/**
 * @generated from message Authentication.TwoFactorAddRequest
 */
export type TwoFactorAddRequest = Message<"Authentication.TwoFactorAddRequest"> & {
  /**
   * @generated from field: Authentication.TwoFactorChannelType channelType = 1;
   */
  channelType: TwoFactorChannelType;

  /**
   * @generated from field: bytes channel_uid = 2;
   */
  channelUid: Uint8Array;

  /**
   * @generated from field: string channelName = 3;
   */
  channelName: string;

  /**
   * @generated from field: string phoneNumber = 4;
   */
  phoneNumber: string;

  /**
   * @generated from field: Authentication.TwoFactorPushType duoPushType = 5;
   */
  duoPushType: TwoFactorPushType;
};

/**
 * Describes the message Authentication.TwoFactorAddRequest.
 * Use `create(TwoFactorAddRequestSchema)` to create a new message.
 */
export const TwoFactorAddRequestSchema: GenMessage<TwoFactorAddRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 22);

/**
 * @generated from message Authentication.TwoFactorRenameRequest
 */
export type TwoFactorRenameRequest = Message<"Authentication.TwoFactorRenameRequest"> & {
  /**
   * @generated from field: bytes channel_uid = 1;
   */
  channelUid: Uint8Array;

  /**
   * @generated from field: string channelName = 2;
   */
  channelName: string;
};

/**
 * Describes the message Authentication.TwoFactorRenameRequest.
 * Use `create(TwoFactorRenameRequestSchema)` to create a new message.
 */
export const TwoFactorRenameRequestSchema: GenMessage<TwoFactorRenameRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 23);

/**
 * @generated from message Authentication.TwoFactorAddResponse
 */
export type TwoFactorAddResponse = Message<"Authentication.TwoFactorAddResponse"> & {
  /**
   * @generated from field: string challenge = 1;
   */
  challenge: string;

  /**
   * @generated from field: repeated string backupKeys = 2;
   */
  backupKeys: string[];
};

/**
 * Describes the message Authentication.TwoFactorAddResponse.
 * Use `create(TwoFactorAddResponseSchema)` to create a new message.
 */
export const TwoFactorAddResponseSchema: GenMessage<TwoFactorAddResponse> =
  /*@__PURE__*/
  messageDesc(file_api_request, 24);

/**
 * @generated from message Authentication.TwoFactorDeleteRequest
 */
export type TwoFactorDeleteRequest = Message<"Authentication.TwoFactorDeleteRequest"> & {
  /**
   * @generated from field: bytes channel_uid = 1;
   */
  channelUid: Uint8Array;
};

/**
 * Describes the message Authentication.TwoFactorDeleteRequest.
 * Use `create(TwoFactorDeleteRequestSchema)` to create a new message.
 */
export const TwoFactorDeleteRequestSchema: GenMessage<TwoFactorDeleteRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 25);

/**
 * @generated from message Authentication.TwoFactorListResponse
 */
export type TwoFactorListResponse = Message<"Authentication.TwoFactorListResponse"> & {
  /**
   * @generated from field: repeated Authentication.TwoFactorChannelInfo channels = 1;
   */
  channels: TwoFactorChannelInfo[];

  /**
   * @generated from field: int64 expireOn = 2;
   */
  expireOn: bigint;
};

/**
 * Describes the message Authentication.TwoFactorListResponse.
 * Use `create(TwoFactorListResponseSchema)` to create a new message.
 */
export const TwoFactorListResponseSchema: GenMessage<TwoFactorListResponse> =
  /*@__PURE__*/
  messageDesc(file_api_request, 26);

/**
 * @generated from message Authentication.TwoFactorUpdateExpirationRequest
 */
export type TwoFactorUpdateExpirationRequest =
  Message<"Authentication.TwoFactorUpdateExpirationRequest"> & {
    /**
     * @generated from field: Authentication.TwoFactorExpiration expireIn = 1;
     */
    expireIn: TwoFactorExpiration;
  };

/**
 * Describes the message Authentication.TwoFactorUpdateExpirationRequest.
 * Use `create(TwoFactorUpdateExpirationRequestSchema)` to create a new message.
 */
export const TwoFactorUpdateExpirationRequestSchema: GenMessage<TwoFactorUpdateExpirationRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 27);

/**
 * @generated from message Authentication.TwoFactorValidateRequest
 */
export type TwoFactorValidateRequest = Message<"Authentication.TwoFactorValidateRequest"> & {
  /**
   * @generated from field: bytes encryptedLoginToken = 1;
   */
  encryptedLoginToken: Uint8Array;

  /**
   * @generated from field: Authentication.TwoFactorValueType valueType = 2;
   */
  valueType: TwoFactorValueType;

  /**
   * @generated from field: string value = 3;
   */
  value: string;

  /**
   * @generated from field: bytes channel_uid = 4;
   */
  channelUid: Uint8Array;

  /**
   * @generated from field: Authentication.TwoFactorExpiration expireIn = 5;
   */
  expireIn: TwoFactorExpiration;
};

/**
 * Describes the message Authentication.TwoFactorValidateRequest.
 * Use `create(TwoFactorValidateRequestSchema)` to create a new message.
 */
export const TwoFactorValidateRequestSchema: GenMessage<TwoFactorValidateRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 28);

/**
 * @generated from message Authentication.TwoFactorValidateResponse
 */
export type TwoFactorValidateResponse = Message<"Authentication.TwoFactorValidateResponse"> & {
  /**
   * @generated from field: bytes encryptedLoginToken = 1;
   */
  encryptedLoginToken: Uint8Array;
};

/**
 * Describes the message Authentication.TwoFactorValidateResponse.
 * Use `create(TwoFactorValidateResponseSchema)` to create a new message.
 */
export const TwoFactorValidateResponseSchema: GenMessage<TwoFactorValidateResponse> =
  /*@__PURE__*/
  messageDesc(file_api_request, 29);

/**
 * @generated from message Authentication.TwoFactorSendPushRequest
 */
export type TwoFactorSendPushRequest = Message<"Authentication.TwoFactorSendPushRequest"> & {
  /**
   * @generated from field: bytes encryptedLoginToken = 1;
   */
  encryptedLoginToken: Uint8Array;

  /**
   * @generated from field: Authentication.TwoFactorPushType pushType = 2;
   */
  pushType: TwoFactorPushType;

  /**
   * @generated from field: bytes channel_uid = 3;
   */
  channelUid: Uint8Array;

  /**
   * @generated from field: Authentication.TwoFactorExpiration expireIn = 4;
   */
  expireIn: TwoFactorExpiration;
};

/**
 * Describes the message Authentication.TwoFactorSendPushRequest.
 * Use `create(TwoFactorSendPushRequestSchema)` to create a new message.
 */
export const TwoFactorSendPushRequestSchema: GenMessage<TwoFactorSendPushRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 30);

/**
 * @generated from message Authentication.License
 */
export type License = Message<"Authentication.License"> & {
  /**
   * @generated from field: int64 created = 1;
   */
  created: bigint;

  /**
   * @generated from field: int64 expiration = 2;
   */
  expiration: bigint;

  /**
   * @generated from field: Authentication.LicenseStatus licenseStatus = 3;
   */
  licenseStatus: LicenseStatus;

  /**
   * @generated from field: bool paid = 4;
   */
  paid: boolean;

  /**
   * @generated from field: string message = 5;
   */
  message: string;
};

/**
 * Describes the message Authentication.License.
 * Use `create(LicenseSchema)` to create a new message.
 */
export const LicenseSchema: GenMessage<License> = /*@__PURE__*/ messageDesc(file_api_request, 31);

/**
 * @generated from message Authentication.OwnerlessRecord
 */
export type OwnerlessRecord = Message<"Authentication.OwnerlessRecord"> & {
  /**
   * @generated from field: bytes recordUid = 1;
   */
  recordUid: Uint8Array;

  /**
   * @generated from field: bytes recordKey = 2;
   */
  recordKey: Uint8Array;

  /**
   * @generated from field: int32 status = 3;
   */
  status: number;
};

/**
 * Describes the message Authentication.OwnerlessRecord.
 * Use `create(OwnerlessRecordSchema)` to create a new message.
 */
export const OwnerlessRecordSchema: GenMessage<OwnerlessRecord> =
  /*@__PURE__*/
  messageDesc(file_api_request, 32);

/**
 * @generated from message Authentication.OwnerlessRecords
 */
export type OwnerlessRecords = Message<"Authentication.OwnerlessRecords"> & {
  /**
   * @generated from field: repeated Authentication.OwnerlessRecord ownerlessRecord = 1;
   */
  ownerlessRecord: OwnerlessRecord[];
};

/**
 * Describes the message Authentication.OwnerlessRecords.
 * Use `create(OwnerlessRecordsSchema)` to create a new message.
 */
export const OwnerlessRecordsSchema: GenMessage<OwnerlessRecords> =
  /*@__PURE__*/
  messageDesc(file_api_request, 33);

/**
 * @generated from message Authentication.UserAuthRequest
 */
export type UserAuthRequest = Message<"Authentication.UserAuthRequest"> & {
  /**
   * @generated from field: bytes uid = 1;
   */
  uid: Uint8Array;

  /**
   * @generated from field: bytes salt = 2;
   */
  salt: Uint8Array;

  /**
   * @generated from field: int32 iterations = 3;
   */
  iterations: number;

  /**
   * @generated from field: bytes encryptedClientKey = 4;
   */
  encryptedClientKey: Uint8Array;

  /**
   * @generated from field: bytes authHash = 5;
   */
  authHash: Uint8Array;

  /**
   * @generated from field: bytes encryptedDataKey = 6;
   */
  encryptedDataKey: Uint8Array;

  /**
   * @generated from field: Authentication.LoginType loginType = 7;
   */
  loginType: LoginType;

  /**
   * @generated from field: string name = 8;
   */
  name: string;

  /**
   * @generated from field: int32 algorithm = 9;
   */
  algorithm: number;
};

/**
 * Describes the message Authentication.UserAuthRequest.
 * Use `create(UserAuthRequestSchema)` to create a new message.
 */
export const UserAuthRequestSchema: GenMessage<UserAuthRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 34);

/**
 * @generated from message Authentication.UidRequest
 */
export type UidRequest = Message<"Authentication.UidRequest"> & {
  /**
   * @generated from field: repeated bytes uid = 1;
   */
  uid: Uint8Array[];
};

/**
 * Describes the message Authentication.UidRequest.
 * Use `create(UidRequestSchema)` to create a new message.
 */
export const UidRequestSchema: GenMessage<UidRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 35);

/**
 * @generated from message Authentication.DeviceUpdateRequest
 */
export type DeviceUpdateRequest = Message<"Authentication.DeviceUpdateRequest"> & {
  /**
   * @generated from field: bytes encryptedDeviceToken = 1;
   */
  encryptedDeviceToken: Uint8Array;

  /**
   * @generated from field: string clientVersion = 2;
   */
  clientVersion: string;

  /**
   * @generated from field: string deviceName = 3;
   */
  deviceName: string;

  /**
   * @generated from field: bytes devicePublicKey = 4;
   */
  devicePublicKey: Uint8Array;

  /**
   * @generated from field: Authentication.DeviceStatus deviceStatus = 5;
   */
  deviceStatus: DeviceStatus;

  /**
   * @generated from field: string devicePlatform = 6;
   */
  devicePlatform: string;

  /**
   * @generated from field: Authentication.ClientFormFactor clientFormFactor = 7;
   */
  clientFormFactor: ClientFormFactor;
};

/**
 * Describes the message Authentication.DeviceUpdateRequest.
 * Use `create(DeviceUpdateRequestSchema)` to create a new message.
 */
export const DeviceUpdateRequestSchema: GenMessage<DeviceUpdateRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 36);

/**
 * @generated from message Authentication.DeviceUpdateResponse
 */
export type DeviceUpdateResponse = Message<"Authentication.DeviceUpdateResponse"> & {
  /**
   * @generated from field: bytes encryptedDeviceToken = 1;
   */
  encryptedDeviceToken: Uint8Array;

  /**
   * @generated from field: string clientVersion = 2;
   */
  clientVersion: string;

  /**
   * @generated from field: string deviceName = 3;
   */
  deviceName: string;

  /**
   * @generated from field: bytes devicePublicKey = 4;
   */
  devicePublicKey: Uint8Array;

  /**
   * @generated from field: Authentication.DeviceStatus deviceStatus = 5;
   */
  deviceStatus: DeviceStatus;

  /**
   * @generated from field: string devicePlatform = 6;
   */
  devicePlatform: string;

  /**
   * @generated from field: Authentication.ClientFormFactor clientFormFactor = 7;
   */
  clientFormFactor: ClientFormFactor;
};

/**
 * Describes the message Authentication.DeviceUpdateResponse.
 * Use `create(DeviceUpdateResponseSchema)` to create a new message.
 */
export const DeviceUpdateResponseSchema: GenMessage<DeviceUpdateResponse> =
  /*@__PURE__*/
  messageDesc(file_api_request, 37);

/**
 * @generated from message Authentication.RegisterDeviceInRegionRequest
 */
export type RegisterDeviceInRegionRequest =
  Message<"Authentication.RegisterDeviceInRegionRequest"> & {
    /**
     * @generated from field: bytes encryptedDeviceToken = 1;
     */
    encryptedDeviceToken: Uint8Array;

    /**
     * @generated from field: string clientVersion = 2;
     */
    clientVersion: string;

    /**
     * @generated from field: string deviceName = 3;
     */
    deviceName: string;

    /**
     * @generated from field: bytes devicePublicKey = 4;
     */
    devicePublicKey: Uint8Array;

    /**
     * @generated from field: string devicePlatform = 5;
     */
    devicePlatform: string;

    /**
     * @generated from field: Authentication.ClientFormFactor clientFormFactor = 6;
     */
    clientFormFactor: ClientFormFactor;
  };

/**
 * Describes the message Authentication.RegisterDeviceInRegionRequest.
 * Use `create(RegisterDeviceInRegionRequestSchema)` to create a new message.
 */
export const RegisterDeviceInRegionRequestSchema: GenMessage<RegisterDeviceInRegionRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 38);

/**
 * @generated from message Authentication.RegistrationRequest
 */
export type RegistrationRequest = Message<"Authentication.RegistrationRequest"> & {
  /**
   * @generated from field: Authentication.AuthRequest authRequest = 1;
   */
  authRequest?: AuthRequest;

  /**
   * @generated from field: Authentication.UserAuthRequest userAuthRequest = 2;
   */
  userAuthRequest?: UserAuthRequest;

  /**
   * @generated from field: bytes encryptedClientKey = 3;
   */
  encryptedClientKey: Uint8Array;

  /**
   * @generated from field: bytes encryptedPrivateKey = 4;
   */
  encryptedPrivateKey: Uint8Array;

  /**
   * @generated from field: bytes publicKey = 5;
   */
  publicKey: Uint8Array;

  /**
   * @generated from field: string verificationCode = 6;
   */
  verificationCode: string;

  /**
   * @generated from field: bytes deprecatedAuthHashHash = 7;
   */
  deprecatedAuthHashHash: Uint8Array;

  /**
   * @generated from field: bytes deprecatedEncryptedClientKey = 8;
   */
  deprecatedEncryptedClientKey: Uint8Array;

  /**
   * @generated from field: bytes deprecatedEncryptedPrivateKey = 9;
   */
  deprecatedEncryptedPrivateKey: Uint8Array;

  /**
   * @generated from field: bytes deprecatedEncryptionParams = 10;
   */
  deprecatedEncryptionParams: Uint8Array;
};

/**
 * Describes the message Authentication.RegistrationRequest.
 * Use `create(RegistrationRequestSchema)` to create a new message.
 */
export const RegistrationRequestSchema: GenMessage<RegistrationRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 39);

/**
 * @generated from message Authentication.ConvertUserToV3Request
 */
export type ConvertUserToV3Request = Message<"Authentication.ConvertUserToV3Request"> & {
  /**
   * @generated from field: Authentication.AuthRequest authRequest = 1;
   */
  authRequest?: AuthRequest;

  /**
   * @generated from field: Authentication.UserAuthRequest userAuthRequest = 2;
   */
  userAuthRequest?: UserAuthRequest;

  /**
   * @generated from field: bytes encryptedClientKey = 3;
   */
  encryptedClientKey: Uint8Array;

  /**
   * @generated from field: bytes encryptedPrivateKey = 4;
   */
  encryptedPrivateKey: Uint8Array;

  /**
   * @generated from field: bytes publicKey = 5;
   */
  publicKey: Uint8Array;
};

/**
 * Describes the message Authentication.ConvertUserToV3Request.
 * Use `create(ConvertUserToV3RequestSchema)` to create a new message.
 */
export const ConvertUserToV3RequestSchema: GenMessage<ConvertUserToV3Request> =
  /*@__PURE__*/
  messageDesc(file_api_request, 40);

/**
 * @generated from message Authentication.RevisionResponse
 */
export type RevisionResponse = Message<"Authentication.RevisionResponse"> & {
  /**
   * @generated from field: int64 revision = 1;
   */
  revision: bigint;
};

/**
 * Describes the message Authentication.RevisionResponse.
 * Use `create(RevisionResponseSchema)` to create a new message.
 */
export const RevisionResponseSchema: GenMessage<RevisionResponse> =
  /*@__PURE__*/
  messageDesc(file_api_request, 41);

/**
 * @generated from message Authentication.ChangeEmailRequest
 */
export type ChangeEmailRequest = Message<"Authentication.ChangeEmailRequest"> & {
  /**
   * @generated from field: string newEmail = 1;
   */
  newEmail: string;
};

/**
 * Describes the message Authentication.ChangeEmailRequest.
 * Use `create(ChangeEmailRequestSchema)` to create a new message.
 */
export const ChangeEmailRequestSchema: GenMessage<ChangeEmailRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 42);

/**
 * @generated from message Authentication.ChangeEmailResponse
 */
export type ChangeEmailResponse = Message<"Authentication.ChangeEmailResponse"> & {
  /**
   * @generated from field: bytes encryptedChangeEmailToken = 1;
   */
  encryptedChangeEmailToken: Uint8Array;
};

/**
 * Describes the message Authentication.ChangeEmailResponse.
 * Use `create(ChangeEmailResponseSchema)` to create a new message.
 */
export const ChangeEmailResponseSchema: GenMessage<ChangeEmailResponse> =
  /*@__PURE__*/
  messageDesc(file_api_request, 43);

/**
 * @generated from message Authentication.EmailVerificationLinkResponse
 */
export type EmailVerificationLinkResponse =
  Message<"Authentication.EmailVerificationLinkResponse"> & {
    /**
     * @generated from field: bool emailVerified = 1;
     */
    emailVerified: boolean;
  };

/**
 * Describes the message Authentication.EmailVerificationLinkResponse.
 * Use `create(EmailVerificationLinkResponseSchema)` to create a new message.
 */
export const EmailVerificationLinkResponseSchema: GenMessage<EmailVerificationLinkResponse> =
  /*@__PURE__*/
  messageDesc(file_api_request, 44);

/**
 * @generated from message Authentication.SecurityData
 */
export type SecurityData = Message<"Authentication.SecurityData"> & {
  /**
   * @generated from field: bytes uid = 1;
   */
  uid: Uint8Array;

  /**
   * @generated from field: bytes data = 2;
   */
  data: Uint8Array;
};

/**
 * Describes the message Authentication.SecurityData.
 * Use `create(SecurityDataSchema)` to create a new message.
 */
export const SecurityDataSchema: GenMessage<SecurityData> =
  /*@__PURE__*/
  messageDesc(file_api_request, 45);

/**
 * @generated from message Authentication.SecurityScoreData
 */
export type SecurityScoreData = Message<"Authentication.SecurityScoreData"> & {
  /**
   * @generated from field: bytes uid = 1;
   */
  uid: Uint8Array;

  /**
   * @generated from field: bytes data = 2;
   */
  data: Uint8Array;

  /**
   * @generated from field: int64 revision = 3;
   */
  revision: bigint;
};

/**
 * Describes the message Authentication.SecurityScoreData.
 * Use `create(SecurityScoreDataSchema)` to create a new message.
 */
export const SecurityScoreDataSchema: GenMessage<SecurityScoreData> =
  /*@__PURE__*/
  messageDesc(file_api_request, 46);

/**
 * @generated from message Authentication.SecurityDataRequest
 */
export type SecurityDataRequest = Message<"Authentication.SecurityDataRequest"> & {
  /**
   * @generated from field: repeated Authentication.SecurityData recordSecurityData = 1;
   */
  recordSecurityData: SecurityData[];

  /**
   * @generated from field: repeated Authentication.SecurityData masterPasswordSecurityData = 2;
   */
  masterPasswordSecurityData: SecurityData[];

  /**
   * @generated from field: Enterprise.EncryptedKeyType encryptionType = 3;
   */
  encryptionType: EncryptedKeyType;

  /**
   * @generated from field: repeated Authentication.SecurityScoreData recordSecurityScoreData = 4;
   */
  recordSecurityScoreData: SecurityScoreData[];
};

/**
 * Describes the message Authentication.SecurityDataRequest.
 * Use `create(SecurityDataRequestSchema)` to create a new message.
 */
export const SecurityDataRequestSchema: GenMessage<SecurityDataRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 47);

/**
 * @generated from message Authentication.SecurityReportIncrementalData
 */
export type SecurityReportIncrementalData =
  Message<"Authentication.SecurityReportIncrementalData"> & {
    /**
     * @generated from field: int64 enterpriseUserId = 1;
     */
    enterpriseUserId: bigint;

    /**
     * @generated from field: bytes currentSecurityData = 2;
     */
    currentSecurityData: Uint8Array;

    /**
     * @generated from field: int64 currentSecurityDataRevision = 3;
     */
    currentSecurityDataRevision: bigint;

    /**
     * @generated from field: bytes oldSecurityData = 4;
     */
    oldSecurityData: Uint8Array;

    /**
     * @generated from field: int64 oldSecurityDataRevision = 5;
     */
    oldSecurityDataRevision: bigint;

    /**
     * @generated from field: Enterprise.EncryptedKeyType currentDataEncryptionType = 6;
     */
    currentDataEncryptionType: EncryptedKeyType;

    /**
     * @generated from field: Enterprise.EncryptedKeyType oldDataEncryptionType = 7;
     */
    oldDataEncryptionType: EncryptedKeyType;

    /**
     * @generated from field: bytes recordUid = 8;
     */
    recordUid: Uint8Array;
  };

/**
 * Describes the message Authentication.SecurityReportIncrementalData.
 * Use `create(SecurityReportIncrementalDataSchema)` to create a new message.
 */
export const SecurityReportIncrementalDataSchema: GenMessage<SecurityReportIncrementalData> =
  /*@__PURE__*/
  messageDesc(file_api_request, 48);

/**
 * @generated from message Authentication.SecurityReport
 */
export type SecurityReport = Message<"Authentication.SecurityReport"> & {
  /**
   * @generated from field: int64 enterpriseUserId = 1;
   */
  enterpriseUserId: bigint;

  /**
   * @generated from field: bytes encryptedReportData = 2;
   */
  encryptedReportData: Uint8Array;

  /**
   * @generated from field: int64 revision = 3;
   */
  revision: bigint;

  /**
   * @generated from field: string twoFactor = 4;
   */
  twoFactor: string;

  /**
   * @generated from field: int64 lastLogin = 5;
   */
  lastLogin: bigint;

  /**
   * @generated from field: int32 numberOfReusedPassword = 6;
   */
  numberOfReusedPassword: number;

  /**
   * @generated from field: repeated Authentication.SecurityReportIncrementalData securityReportIncrementalData = 7;
   */
  securityReportIncrementalData: SecurityReportIncrementalData[];

  /**
   * @generated from field: int32 userId = 8;
   */
  userId: number;

  /**
   * @generated from field: bool hasOldEncryption = 9;
   */
  hasOldEncryption: boolean;
};

/**
 * Describes the message Authentication.SecurityReport.
 * Use `create(SecurityReportSchema)` to create a new message.
 */
export const SecurityReportSchema: GenMessage<SecurityReport> =
  /*@__PURE__*/
  messageDesc(file_api_request, 49);

/**
 * @generated from message Authentication.SecurityReportSaveRequest
 */
export type SecurityReportSaveRequest = Message<"Authentication.SecurityReportSaveRequest"> & {
  /**
   * @generated from field: repeated Authentication.SecurityReport securityReport = 1;
   */
  securityReport: SecurityReport[];

  /**
   * @generated from field: bytes continuationToken = 2;
   */
  continuationToken: Uint8Array;
};

/**
 * Describes the message Authentication.SecurityReportSaveRequest.
 * Use `create(SecurityReportSaveRequestSchema)` to create a new message.
 */
export const SecurityReportSaveRequestSchema: GenMessage<SecurityReportSaveRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 50);

/**
 * @generated from message Authentication.SecurityReportRequest
 */
export type SecurityReportRequest = Message<"Authentication.SecurityReportRequest"> & {
  /**
   * @generated from field: int64 fromPage = 1;
   */
  fromPage: bigint;
};

/**
 * Describes the message Authentication.SecurityReportRequest.
 * Use `create(SecurityReportRequestSchema)` to create a new message.
 */
export const SecurityReportRequestSchema: GenMessage<SecurityReportRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 51);

/**
 * @generated from message Authentication.SecurityReportResponse
 */
export type SecurityReportResponse = Message<"Authentication.SecurityReportResponse"> & {
  /**
   * @generated from field: bytes enterprisePrivateKey = 1;
   */
  enterprisePrivateKey: Uint8Array;

  /**
   * @generated from field: repeated Authentication.SecurityReport securityReport = 2;
   */
  securityReport: SecurityReport[];

  /**
   * @generated from field: int64 asOfRevision = 3;
   */
  asOfRevision: bigint;

  /**
   * @generated from field: int64 fromPage = 4;
   */
  fromPage: bigint;

  /**
   * @generated from field: int64 toPage = 5;
   */
  toPage: bigint;

  /**
   * @generated from field: bool complete = 6;
   */
  complete: boolean;

  /**
   * @generated from field: bytes enterpriseEccPrivateKey = 7;
   */
  enterpriseEccPrivateKey: Uint8Array;

  /**
   * @generated from field: bool hasIncrementalData = 8;
   */
  hasIncrementalData: boolean;
};

/**
 * Describes the message Authentication.SecurityReportResponse.
 * Use `create(SecurityReportResponseSchema)` to create a new message.
 */
export const SecurityReportResponseSchema: GenMessage<SecurityReportResponse> =
  /*@__PURE__*/
  messageDesc(file_api_request, 52);

/**
 * @generated from message Authentication.IncrementalSecurityDataRequest
 */
export type IncrementalSecurityDataRequest =
  Message<"Authentication.IncrementalSecurityDataRequest"> & {
    /**
     * @generated from field: bytes continuationToken = 1;
     */
    continuationToken: Uint8Array;
  };

/**
 * Describes the message Authentication.IncrementalSecurityDataRequest.
 * Use `create(IncrementalSecurityDataRequestSchema)` to create a new message.
 */
export const IncrementalSecurityDataRequestSchema: GenMessage<IncrementalSecurityDataRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 53);

/**
 * @generated from message Authentication.IncrementalSecurityDataResponse
 */
export type IncrementalSecurityDataResponse =
  Message<"Authentication.IncrementalSecurityDataResponse"> & {
    /**
     * @generated from field: repeated Authentication.SecurityReportIncrementalData securityReportIncrementalData = 1;
     */
    securityReportIncrementalData: SecurityReportIncrementalData[];

    /**
     * @generated from field: bytes continuationToken = 2;
     */
    continuationToken: Uint8Array;
  };

/**
 * Describes the message Authentication.IncrementalSecurityDataResponse.
 * Use `create(IncrementalSecurityDataResponseSchema)` to create a new message.
 */
export const IncrementalSecurityDataResponseSchema: GenMessage<IncrementalSecurityDataResponse> =
  /*@__PURE__*/
  messageDesc(file_api_request, 54);

/**
 * @generated from message Authentication.ReusedPasswordsRequest
 */
export type ReusedPasswordsRequest = Message<"Authentication.ReusedPasswordsRequest"> & {
  /**
   * @generated from field: int32 count = 1;
   */
  count: number;
};

/**
 * Describes the message Authentication.ReusedPasswordsRequest.
 * Use `create(ReusedPasswordsRequestSchema)` to create a new message.
 */
export const ReusedPasswordsRequestSchema: GenMessage<ReusedPasswordsRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 55);

/**
 * @generated from message Authentication.SummaryConsoleReport
 */
export type SummaryConsoleReport = Message<"Authentication.SummaryConsoleReport"> & {
  /**
   * @generated from field: int32 reportType = 1;
   */
  reportType: number;

  /**
   * @generated from field: bytes reportData = 2;
   */
  reportData: Uint8Array;
};

/**
 * Describes the message Authentication.SummaryConsoleReport.
 * Use `create(SummaryConsoleReportSchema)` to create a new message.
 */
export const SummaryConsoleReportSchema: GenMessage<SummaryConsoleReport> =
  /*@__PURE__*/
  messageDesc(file_api_request, 56);

/**
 * @generated from message Authentication.ChangeToKeyTypeOne
 */
export type ChangeToKeyTypeOne = Message<"Authentication.ChangeToKeyTypeOne"> & {
  /**
   * @generated from field: Authentication.ObjectTypes objectType = 1;
   */
  objectType: ObjectTypes;

  /**
   * @generated from field: bytes primaryUid = 2;
   */
  primaryUid: Uint8Array;

  /**
   * @generated from field: bytes secondaryUid = 3;
   */
  secondaryUid: Uint8Array;

  /**
   * @generated from field: bytes key = 4;
   */
  key: Uint8Array;
};

/**
 * Describes the message Authentication.ChangeToKeyTypeOne.
 * Use `create(ChangeToKeyTypeOneSchema)` to create a new message.
 */
export const ChangeToKeyTypeOneSchema: GenMessage<ChangeToKeyTypeOne> =
  /*@__PURE__*/
  messageDesc(file_api_request, 57);

/**
 * @generated from message Authentication.ChangeToKeyTypeOneRequest
 */
export type ChangeToKeyTypeOneRequest = Message<"Authentication.ChangeToKeyTypeOneRequest"> & {
  /**
   * @generated from field: repeated Authentication.ChangeToKeyTypeOne changeToKeyTypeOne = 1;
   */
  changeToKeyTypeOne: ChangeToKeyTypeOne[];
};

/**
 * Describes the message Authentication.ChangeToKeyTypeOneRequest.
 * Use `create(ChangeToKeyTypeOneRequestSchema)` to create a new message.
 */
export const ChangeToKeyTypeOneRequestSchema: GenMessage<ChangeToKeyTypeOneRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 58);

/**
 * @generated from message Authentication.ChangeToKeyTypeOneStatus
 */
export type ChangeToKeyTypeOneStatus = Message<"Authentication.ChangeToKeyTypeOneStatus"> & {
  /**
   * @generated from field: bytes uid = 1;
   */
  uid: Uint8Array;

  /**
   * @generated from field: string type = 2;
   */
  type: string;

  /**
   * @generated from field: string status = 3;
   */
  status: string;

  /**
   * @generated from field: string reason = 4;
   */
  reason: string;
};

/**
 * Describes the message Authentication.ChangeToKeyTypeOneStatus.
 * Use `create(ChangeToKeyTypeOneStatusSchema)` to create a new message.
 */
export const ChangeToKeyTypeOneStatusSchema: GenMessage<ChangeToKeyTypeOneStatus> =
  /*@__PURE__*/
  messageDesc(file_api_request, 59);

/**
 * @generated from message Authentication.ChangeToKeyTypeOneResponse
 */
export type ChangeToKeyTypeOneResponse = Message<"Authentication.ChangeToKeyTypeOneResponse"> & {
  /**
   * @generated from field: repeated Authentication.ChangeToKeyTypeOneStatus changeToKeyTypeOneStatus = 1;
   */
  changeToKeyTypeOneStatus: ChangeToKeyTypeOneStatus[];
};

/**
 * Describes the message Authentication.ChangeToKeyTypeOneResponse.
 * Use `create(ChangeToKeyTypeOneResponseSchema)` to create a new message.
 */
export const ChangeToKeyTypeOneResponseSchema: GenMessage<ChangeToKeyTypeOneResponse> =
  /*@__PURE__*/
  messageDesc(file_api_request, 60);

/**
 * @generated from message Authentication.GetChangeKeyTypesRequest
 */
export type GetChangeKeyTypesRequest = Message<"Authentication.GetChangeKeyTypesRequest"> & {
  /**
   * @generated from field: repeated Authentication.EncryptedObjectType onlyTheseObjects = 1;
   */
  onlyTheseObjects: EncryptedObjectType[];

  /**
   * @generated from field: int32 limit = 2;
   */
  limit: number;

  /**
   * @generated from field: bool includeRecommended = 3;
   */
  includeRecommended: boolean;

  /**
   * @generated from field: bool includeKeys = 4;
   */
  includeKeys: boolean;

  /**
   * @generated from field: bool includeAllowedKeyTypes = 5;
   */
  includeAllowedKeyTypes: boolean;
};

/**
 * Describes the message Authentication.GetChangeKeyTypesRequest.
 * Use `create(GetChangeKeyTypesRequestSchema)` to create a new message.
 */
export const GetChangeKeyTypesRequestSchema: GenMessage<GetChangeKeyTypesRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 61);

/**
 * @generated from message Authentication.GetChangeKeyTypesResponse
 */
export type GetChangeKeyTypesResponse = Message<"Authentication.GetChangeKeyTypesResponse"> & {
  /**
   * @generated from field: repeated Authentication.ChangeKeyType keys = 1;
   */
  keys: ChangeKeyType[];

  /**
   * @generated from field: repeated Authentication.AllowedKeyTypes allowedKeyTypes = 2;
   */
  allowedKeyTypes: AllowedKeyTypes[];
};

/**
 * Describes the message Authentication.GetChangeKeyTypesResponse.
 * Use `create(GetChangeKeyTypesResponseSchema)` to create a new message.
 */
export const GetChangeKeyTypesResponseSchema: GenMessage<GetChangeKeyTypesResponse> =
  /*@__PURE__*/
  messageDesc(file_api_request, 62);

/**
 * @generated from message Authentication.AllowedKeyTypes
 */
export type AllowedKeyTypes = Message<"Authentication.AllowedKeyTypes"> & {
  /**
   * @generated from field: Authentication.EncryptedObjectType objectType = 1;
   */
  objectType: EncryptedObjectType;

  /**
   * @generated from field: repeated Enterprise.EncryptedKeyType allowedKeyTypes = 2;
   */
  allowedKeyTypes: EncryptedKeyType[];
};

/**
 * Describes the message Authentication.AllowedKeyTypes.
 * Use `create(AllowedKeyTypesSchema)` to create a new message.
 */
export const AllowedKeyTypesSchema: GenMessage<AllowedKeyTypes> =
  /*@__PURE__*/
  messageDesc(file_api_request, 63);

/**
 * @generated from message Authentication.ChangeKeyTypes
 */
export type ChangeKeyTypes = Message<"Authentication.ChangeKeyTypes"> & {
  /**
   * @generated from field: repeated Authentication.ChangeKeyType keys = 1;
   */
  keys: ChangeKeyType[];
};

/**
 * Describes the message Authentication.ChangeKeyTypes.
 * Use `create(ChangeKeyTypesSchema)` to create a new message.
 */
export const ChangeKeyTypesSchema: GenMessage<ChangeKeyTypes> =
  /*@__PURE__*/
  messageDesc(file_api_request, 64);

/**
 * @generated from message Authentication.ChangeKeyType
 */
export type ChangeKeyType = Message<"Authentication.ChangeKeyType"> & {
  /**
   * @generated from field: Authentication.EncryptedObjectType objectType = 1;
   */
  objectType: EncryptedObjectType;

  /**
   * @generated from field: bytes uid = 2;
   */
  uid: Uint8Array;

  /**
   * @generated from field: bytes secondaryUid = 3;
   */
  secondaryUid: Uint8Array;

  /**
   * @generated from field: bytes key = 4;
   */
  key: Uint8Array;

  /**
   * @generated from field: Enterprise.EncryptedKeyType keyType = 5;
   */
  keyType: EncryptedKeyType;

  /**
   * @generated from field: Authentication.GenericStatus status = 6;
   */
  status: GenericStatus;
};

/**
 * Describes the message Authentication.ChangeKeyType.
 * Use `create(ChangeKeyTypeSchema)` to create a new message.
 */
export const ChangeKeyTypeSchema: GenMessage<ChangeKeyType> =
  /*@__PURE__*/
  messageDesc(file_api_request, 65);

/**
 * @generated from message Authentication.SetKey
 */
export type SetKey = Message<"Authentication.SetKey"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: bytes key = 2;
   */
  key: Uint8Array;
};

/**
 * Describes the message Authentication.SetKey.
 * Use `create(SetKeySchema)` to create a new message.
 */
export const SetKeySchema: GenMessage<SetKey> = /*@__PURE__*/ messageDesc(file_api_request, 66);

/**
 * @generated from message Authentication.SetKeyRequest
 */
export type SetKeyRequest = Message<"Authentication.SetKeyRequest"> & {
  /**
   * @generated from field: repeated Authentication.SetKey keys = 1;
   */
  keys: SetKey[];
};

/**
 * Describes the message Authentication.SetKeyRequest.
 * Use `create(SetKeyRequestSchema)` to create a new message.
 */
export const SetKeyRequestSchema: GenMessage<SetKeyRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 67);

/**
 * @generated from message Authentication.CreateUserRequest
 */
export type CreateUserRequest = Message<"Authentication.CreateUserRequest"> & {
  /**
   * @generated from field: string username = 1;
   */
  username: string;

  /**
   * @generated from field: bytes authVerifier = 2;
   */
  authVerifier: Uint8Array;

  /**
   * @generated from field: bytes encryptionParams = 3;
   */
  encryptionParams: Uint8Array;

  /**
   * @generated from field: bytes rsaPublicKey = 4;
   */
  rsaPublicKey: Uint8Array;

  /**
   * @generated from field: bytes rsaEncryptedPrivateKey = 5;
   */
  rsaEncryptedPrivateKey: Uint8Array;

  /**
   * @generated from field: bytes eccPublicKey = 6;
   */
  eccPublicKey: Uint8Array;

  /**
   * @generated from field: bytes eccEncryptedPrivateKey = 7;
   */
  eccEncryptedPrivateKey: Uint8Array;

  /**
   * @generated from field: bytes encryptedDeviceToken = 8;
   */
  encryptedDeviceToken: Uint8Array;

  /**
   * @generated from field: bytes encryptedClientKey = 9;
   */
  encryptedClientKey: Uint8Array;

  /**
   * @generated from field: string clientVersion = 10;
   */
  clientVersion: string;

  /**
   * @generated from field: bytes encryptedDeviceDataKey = 11;
   */
  encryptedDeviceDataKey: Uint8Array;

  /**
   * @generated from field: bytes encryptedLoginToken = 12;
   */
  encryptedLoginToken: Uint8Array;

  /**
   * @generated from field: bytes messageSessionUid = 13;
   */
  messageSessionUid: Uint8Array;

  /**
   * @generated from field: string installReferrer = 14;
   */
  installReferrer: string;

  /**
   * @generated from field: int32 mccMNC = 15;
   */
  mccMNC: number;

  /**
   * @generated from field: string mfg = 16;
   */
  mfg: string;

  /**
   * @generated from field: string model = 17;
   */
  model: string;

  /**
   * @generated from field: string brand = 18;
   */
  brand: string;

  /**
   * @generated from field: string product = 19;
   */
  product: string;

  /**
   * @generated from field: string device = 20;
   */
  device: string;

  /**
   * @generated from field: string carrier = 21;
   */
  carrier: string;

  /**
   * @generated from field: string verificationCode = 22;
   */
  verificationCode: string;

  /**
   * @generated from field: Enterprise.EnterpriseRegistration enterpriseRegistration = 23;
   */
  enterpriseRegistration?: EnterpriseRegistration;

  /**
   * @generated from field: bytes encryptedVerificationToken = 24;
   */
  encryptedVerificationToken: Uint8Array;

  /**
   * @generated from field: bytes enterpriseUsersDataKey = 25;
   */
  enterpriseUsersDataKey: Uint8Array;
};

/**
 * Describes the message Authentication.CreateUserRequest.
 * Use `create(CreateUserRequestSchema)` to create a new message.
 */
export const CreateUserRequestSchema: GenMessage<CreateUserRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 68);

/**
 * @generated from message Authentication.NodeEnforcementAddOrUpdateRequest
 */
export type NodeEnforcementAddOrUpdateRequest =
  Message<"Authentication.NodeEnforcementAddOrUpdateRequest"> & {
    /**
     * @generated from field: int64 nodeId = 1;
     */
    nodeId: bigint;

    /**
     * @generated from field: string enforcement = 2;
     */
    enforcement: string;

    /**
     * @generated from field: string value = 3;
     */
    value: string;
  };

/**
 * Describes the message Authentication.NodeEnforcementAddOrUpdateRequest.
 * Use `create(NodeEnforcementAddOrUpdateRequestSchema)` to create a new message.
 */
export const NodeEnforcementAddOrUpdateRequestSchema: GenMessage<NodeEnforcementAddOrUpdateRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 69);

/**
 * @generated from message Authentication.NodeEnforcementRemoveRequest
 */
export type NodeEnforcementRemoveRequest =
  Message<"Authentication.NodeEnforcementRemoveRequest"> & {
    /**
     * @generated from field: int64 nodeId = 1;
     */
    nodeId: bigint;

    /**
     * @generated from field: string enforcement = 2;
     */
    enforcement: string;
  };

/**
 * Describes the message Authentication.NodeEnforcementRemoveRequest.
 * Use `create(NodeEnforcementRemoveRequestSchema)` to create a new message.
 */
export const NodeEnforcementRemoveRequestSchema: GenMessage<NodeEnforcementRemoveRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 70);

/**
 * @generated from message Authentication.ApiRequestByKey
 */
export type ApiRequestByKey = Message<"Authentication.ApiRequestByKey"> & {
  /**
   * @generated from field: int32 keyId = 1;
   */
  keyId: number;

  /**
   * @generated from field: bytes payload = 2;
   */
  payload: Uint8Array;

  /**
   * @generated from field: string username = 3;
   */
  username: string;

  /**
   * @generated from field: string locale = 4;
   */
  locale: string;

  /**
   * @generated from field: Authentication.SupportedLanguage supportedLanguage = 5;
   */
  supportedLanguage: SupportedLanguage;

  /**
   * @generated from field: int32 type = 6;
   */
  type: number;
};

/**
 * Describes the message Authentication.ApiRequestByKey.
 * Use `create(ApiRequestByKeySchema)` to create a new message.
 */
export const ApiRequestByKeySchema: GenMessage<ApiRequestByKey> =
  /*@__PURE__*/
  messageDesc(file_api_request, 71);

/**
 * @generated from message Authentication.ApiRequestByKAtoKAKey
 */
export type ApiRequestByKAtoKAKey = Message<"Authentication.ApiRequestByKAtoKAKey"> & {
  /**
   * @generated from field: Authentication.Region sourceRegion = 1;
   */
  sourceRegion: Region;

  /**
   * @generated from field: bytes payload = 2;
   */
  payload: Uint8Array;

  /**
   * @generated from field: Authentication.SupportedLanguage supportedLanguage = 3;
   */
  supportedLanguage: SupportedLanguage;

  /**
   * @generated from field: Authentication.Region destinationRegion = 4;
   */
  destinationRegion: Region;
};

/**
 * Describes the message Authentication.ApiRequestByKAtoKAKey.
 * Use `create(ApiRequestByKAtoKAKeySchema)` to create a new message.
 */
export const ApiRequestByKAtoKAKeySchema: GenMessage<ApiRequestByKAtoKAKey> =
  /*@__PURE__*/
  messageDesc(file_api_request, 72);

/**
 * @generated from message Authentication.MemcacheRequest
 */
export type MemcacheRequest = Message<"Authentication.MemcacheRequest"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * @generated from field: int32 userId = 2;
   */
  userId: number;
};

/**
 * Describes the message Authentication.MemcacheRequest.
 * Use `create(MemcacheRequestSchema)` to create a new message.
 */
export const MemcacheRequestSchema: GenMessage<MemcacheRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 73);

/**
 * @generated from message Authentication.MemcacheResponse
 */
export type MemcacheResponse = Message<"Authentication.MemcacheResponse"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * @generated from field: string value = 2;
   */
  value: string;
};

/**
 * Describes the message Authentication.MemcacheResponse.
 * Use `create(MemcacheResponseSchema)` to create a new message.
 */
export const MemcacheResponseSchema: GenMessage<MemcacheResponse> =
  /*@__PURE__*/
  messageDesc(file_api_request, 74);

/**
 * @generated from message Authentication.MasterPasswordReentryRequest
 */
export type MasterPasswordReentryRequest =
  Message<"Authentication.MasterPasswordReentryRequest"> & {
    /**
     * @generated from field: string pbkdf2Password = 1;
     */
    pbkdf2Password: string;

    /**
     * @generated from field: Authentication.MasterPasswordReentryActionType action = 2;
     */
    action: MasterPasswordReentryActionType;
  };

/**
 * Describes the message Authentication.MasterPasswordReentryRequest.
 * Use `create(MasterPasswordReentryRequestSchema)` to create a new message.
 */
export const MasterPasswordReentryRequestSchema: GenMessage<MasterPasswordReentryRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 75);

/**
 * @generated from message Authentication.MasterPasswordReentryResponse
 */
export type MasterPasswordReentryResponse =
  Message<"Authentication.MasterPasswordReentryResponse"> & {
    /**
     * @generated from field: Authentication.MasterPasswordReentryStatus status = 1;
     */
    status: MasterPasswordReentryStatus;
  };

/**
 * Describes the message Authentication.MasterPasswordReentryResponse.
 * Use `create(MasterPasswordReentryResponseSchema)` to create a new message.
 */
export const MasterPasswordReentryResponseSchema: GenMessage<MasterPasswordReentryResponse> =
  /*@__PURE__*/
  messageDesc(file_api_request, 76);

/**
 * @generated from message Authentication.DeviceRegistrationRequest
 */
export type DeviceRegistrationRequest = Message<"Authentication.DeviceRegistrationRequest"> & {
  /**
   * @generated from field: string clientVersion = 1;
   */
  clientVersion: string;

  /**
   * @generated from field: string deviceName = 2;
   */
  deviceName: string;

  /**
   * @generated from field: bytes devicePublicKey = 3;
   */
  devicePublicKey: Uint8Array;

  /**
   * @generated from field: string devicePlatform = 4;
   */
  devicePlatform: string;

  /**
   * @generated from field: Authentication.ClientFormFactor clientFormFactor = 5;
   */
  clientFormFactor: ClientFormFactor;
};

/**
 * Describes the message Authentication.DeviceRegistrationRequest.
 * Use `create(DeviceRegistrationRequestSchema)` to create a new message.
 */
export const DeviceRegistrationRequestSchema: GenMessage<DeviceRegistrationRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 77);

/**
 * @generated from message Authentication.DeviceVerificationRequest
 */
export type DeviceVerificationRequest = Message<"Authentication.DeviceVerificationRequest"> & {
  /**
   * @generated from field: bytes encryptedDeviceToken = 1;
   */
  encryptedDeviceToken: Uint8Array;

  /**
   * @generated from field: string username = 2;
   */
  username: string;

  /**
   * @generated from field: string verificationChannel = 3;
   */
  verificationChannel: string;

  /**
   * @generated from field: bytes messageSessionUid = 4;
   */
  messageSessionUid: Uint8Array;

  /**
   * @generated from field: string clientVersion = 5;
   */
  clientVersion: string;
};

/**
 * Describes the message Authentication.DeviceVerificationRequest.
 * Use `create(DeviceVerificationRequestSchema)` to create a new message.
 */
export const DeviceVerificationRequestSchema: GenMessage<DeviceVerificationRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 78);

/**
 * @generated from message Authentication.DeviceVerificationResponse
 */
export type DeviceVerificationResponse = Message<"Authentication.DeviceVerificationResponse"> & {
  /**
   * @generated from field: bytes encryptedDeviceToken = 1;
   */
  encryptedDeviceToken: Uint8Array;

  /**
   * @generated from field: string username = 2;
   */
  username: string;

  /**
   * @generated from field: bytes messageSessionUid = 3;
   */
  messageSessionUid: Uint8Array;

  /**
   * @generated from field: string clientVersion = 4;
   */
  clientVersion: string;

  /**
   * @generated from field: Authentication.DeviceStatus deviceStatus = 5;
   */
  deviceStatus: DeviceStatus;
};

/**
 * Describes the message Authentication.DeviceVerificationResponse.
 * Use `create(DeviceVerificationResponseSchema)` to create a new message.
 */
export const DeviceVerificationResponseSchema: GenMessage<DeviceVerificationResponse> =
  /*@__PURE__*/
  messageDesc(file_api_request, 79);

/**
 * @generated from message Authentication.DeviceApprovalRequest
 */
export type DeviceApprovalRequest = Message<"Authentication.DeviceApprovalRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * @generated from field: string twoFactorChannel = 2;
   */
  twoFactorChannel: string;

  /**
   * @generated from field: string clientVersion = 3;
   */
  clientVersion: string;

  /**
   * @generated from field: string locale = 4;
   */
  locale: string;

  /**
   * @generated from field: bytes encryptedDeviceToken = 5;
   */
  encryptedDeviceToken: Uint8Array;

  /**
   * @generated from field: string totpCode = 6;
   */
  totpCode: string;

  /**
   * @generated from field: string deviceIp = 7;
   */
  deviceIp: string;

  /**
   * @generated from field: string deviceTokenExpireDays = 8;
   */
  deviceTokenExpireDays: string;
};

/**
 * Describes the message Authentication.DeviceApprovalRequest.
 * Use `create(DeviceApprovalRequestSchema)` to create a new message.
 */
export const DeviceApprovalRequestSchema: GenMessage<DeviceApprovalRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 80);

/**
 * @generated from message Authentication.DeviceApprovalResponse
 */
export type DeviceApprovalResponse = Message<"Authentication.DeviceApprovalResponse"> & {
  /**
   * @generated from field: bytes encryptedTwoFactorToken = 1;
   */
  encryptedTwoFactorToken: Uint8Array;
};

/**
 * Describes the message Authentication.DeviceApprovalResponse.
 * Use `create(DeviceApprovalResponseSchema)` to create a new message.
 */
export const DeviceApprovalResponseSchema: GenMessage<DeviceApprovalResponse> =
  /*@__PURE__*/
  messageDesc(file_api_request, 81);

/**
 * @generated from message Authentication.ApproveDeviceRequest
 */
export type ApproveDeviceRequest = Message<"Authentication.ApproveDeviceRequest"> & {
  /**
   * @generated from field: bytes encryptedDeviceToken = 1;
   */
  encryptedDeviceToken: Uint8Array;

  /**
   * @generated from field: bytes encryptedDeviceDataKey = 2;
   */
  encryptedDeviceDataKey: Uint8Array;

  /**
   * @generated from field: bool denyApproval = 3;
   */
  denyApproval: boolean;

  /**
   * @generated from field: bool linkDevice = 4;
   */
  linkDevice: boolean;
};

/**
 * Describes the message Authentication.ApproveDeviceRequest.
 * Use `create(ApproveDeviceRequestSchema)` to create a new message.
 */
export const ApproveDeviceRequestSchema: GenMessage<ApproveDeviceRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 82);

/**
 * @generated from message Authentication.EnterpriseUserAliasRequest
 */
export type EnterpriseUserAliasRequest = Message<"Authentication.EnterpriseUserAliasRequest"> & {
  /**
   * @generated from field: int64 enterpriseUserId = 1;
   */
  enterpriseUserId: bigint;

  /**
   * @generated from field: string alias = 2;
   */
  alias: string;
};

/**
 * Describes the message Authentication.EnterpriseUserAliasRequest.
 * Use `create(EnterpriseUserAliasRequestSchema)` to create a new message.
 */
export const EnterpriseUserAliasRequestSchema: GenMessage<EnterpriseUserAliasRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 83);

/**
 * @generated from message Authentication.EnterpriseUserAddAliasRequest
 */
export type EnterpriseUserAddAliasRequest =
  Message<"Authentication.EnterpriseUserAddAliasRequest"> & {
    /**
     * @generated from field: int64 enterpriseUserId = 1;
     */
    enterpriseUserId: bigint;

    /**
     * @generated from field: string alias = 2;
     */
    alias: string;

    /**
     * @generated from field: bool primary = 3;
     */
    primary: boolean;
  };

/**
 * Describes the message Authentication.EnterpriseUserAddAliasRequest.
 * Use `create(EnterpriseUserAddAliasRequestSchema)` to create a new message.
 */
export const EnterpriseUserAddAliasRequestSchema: GenMessage<EnterpriseUserAddAliasRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 84);

/**
 * @generated from message Authentication.EnterpriseUserAddAliasRequestV2
 */
export type EnterpriseUserAddAliasRequestV2 =
  Message<"Authentication.EnterpriseUserAddAliasRequestV2"> & {
    /**
     * @generated from field: repeated Authentication.EnterpriseUserAddAliasRequest enterpriseUserAddAliasRequest = 1;
     */
    enterpriseUserAddAliasRequest: EnterpriseUserAddAliasRequest[];
  };

/**
 * Describes the message Authentication.EnterpriseUserAddAliasRequestV2.
 * Use `create(EnterpriseUserAddAliasRequestV2Schema)` to create a new message.
 */
export const EnterpriseUserAddAliasRequestV2Schema: GenMessage<EnterpriseUserAddAliasRequestV2> =
  /*@__PURE__*/
  messageDesc(file_api_request, 85);

/**
 * @generated from message Authentication.EnterpriseUserAddAliasStatus
 */
export type EnterpriseUserAddAliasStatus =
  Message<"Authentication.EnterpriseUserAddAliasStatus"> & {
    /**
     * @generated from field: int64 enterpriseUserId = 1;
     */
    enterpriseUserId: bigint;

    /**
     * @generated from field: string status = 2;
     */
    status: string;
  };

/**
 * Describes the message Authentication.EnterpriseUserAddAliasStatus.
 * Use `create(EnterpriseUserAddAliasStatusSchema)` to create a new message.
 */
export const EnterpriseUserAddAliasStatusSchema: GenMessage<EnterpriseUserAddAliasStatus> =
  /*@__PURE__*/
  messageDesc(file_api_request, 86);

/**
 * @generated from message Authentication.EnterpriseUserAddAliasResponse
 */
export type EnterpriseUserAddAliasResponse =
  Message<"Authentication.EnterpriseUserAddAliasResponse"> & {
    /**
     * @generated from field: repeated Authentication.EnterpriseUserAddAliasStatus status = 1;
     */
    status: EnterpriseUserAddAliasStatus[];
  };

/**
 * Describes the message Authentication.EnterpriseUserAddAliasResponse.
 * Use `create(EnterpriseUserAddAliasResponseSchema)` to create a new message.
 */
export const EnterpriseUserAddAliasResponseSchema: GenMessage<EnterpriseUserAddAliasResponse> =
  /*@__PURE__*/
  messageDesc(file_api_request, 87);

/**
 * @generated from message Authentication.Device
 */
export type Device = Message<"Authentication.Device"> & {
  /**
   * @generated from field: bytes encryptedDeviceToken = 1;
   */
  encryptedDeviceToken: Uint8Array;
};

/**
 * Describes the message Authentication.Device.
 * Use `create(DeviceSchema)` to create a new message.
 */
export const DeviceSchema: GenMessage<Device> = /*@__PURE__*/ messageDesc(file_api_request, 88);

/**
 * @generated from message Authentication.RegisterDeviceDataKeyRequest
 */
export type RegisterDeviceDataKeyRequest =
  Message<"Authentication.RegisterDeviceDataKeyRequest"> & {
    /**
     * @generated from field: bytes encryptedDeviceToken = 1;
     */
    encryptedDeviceToken: Uint8Array;

    /**
     * @generated from field: bytes encryptedDeviceDataKey = 2;
     */
    encryptedDeviceDataKey: Uint8Array;
  };

/**
 * Describes the message Authentication.RegisterDeviceDataKeyRequest.
 * Use `create(RegisterDeviceDataKeyRequestSchema)` to create a new message.
 */
export const RegisterDeviceDataKeyRequestSchema: GenMessage<RegisterDeviceDataKeyRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 89);

/**
 * @generated from message Authentication.ValidateCreateUserVerificationCodeRequest
 */
export type ValidateCreateUserVerificationCodeRequest =
  Message<"Authentication.ValidateCreateUserVerificationCodeRequest"> & {
    /**
     * @generated from field: string username = 1;
     */
    username: string;

    /**
     * @generated from field: string clientVersion = 2;
     */
    clientVersion: string;

    /**
     * @generated from field: string verificationCode = 3;
     */
    verificationCode: string;
  };

/**
 * Describes the message Authentication.ValidateCreateUserVerificationCodeRequest.
 * Use `create(ValidateCreateUserVerificationCodeRequestSchema)` to create a new message.
 */
export const ValidateCreateUserVerificationCodeRequestSchema: GenMessage<ValidateCreateUserVerificationCodeRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 90);

/**
 * @generated from message Authentication.ValidateDeviceVerificationCodeRequest
 */
export type ValidateDeviceVerificationCodeRequest =
  Message<"Authentication.ValidateDeviceVerificationCodeRequest"> & {
    /**
     * @generated from field: string username = 1;
     */
    username: string;

    /**
     * @generated from field: string clientVersion = 2;
     */
    clientVersion: string;

    /**
     * @generated from field: string verificationCode = 3;
     */
    verificationCode: string;

    /**
     * @generated from field: bytes messageSessionUid = 4;
     */
    messageSessionUid: Uint8Array;

    /**
     * @generated from field: bytes encryptedDeviceToken = 5;
     */
    encryptedDeviceToken: Uint8Array;
  };

/**
 * Describes the message Authentication.ValidateDeviceVerificationCodeRequest.
 * Use `create(ValidateDeviceVerificationCodeRequestSchema)` to create a new message.
 */
export const ValidateDeviceVerificationCodeRequestSchema: GenMessage<ValidateDeviceVerificationCodeRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 91);

/**
 * @generated from message Authentication.SendSessionMessageRequest
 */
export type SendSessionMessageRequest = Message<"Authentication.SendSessionMessageRequest"> & {
  /**
   * @generated from field: bytes messageSessionUid = 1;
   */
  messageSessionUid: Uint8Array;

  /**
   * @generated from field: string command = 2;
   */
  command: string;

  /**
   * @generated from field: string username = 3;
   */
  username: string;
};

/**
 * Describes the message Authentication.SendSessionMessageRequest.
 * Use `create(SendSessionMessageRequestSchema)` to create a new message.
 */
export const SendSessionMessageRequestSchema: GenMessage<SendSessionMessageRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 92);

/**
 * @generated from message Authentication.GlobalUserAccount
 */
export type GlobalUserAccount = Message<"Authentication.GlobalUserAccount"> & {
  /**
   * @generated from field: string username = 1;
   */
  username: string;

  /**
   * @generated from field: bytes accountUid = 2;
   */
  accountUid: Uint8Array;

  /**
   * @generated from field: string regionName = 3;
   */
  regionName: string;
};

/**
 * Describes the message Authentication.GlobalUserAccount.
 * Use `create(GlobalUserAccountSchema)` to create a new message.
 */
export const GlobalUserAccountSchema: GenMessage<GlobalUserAccount> =
  /*@__PURE__*/
  messageDesc(file_api_request, 93);

/**
 * @generated from message Authentication.AccountUsername
 */
export type AccountUsername = Message<"Authentication.AccountUsername"> & {
  /**
   * @generated from field: string username = 1;
   */
  username: string;

  /**
   * @generated from field: string dateActive = 2;
   */
  dateActive: string;
};

/**
 * Describes the message Authentication.AccountUsername.
 * Use `create(AccountUsernameSchema)` to create a new message.
 */
export const AccountUsernameSchema: GenMessage<AccountUsername> =
  /*@__PURE__*/
  messageDesc(file_api_request, 94);

/**
 * @generated from message Authentication.SsoServiceProviderRequest
 */
export type SsoServiceProviderRequest = Message<"Authentication.SsoServiceProviderRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string clientVersion = 2;
   */
  clientVersion: string;

  /**
   * @generated from field: string locale = 3;
   */
  locale: string;
};

/**
 * Describes the message Authentication.SsoServiceProviderRequest.
 * Use `create(SsoServiceProviderRequestSchema)` to create a new message.
 */
export const SsoServiceProviderRequestSchema: GenMessage<SsoServiceProviderRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 95);

/**
 * @generated from message Authentication.SsoServiceProviderResponse
 */
export type SsoServiceProviderResponse = Message<"Authentication.SsoServiceProviderResponse"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string spUrl = 2;
   */
  spUrl: string;

  /**
   * @generated from field: bool isCloud = 3;
   */
  isCloud: boolean;

  /**
   * @generated from field: string clientVersion = 4;
   */
  clientVersion: string;
};

/**
 * Describes the message Authentication.SsoServiceProviderResponse.
 * Use `create(SsoServiceProviderResponseSchema)` to create a new message.
 */
export const SsoServiceProviderResponseSchema: GenMessage<SsoServiceProviderResponse> =
  /*@__PURE__*/
  messageDesc(file_api_request, 96);

/**
 * @generated from message Authentication.UserSettingRequest
 */
export type UserSettingRequest = Message<"Authentication.UserSettingRequest"> & {
  /**
   * @generated from field: string setting = 1;
   */
  setting: string;

  /**
   * @generated from field: string value = 2;
   */
  value: string;
};

/**
 * Describes the message Authentication.UserSettingRequest.
 * Use `create(UserSettingRequestSchema)` to create a new message.
 */
export const UserSettingRequestSchema: GenMessage<UserSettingRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 97);

/**
 * @generated from message Authentication.ThrottleState
 */
export type ThrottleState = Message<"Authentication.ThrottleState"> & {
  /**
   * @generated from field: Authentication.ThrottleType type = 1;
   */
  type: ThrottleType;

  /**
   * @generated from field: string key = 2;
   */
  key: string;

  /**
   * @generated from field: string value = 3;
   */
  value: string;

  /**
   * @generated from field: bool state = 4;
   */
  state: boolean;
};

/**
 * Describes the message Authentication.ThrottleState.
 * Use `create(ThrottleStateSchema)` to create a new message.
 */
export const ThrottleStateSchema: GenMessage<ThrottleState> =
  /*@__PURE__*/
  messageDesc(file_api_request, 98);

/**
 * @generated from message Authentication.ThrottleState2
 */
export type ThrottleState2 = Message<"Authentication.ThrottleState2"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * @generated from field: string keyDescription = 2;
   */
  keyDescription: string;

  /**
   * @generated from field: string value = 3;
   */
  value: string;

  /**
   * @generated from field: string valueDescription = 4;
   */
  valueDescription: string;

  /**
   * @generated from field: string identifier = 5;
   */
  identifier: string;

  /**
   * @generated from field: bool locked = 6;
   */
  locked: boolean;

  /**
   * @generated from field: bool includedInAllClear = 7;
   */
  includedInAllClear: boolean;

  /**
   * @generated from field: int32 expireSeconds = 8;
   */
  expireSeconds: number;
};

/**
 * Describes the message Authentication.ThrottleState2.
 * Use `create(ThrottleState2Schema)` to create a new message.
 */
export const ThrottleState2Schema: GenMessage<ThrottleState2> =
  /*@__PURE__*/
  messageDesc(file_api_request, 99);

/**
 * @generated from message Authentication.DeviceInformation
 */
export type DeviceInformation = Message<"Authentication.DeviceInformation"> & {
  /**
   * @generated from field: int64 deviceId = 1;
   */
  deviceId: bigint;

  /**
   * @generated from field: string deviceName = 2;
   */
  deviceName: string;

  /**
   * @generated from field: string clientVersion = 3;
   */
  clientVersion: string;

  /**
   * @generated from field: int64 lastLogin = 4;
   */
  lastLogin: bigint;

  /**
   * @generated from field: Authentication.DeviceStatus deviceStatus = 5;
   */
  deviceStatus: DeviceStatus;
};

/**
 * Describes the message Authentication.DeviceInformation.
 * Use `create(DeviceInformationSchema)` to create a new message.
 */
export const DeviceInformationSchema: GenMessage<DeviceInformation> =
  /*@__PURE__*/
  messageDesc(file_api_request, 100);

/**
 * @generated from message Authentication.UserSetting
 */
export type UserSetting = Message<"Authentication.UserSetting"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: bool value = 2;
   */
  value: boolean;
};

/**
 * Describes the message Authentication.UserSetting.
 * Use `create(UserSettingSchema)` to create a new message.
 */
export const UserSettingSchema: GenMessage<UserSetting> =
  /*@__PURE__*/
  messageDesc(file_api_request, 101);

/**
 * @generated from message Authentication.UserDataKeyRequest
 */
export type UserDataKeyRequest = Message<"Authentication.UserDataKeyRequest"> & {
  /**
   * @generated from field: repeated int64 enterpriseUserId = 1;
   */
  enterpriseUserId: bigint[];
};

/**
 * Describes the message Authentication.UserDataKeyRequest.
 * Use `create(UserDataKeyRequestSchema)` to create a new message.
 */
export const UserDataKeyRequestSchema: GenMessage<UserDataKeyRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 102);

/**
 * @generated from message Authentication.UserDataKeyByNodeRequest
 */
export type UserDataKeyByNodeRequest = Message<"Authentication.UserDataKeyByNodeRequest"> & {
  /**
   * @generated from field: repeated int64 nodeIds = 1;
   */
  nodeIds: bigint[];
};

/**
 * Describes the message Authentication.UserDataKeyByNodeRequest.
 * Use `create(UserDataKeyByNodeRequestSchema)` to create a new message.
 */
export const UserDataKeyByNodeRequestSchema: GenMessage<UserDataKeyByNodeRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 103);

/**
 * @generated from message Authentication.EnterpriseUserIdDataKeyPair
 */
export type EnterpriseUserIdDataKeyPair = Message<"Authentication.EnterpriseUserIdDataKeyPair"> & {
  /**
   * @generated from field: int64 enterpriseUserId = 1;
   */
  enterpriseUserId: bigint;

  /**
   * @generated from field: bytes encryptedDataKey = 2;
   */
  encryptedDataKey: Uint8Array;

  /**
   * @generated from field: Enterprise.EncryptedKeyType keyType = 3;
   */
  keyType: EncryptedKeyType;
};

/**
 * Describes the message Authentication.EnterpriseUserIdDataKeyPair.
 * Use `create(EnterpriseUserIdDataKeyPairSchema)` to create a new message.
 */
export const EnterpriseUserIdDataKeyPairSchema: GenMessage<EnterpriseUserIdDataKeyPair> =
  /*@__PURE__*/
  messageDesc(file_api_request, 104);

/**
 * @generated from message Authentication.UserDataKey
 */
export type UserDataKey = Message<"Authentication.UserDataKey"> & {
  /**
   * @generated from field: int64 roleId = 1;
   */
  roleId: bigint;

  /**
   * @generated from field: bytes roleKey = 2;
   */
  roleKey: Uint8Array;

  /**
   * @generated from field: string privateKey = 3;
   */
  privateKey: string;

  /**
   * @generated from field: repeated Authentication.EnterpriseUserIdDataKeyPair enterpriseUserIdDataKeyPairs = 4;
   */
  enterpriseUserIdDataKeyPairs: EnterpriseUserIdDataKeyPair[];
};

/**
 * Describes the message Authentication.UserDataKey.
 * Use `create(UserDataKeySchema)` to create a new message.
 */
export const UserDataKeySchema: GenMessage<UserDataKey> =
  /*@__PURE__*/
  messageDesc(file_api_request, 105);

/**
 * @generated from message Authentication.UserDataKeyResponse
 */
export type UserDataKeyResponse = Message<"Authentication.UserDataKeyResponse"> & {
  /**
   * @generated from field: repeated Authentication.UserDataKey userDataKeys = 1;
   */
  userDataKeys: UserDataKey[];

  /**
   * @generated from field: repeated int64 accessDenied = 2;
   */
  accessDenied: bigint[];

  /**
   * @generated from field: repeated int64 noEncryptedDataKey = 3;
   */
  noEncryptedDataKey: bigint[];
};

/**
 * Describes the message Authentication.UserDataKeyResponse.
 * Use `create(UserDataKeyResponseSchema)` to create a new message.
 */
export const UserDataKeyResponseSchema: GenMessage<UserDataKeyResponse> =
  /*@__PURE__*/
  messageDesc(file_api_request, 106);

/**
 * @generated from message Authentication.MasterPasswordRecoveryVerificationRequest
 */
export type MasterPasswordRecoveryVerificationRequest =
  Message<"Authentication.MasterPasswordRecoveryVerificationRequest"> & {
    /**
     * @generated from field: bytes encryptedLoginToken = 1;
     */
    encryptedLoginToken: Uint8Array;
  };

/**
 * Describes the message Authentication.MasterPasswordRecoveryVerificationRequest.
 * Use `create(MasterPasswordRecoveryVerificationRequestSchema)` to create a new message.
 */
export const MasterPasswordRecoveryVerificationRequestSchema: GenMessage<MasterPasswordRecoveryVerificationRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 107);

/**
 * @generated from message Authentication.GetSecurityQuestionV3Request
 */
export type GetSecurityQuestionV3Request =
  Message<"Authentication.GetSecurityQuestionV3Request"> & {
    /**
     * @generated from field: bytes encryptedLoginToken = 1;
     */
    encryptedLoginToken: Uint8Array;

    /**
     * @generated from field: string verificationCode = 2;
     */
    verificationCode: string;
  };

/**
 * Describes the message Authentication.GetSecurityQuestionV3Request.
 * Use `create(GetSecurityQuestionV3RequestSchema)` to create a new message.
 */
export const GetSecurityQuestionV3RequestSchema: GenMessage<GetSecurityQuestionV3Request> =
  /*@__PURE__*/
  messageDesc(file_api_request, 108);

/**
 * @generated from message Authentication.GetSecurityQuestionV3Response
 */
export type GetSecurityQuestionV3Response =
  Message<"Authentication.GetSecurityQuestionV3Response"> & {
    /**
     * @generated from field: string securityQuestion = 1;
     */
    securityQuestion: string;

    /**
     * @generated from field: int64 backupKeyDate = 2;
     */
    backupKeyDate: bigint;

    /**
     * @generated from field: bytes salt = 3;
     */
    salt: Uint8Array;

    /**
     * @generated from field: int32 iterations = 4;
     */
    iterations: number;
  };

/**
 * Describes the message Authentication.GetSecurityQuestionV3Response.
 * Use `create(GetSecurityQuestionV3ResponseSchema)` to create a new message.
 */
export const GetSecurityQuestionV3ResponseSchema: GenMessage<GetSecurityQuestionV3Response> =
  /*@__PURE__*/
  messageDesc(file_api_request, 109);

/**
 * @generated from message Authentication.GetDataKeyBackupV3Request
 */
export type GetDataKeyBackupV3Request = Message<"Authentication.GetDataKeyBackupV3Request"> & {
  /**
   * @generated from field: bytes encryptedLoginToken = 1;
   */
  encryptedLoginToken: Uint8Array;

  /**
   * @generated from field: string verificationCode = 2;
   */
  verificationCode: string;

  /**
   * @generated from field: bytes securityAnswerHash = 3;
   */
  securityAnswerHash: Uint8Array;
};

/**
 * Describes the message Authentication.GetDataKeyBackupV3Request.
 * Use `create(GetDataKeyBackupV3RequestSchema)` to create a new message.
 */
export const GetDataKeyBackupV3RequestSchema: GenMessage<GetDataKeyBackupV3Request> =
  /*@__PURE__*/
  messageDesc(file_api_request, 110);

/**
 * @generated from message Authentication.PasswordRules
 */
export type PasswordRules = Message<"Authentication.PasswordRules"> & {
  /**
   * @generated from field: string ruleType = 1;
   */
  ruleType: string;

  /**
   * @generated from field: bool match = 2;
   */
  match: boolean;

  /**
   * @generated from field: string pattern = 3;
   */
  pattern: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: int32 minimum = 5;
   */
  minimum: number;

  /**
   * @generated from field: string value = 6;
   */
  value: string;
};

/**
 * Describes the message Authentication.PasswordRules.
 * Use `create(PasswordRulesSchema)` to create a new message.
 */
export const PasswordRulesSchema: GenMessage<PasswordRules> =
  /*@__PURE__*/
  messageDesc(file_api_request, 111);

/**
 * @generated from message Authentication.GetDataKeyBackupV3Response
 */
export type GetDataKeyBackupV3Response = Message<"Authentication.GetDataKeyBackupV3Response"> & {
  /**
   * @generated from field: bytes dataKeyBackup = 1;
   */
  dataKeyBackup: Uint8Array;

  /**
   * @generated from field: int64 dataKeyBackupDate = 2;
   */
  dataKeyBackupDate: bigint;

  /**
   * @generated from field: bytes publicKey = 3;
   */
  publicKey: Uint8Array;

  /**
   * @generated from field: bytes encryptedPrivateKey = 4;
   */
  encryptedPrivateKey: Uint8Array;

  /**
   * @generated from field: bytes clientKey = 5;
   */
  clientKey: Uint8Array;

  /**
   * @generated from field: bytes encryptedSessionToken = 6;
   */
  encryptedSessionToken: Uint8Array;

  /**
   * @generated from field: repeated Authentication.PasswordRules passwordRules = 7;
   */
  passwordRules: PasswordRules[];

  /**
   * @generated from field: string passwordRulesIntro = 8;
   */
  passwordRulesIntro: string;

  /**
   * @generated from field: int32 minimumPbkdf2Iterations = 9;
   */
  minimumPbkdf2Iterations: number;

  /**
   * @generated from field: Enterprise.KeyType keyType = 10;
   */
  keyType: KeyType;
};

/**
 * Describes the message Authentication.GetDataKeyBackupV3Response.
 * Use `create(GetDataKeyBackupV3ResponseSchema)` to create a new message.
 */
export const GetDataKeyBackupV3ResponseSchema: GenMessage<GetDataKeyBackupV3Response> =
  /*@__PURE__*/
  messageDesc(file_api_request, 112);

/**
 * @generated from message Authentication.GetPublicKeysRequest
 */
export type GetPublicKeysRequest = Message<"Authentication.GetPublicKeysRequest"> & {
  /**
   * @generated from field: repeated string usernames = 1;
   */
  usernames: string[];
};

/**
 * Describes the message Authentication.GetPublicKeysRequest.
 * Use `create(GetPublicKeysRequestSchema)` to create a new message.
 */
export const GetPublicKeysRequestSchema: GenMessage<GetPublicKeysRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 113);

/**
 * @generated from message Authentication.PublicKeyResponse
 */
export type PublicKeyResponse = Message<"Authentication.PublicKeyResponse"> & {
  /**
   * @generated from field: string username = 1;
   */
  username: string;

  /**
   * @generated from field: bytes publicKey = 2;
   */
  publicKey: Uint8Array;

  /**
   * @generated from field: bytes publicEccKey = 3;
   */
  publicEccKey: Uint8Array;

  /**
   * @generated from field: string message = 4;
   */
  message: string;

  /**
   * @generated from field: string errorCode = 5;
   */
  errorCode: string;
};

/**
 * Describes the message Authentication.PublicKeyResponse.
 * Use `create(PublicKeyResponseSchema)` to create a new message.
 */
export const PublicKeyResponseSchema: GenMessage<PublicKeyResponse> =
  /*@__PURE__*/
  messageDesc(file_api_request, 114);

/**
 * @generated from message Authentication.GetPublicKeysResponse
 */
export type GetPublicKeysResponse = Message<"Authentication.GetPublicKeysResponse"> & {
  /**
   * @generated from field: repeated Authentication.PublicKeyResponse keyResponses = 1;
   */
  keyResponses: PublicKeyResponse[];
};

/**
 * Describes the message Authentication.GetPublicKeysResponse.
 * Use `create(GetPublicKeysResponseSchema)` to create a new message.
 */
export const GetPublicKeysResponseSchema: GenMessage<GetPublicKeysResponse> =
  /*@__PURE__*/
  messageDesc(file_api_request, 115);

/**
 * @generated from message Authentication.SetEccKeyPairRequest
 */
export type SetEccKeyPairRequest = Message<"Authentication.SetEccKeyPairRequest"> & {
  /**
   * @generated from field: bytes publicKey = 1;
   */
  publicKey: Uint8Array;

  /**
   * @generated from field: bytes encryptedPrivateKey = 2;
   */
  encryptedPrivateKey: Uint8Array;
};

/**
 * Describes the message Authentication.SetEccKeyPairRequest.
 * Use `create(SetEccKeyPairRequestSchema)` to create a new message.
 */
export const SetEccKeyPairRequestSchema: GenMessage<SetEccKeyPairRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 116);

/**
 * @generated from message Authentication.SetEccKeyPairsRequest
 */
export type SetEccKeyPairsRequest = Message<"Authentication.SetEccKeyPairsRequest"> & {
  /**
   * @generated from field: repeated Authentication.TeamEccKeyPair teamKeys = 1;
   */
  teamKeys: TeamEccKeyPair[];
};

/**
 * Describes the message Authentication.SetEccKeyPairsRequest.
 * Use `create(SetEccKeyPairsRequestSchema)` to create a new message.
 */
export const SetEccKeyPairsRequestSchema: GenMessage<SetEccKeyPairsRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 117);

/**
 * @generated from message Authentication.SetEccKeyPairsResponse
 */
export type SetEccKeyPairsResponse = Message<"Authentication.SetEccKeyPairsResponse"> & {
  /**
   * @generated from field: repeated Authentication.TeamEccKeyPairResponse teamKeys = 1;
   */
  teamKeys: TeamEccKeyPairResponse[];
};

/**
 * Describes the message Authentication.SetEccKeyPairsResponse.
 * Use `create(SetEccKeyPairsResponseSchema)` to create a new message.
 */
export const SetEccKeyPairsResponseSchema: GenMessage<SetEccKeyPairsResponse> =
  /*@__PURE__*/
  messageDesc(file_api_request, 118);

/**
 * @generated from message Authentication.TeamEccKeyPair
 */
export type TeamEccKeyPair = Message<"Authentication.TeamEccKeyPair"> & {
  /**
   * @generated from field: bytes teamUid = 1;
   */
  teamUid: Uint8Array;

  /**
   * @generated from field: bytes publicKey = 2;
   */
  publicKey: Uint8Array;

  /**
   * @generated from field: bytes encryptedPrivateKey = 3;
   */
  encryptedPrivateKey: Uint8Array;
};

/**
 * Describes the message Authentication.TeamEccKeyPair.
 * Use `create(TeamEccKeyPairSchema)` to create a new message.
 */
export const TeamEccKeyPairSchema: GenMessage<TeamEccKeyPair> =
  /*@__PURE__*/
  messageDesc(file_api_request, 119);

/**
 * @generated from message Authentication.TeamEccKeyPairResponse
 */
export type TeamEccKeyPairResponse = Message<"Authentication.TeamEccKeyPairResponse"> & {
  /**
   * @generated from field: bytes teamUid = 1;
   */
  teamUid: Uint8Array;

  /**
   * @generated from field: Authentication.GenericStatus status = 2;
   */
  status: GenericStatus;
};

/**
 * Describes the message Authentication.TeamEccKeyPairResponse.
 * Use `create(TeamEccKeyPairResponseSchema)` to create a new message.
 */
export const TeamEccKeyPairResponseSchema: GenMessage<TeamEccKeyPairResponse> =
  /*@__PURE__*/
  messageDesc(file_api_request, 120);

/**
 * @generated from message Authentication.GetKsmPublicKeysRequest
 */
export type GetKsmPublicKeysRequest = Message<"Authentication.GetKsmPublicKeysRequest"> & {
  /**
   * @generated from field: repeated bytes clientIds = 1;
   */
  clientIds: Uint8Array[];

  /**
   * @generated from field: repeated bytes controllerUids = 2;
   */
  controllerUids: Uint8Array[];
};

/**
 * Describes the message Authentication.GetKsmPublicKeysRequest.
 * Use `create(GetKsmPublicKeysRequestSchema)` to create a new message.
 */
export const GetKsmPublicKeysRequestSchema: GenMessage<GetKsmPublicKeysRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 121);

/**
 * @generated from message Authentication.DevicePublicKeyResponse
 */
export type DevicePublicKeyResponse = Message<"Authentication.DevicePublicKeyResponse"> & {
  /**
   * @generated from field: bytes clientId = 1;
   */
  clientId: Uint8Array;

  /**
   * @generated from field: bytes publicKey = 2;
   */
  publicKey: Uint8Array;

  /**
   * @generated from field: bytes controllerUid = 3;
   */
  controllerUid: Uint8Array;
};

/**
 * Describes the message Authentication.DevicePublicKeyResponse.
 * Use `create(DevicePublicKeyResponseSchema)` to create a new message.
 */
export const DevicePublicKeyResponseSchema: GenMessage<DevicePublicKeyResponse> =
  /*@__PURE__*/
  messageDesc(file_api_request, 122);

/**
 * @generated from message Authentication.GetKsmPublicKeysResponse
 */
export type GetKsmPublicKeysResponse = Message<"Authentication.GetKsmPublicKeysResponse"> & {
  /**
   * @generated from field: repeated Authentication.DevicePublicKeyResponse keyResponses = 1;
   */
  keyResponses: DevicePublicKeyResponse[];
};

/**
 * Describes the message Authentication.GetKsmPublicKeysResponse.
 * Use `create(GetKsmPublicKeysResponseSchema)` to create a new message.
 */
export const GetKsmPublicKeysResponseSchema: GenMessage<GetKsmPublicKeysResponse> =
  /*@__PURE__*/
  messageDesc(file_api_request, 123);

/**
 * @generated from message Authentication.AddAppSharesRequest
 */
export type AddAppSharesRequest = Message<"Authentication.AddAppSharesRequest"> & {
  /**
   * @generated from field: bytes appRecordUid = 1;
   */
  appRecordUid: Uint8Array;

  /**
   * @generated from field: repeated Authentication.AppShareAdd shares = 2;
   */
  shares: AppShareAdd[];
};

/**
 * Describes the message Authentication.AddAppSharesRequest.
 * Use `create(AddAppSharesRequestSchema)` to create a new message.
 */
export const AddAppSharesRequestSchema: GenMessage<AddAppSharesRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 124);

/**
 * @generated from message Authentication.RemoveAppSharesRequest
 */
export type RemoveAppSharesRequest = Message<"Authentication.RemoveAppSharesRequest"> & {
  /**
   * @generated from field: bytes appRecordUid = 1;
   */
  appRecordUid: Uint8Array;

  /**
   * @generated from field: repeated bytes shares = 2;
   */
  shares: Uint8Array[];
};

/**
 * Describes the message Authentication.RemoveAppSharesRequest.
 * Use `create(RemoveAppSharesRequestSchema)` to create a new message.
 */
export const RemoveAppSharesRequestSchema: GenMessage<RemoveAppSharesRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 125);

/**
 * @generated from message Authentication.AppShareAdd
 */
export type AppShareAdd = Message<"Authentication.AppShareAdd"> & {
  /**
   * @generated from field: bytes secretUid = 2;
   */
  secretUid: Uint8Array;

  /**
   * @generated from field: Authentication.ApplicationShareType shareType = 3;
   */
  shareType: ApplicationShareType;

  /**
   * @generated from field: bytes encryptedSecretKey = 4;
   */
  encryptedSecretKey: Uint8Array;

  /**
   * @generated from field: bool editable = 5;
   */
  editable: boolean;
};

/**
 * Describes the message Authentication.AppShareAdd.
 * Use `create(AppShareAddSchema)` to create a new message.
 */
export const AppShareAddSchema: GenMessage<AppShareAdd> =
  /*@__PURE__*/
  messageDesc(file_api_request, 126);

/**
 * @generated from message Authentication.AppShare
 */
export type AppShare = Message<"Authentication.AppShare"> & {
  /**
   * @generated from field: bytes secretUid = 1;
   */
  secretUid: Uint8Array;

  /**
   * @generated from field: Authentication.ApplicationShareType shareType = 2;
   */
  shareType: ApplicationShareType;

  /**
   * @generated from field: bool editable = 3;
   */
  editable: boolean;

  /**
   * @generated from field: int64 createdOn = 4;
   */
  createdOn: bigint;

  /**
   * @generated from field: bytes data = 5;
   */
  data: Uint8Array;
};

/**
 * Describes the message Authentication.AppShare.
 * Use `create(AppShareSchema)` to create a new message.
 */
export const AppShareSchema: GenMessage<AppShare> =
  /*@__PURE__*/
  messageDesc(file_api_request, 127);

/**
 * @generated from message Authentication.AddAppClientRequest
 */
export type AddAppClientRequest = Message<"Authentication.AddAppClientRequest"> & {
  /**
   * @generated from field: bytes appRecordUid = 1;
   */
  appRecordUid: Uint8Array;

  /**
   * @generated from field: bytes encryptedAppKey = 2;
   */
  encryptedAppKey: Uint8Array;

  /**
   * @generated from field: bytes clientId = 3;
   */
  clientId: Uint8Array;

  /**
   * @generated from field: bool lockIp = 4;
   */
  lockIp: boolean;

  /**
   * @generated from field: int64 firstAccessExpireOn = 5;
   */
  firstAccessExpireOn: bigint;

  /**
   * @generated from field: int64 accessExpireOn = 6;
   */
  accessExpireOn: bigint;

  /**
   * @generated from field: string id = 7;
   */
  id: string;

  /**
   * @generated from field: Enterprise.AppClientType appClientType = 8;
   */
  appClientType: AppClientType;
};

/**
 * Describes the message Authentication.AddAppClientRequest.
 * Use `create(AddAppClientRequestSchema)` to create a new message.
 */
export const AddAppClientRequestSchema: GenMessage<AddAppClientRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 128);

/**
 * @generated from message Authentication.RemoveAppClientsRequest
 */
export type RemoveAppClientsRequest = Message<"Authentication.RemoveAppClientsRequest"> & {
  /**
   * @generated from field: bytes appRecordUid = 1;
   */
  appRecordUid: Uint8Array;

  /**
   * @generated from field: repeated bytes clients = 2;
   */
  clients: Uint8Array[];
};

/**
 * Describes the message Authentication.RemoveAppClientsRequest.
 * Use `create(RemoveAppClientsRequestSchema)` to create a new message.
 */
export const RemoveAppClientsRequestSchema: GenMessage<RemoveAppClientsRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 129);

/**
 * @generated from message Authentication.AddExternalShareRequest
 */
export type AddExternalShareRequest = Message<"Authentication.AddExternalShareRequest"> & {
  /**
   * @generated from field: bytes recordUid = 1;
   */
  recordUid: Uint8Array;

  /**
   * @generated from field: bytes encryptedRecordKey = 2;
   */
  encryptedRecordKey: Uint8Array;

  /**
   * @generated from field: bytes clientId = 3;
   */
  clientId: Uint8Array;

  /**
   * @generated from field: int64 accessExpireOn = 4;
   */
  accessExpireOn: bigint;

  /**
   * @generated from field: string id = 5;
   */
  id: string;

  /**
   * @generated from field: bool isSelfDestruct = 6;
   */
  isSelfDestruct: boolean;

  /**
   * @generated from field: bool isEditable = 7;
   */
  isEditable: boolean;
};

/**
 * Describes the message Authentication.AddExternalShareRequest.
 * Use `create(AddExternalShareRequestSchema)` to create a new message.
 */
export const AddExternalShareRequestSchema: GenMessage<AddExternalShareRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 130);

/**
 * @generated from message Authentication.AppClient
 */
export type AppClient = Message<"Authentication.AppClient"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: bytes clientId = 2;
   */
  clientId: Uint8Array;

  /**
   * @generated from field: int64 createdOn = 3;
   */
  createdOn: bigint;

  /**
   * @generated from field: int64 firstAccess = 4;
   */
  firstAccess: bigint;

  /**
   * @generated from field: int64 lastAccess = 5;
   */
  lastAccess: bigint;

  /**
   * @generated from field: bytes publicKey = 6;
   */
  publicKey: Uint8Array;

  /**
   * @generated from field: bool lockIp = 7;
   */
  lockIp: boolean;

  /**
   * @generated from field: string ipAddress = 8;
   */
  ipAddress: string;

  /**
   * @generated from field: int64 firstAccessExpireOn = 9;
   */
  firstAccessExpireOn: bigint;

  /**
   * @generated from field: int64 accessExpireOn = 10;
   */
  accessExpireOn: bigint;

  /**
   * @generated from field: Enterprise.AppClientType appClientType = 11;
   */
  appClientType: AppClientType;

  /**
   * @generated from field: bool canEdit = 12;
   */
  canEdit: boolean;
};

/**
 * Describes the message Authentication.AppClient.
 * Use `create(AppClientSchema)` to create a new message.
 */
export const AppClientSchema: GenMessage<AppClient> =
  /*@__PURE__*/
  messageDesc(file_api_request, 131);

/**
 * @generated from message Authentication.GetAppInfoRequest
 */
export type GetAppInfoRequest = Message<"Authentication.GetAppInfoRequest"> & {
  /**
   * @generated from field: repeated bytes appRecordUid = 1;
   */
  appRecordUid: Uint8Array[];
};

/**
 * Describes the message Authentication.GetAppInfoRequest.
 * Use `create(GetAppInfoRequestSchema)` to create a new message.
 */
export const GetAppInfoRequestSchema: GenMessage<GetAppInfoRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 132);

/**
 * @generated from message Authentication.AppInfo
 */
export type AppInfo = Message<"Authentication.AppInfo"> & {
  /**
   * @generated from field: bytes appRecordUid = 1;
   */
  appRecordUid: Uint8Array;

  /**
   * @generated from field: repeated Authentication.AppShare shares = 2;
   */
  shares: AppShare[];

  /**
   * @generated from field: repeated Authentication.AppClient clients = 3;
   */
  clients: AppClient[];

  /**
   * @generated from field: bool isExternalShare = 4;
   */
  isExternalShare: boolean;
};

/**
 * Describes the message Authentication.AppInfo.
 * Use `create(AppInfoSchema)` to create a new message.
 */
export const AppInfoSchema: GenMessage<AppInfo> = /*@__PURE__*/ messageDesc(file_api_request, 133);

/**
 * @generated from message Authentication.GetAppInfoResponse
 */
export type GetAppInfoResponse = Message<"Authentication.GetAppInfoResponse"> & {
  /**
   * @generated from field: repeated Authentication.AppInfo appInfo = 1;
   */
  appInfo: AppInfo[];
};

/**
 * Describes the message Authentication.GetAppInfoResponse.
 * Use `create(GetAppInfoResponseSchema)` to create a new message.
 */
export const GetAppInfoResponseSchema: GenMessage<GetAppInfoResponse> =
  /*@__PURE__*/
  messageDesc(file_api_request, 134);

/**
 * @generated from message Authentication.ApplicationSummary
 */
export type ApplicationSummary = Message<"Authentication.ApplicationSummary"> & {
  /**
   * @generated from field: bytes appRecordUid = 1;
   */
  appRecordUid: Uint8Array;

  /**
   * @generated from field: int64 lastAccess = 2;
   */
  lastAccess: bigint;

  /**
   * @generated from field: int32 recordShares = 3;
   */
  recordShares: number;

  /**
   * @generated from field: int32 folderShares = 4;
   */
  folderShares: number;

  /**
   * @generated from field: int32 folderRecords = 5;
   */
  folderRecords: number;

  /**
   * @generated from field: int32 clientCount = 6;
   */
  clientCount: number;

  /**
   * @generated from field: int32 expiredClientCount = 7;
   */
  expiredClientCount: number;

  /**
   * @generated from field: string username = 8;
   */
  username: string;

  /**
   * @generated from field: bytes appData = 9;
   */
  appData: Uint8Array;
};

/**
 * Describes the message Authentication.ApplicationSummary.
 * Use `create(ApplicationSummarySchema)` to create a new message.
 */
export const ApplicationSummarySchema: GenMessage<ApplicationSummary> =
  /*@__PURE__*/
  messageDesc(file_api_request, 135);

/**
 * @generated from message Authentication.GetApplicationsSummaryResponse
 */
export type GetApplicationsSummaryResponse =
  Message<"Authentication.GetApplicationsSummaryResponse"> & {
    /**
     * @generated from field: repeated Authentication.ApplicationSummary applicationSummary = 1;
     */
    applicationSummary: ApplicationSummary[];
  };

/**
 * Describes the message Authentication.GetApplicationsSummaryResponse.
 * Use `create(GetApplicationsSummaryResponseSchema)` to create a new message.
 */
export const GetApplicationsSummaryResponseSchema: GenMessage<GetApplicationsSummaryResponse> =
  /*@__PURE__*/
  messageDesc(file_api_request, 136);

/**
 * @generated from message Authentication.GetVerificationTokenRequest
 */
export type GetVerificationTokenRequest = Message<"Authentication.GetVerificationTokenRequest"> & {
  /**
   * @generated from field: string username = 1;
   */
  username: string;
};

/**
 * Describes the message Authentication.GetVerificationTokenRequest.
 * Use `create(GetVerificationTokenRequestSchema)` to create a new message.
 */
export const GetVerificationTokenRequestSchema: GenMessage<GetVerificationTokenRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 137);

/**
 * @generated from message Authentication.GetVerificationTokenResponse
 */
export type GetVerificationTokenResponse =
  Message<"Authentication.GetVerificationTokenResponse"> & {
    /**
     * @generated from field: bytes encryptedVerificationToken = 1;
     */
    encryptedVerificationToken: Uint8Array;
  };

/**
 * Describes the message Authentication.GetVerificationTokenResponse.
 * Use `create(GetVerificationTokenResponseSchema)` to create a new message.
 */
export const GetVerificationTokenResponseSchema: GenMessage<GetVerificationTokenResponse> =
  /*@__PURE__*/
  messageDesc(file_api_request, 138);

/**
 * @generated from message Authentication.SendShareInviteRequest
 */
export type SendShareInviteRequest = Message<"Authentication.SendShareInviteRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;
};

/**
 * Describes the message Authentication.SendShareInviteRequest.
 * Use `create(SendShareInviteRequestSchema)` to create a new message.
 */
export const SendShareInviteRequestSchema: GenMessage<SendShareInviteRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 139);

/**
 * @generated from message Authentication.TimeLimitedAccessRequest
 */
export type TimeLimitedAccessRequest = Message<"Authentication.TimeLimitedAccessRequest"> & {
  /**
   * @generated from field: repeated bytes accountUid = 1;
   */
  accountUid: Uint8Array[];

  /**
   * @generated from field: repeated bytes teamUid = 2;
   */
  teamUid: Uint8Array[];

  /**
   * @generated from field: repeated bytes recordUid = 3;
   */
  recordUid: Uint8Array[];

  /**
   * @generated from field: bytes sharedObjectUid = 4;
   */
  sharedObjectUid: Uint8Array;

  /**
   * @generated from field: Authentication.TimeLimitedAccessType timeLimitedAccessType = 5;
   */
  timeLimitedAccessType: TimeLimitedAccessType;

  /**
   * @generated from field: int64 expiration = 6;
   */
  expiration: bigint;
};

/**
 * Describes the message Authentication.TimeLimitedAccessRequest.
 * Use `create(TimeLimitedAccessRequestSchema)` to create a new message.
 */
export const TimeLimitedAccessRequestSchema: GenMessage<TimeLimitedAccessRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 140);

/**
 * @generated from message Authentication.TimeLimitedAccessStatus
 */
export type TimeLimitedAccessStatus = Message<"Authentication.TimeLimitedAccessStatus"> & {
  /**
   * @generated from field: bytes uid = 1;
   */
  uid: Uint8Array;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message Authentication.TimeLimitedAccessStatus.
 * Use `create(TimeLimitedAccessStatusSchema)` to create a new message.
 */
export const TimeLimitedAccessStatusSchema: GenMessage<TimeLimitedAccessStatus> =
  /*@__PURE__*/
  messageDesc(file_api_request, 141);

/**
 * @generated from message Authentication.TimeLimitedAccessResponse
 */
export type TimeLimitedAccessResponse = Message<"Authentication.TimeLimitedAccessResponse"> & {
  /**
   * @generated from field: int64 revision = 1;
   */
  revision: bigint;

  /**
   * @generated from field: repeated Authentication.TimeLimitedAccessStatus userAccessStatus = 2;
   */
  userAccessStatus: TimeLimitedAccessStatus[];

  /**
   * @generated from field: repeated Authentication.TimeLimitedAccessStatus teamAccessStatus = 3;
   */
  teamAccessStatus: TimeLimitedAccessStatus[];

  /**
   * @generated from field: repeated Authentication.TimeLimitedAccessStatus recordAccessStatus = 4;
   */
  recordAccessStatus: TimeLimitedAccessStatus[];
};

/**
 * Describes the message Authentication.TimeLimitedAccessResponse.
 * Use `create(TimeLimitedAccessResponseSchema)` to create a new message.
 */
export const TimeLimitedAccessResponseSchema: GenMessage<TimeLimitedAccessResponse> =
  /*@__PURE__*/
  messageDesc(file_api_request, 142);

/**
 * @generated from message Authentication.RequestDownloadRequest
 */
export type RequestDownloadRequest = Message<"Authentication.RequestDownloadRequest"> & {
  /**
   * @generated from field: repeated string fileNames = 1;
   */
  fileNames: string[];
};

/**
 * Describes the message Authentication.RequestDownloadRequest.
 * Use `create(RequestDownloadRequestSchema)` to create a new message.
 */
export const RequestDownloadRequestSchema: GenMessage<RequestDownloadRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 143);

/**
 * @generated from message Authentication.RequestDownloadResponse
 */
export type RequestDownloadResponse = Message<"Authentication.RequestDownloadResponse"> & {
  /**
   * @generated from field: string result = 1;
   */
  result: string;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: repeated Authentication.Download downloads = 3;
   */
  downloads: Download[];
};

/**
 * Describes the message Authentication.RequestDownloadResponse.
 * Use `create(RequestDownloadResponseSchema)` to create a new message.
 */
export const RequestDownloadResponseSchema: GenMessage<RequestDownloadResponse> =
  /*@__PURE__*/
  messageDesc(file_api_request, 144);

/**
 * @generated from message Authentication.Download
 */
export type Download = Message<"Authentication.Download"> & {
  /**
   * @generated from field: string fileName = 1;
   */
  fileName: string;

  /**
   * @generated from field: string url = 2;
   */
  url: string;

  /**
   * @generated from field: int32 successStatusCode = 3;
   */
  successStatusCode: number;
};

/**
 * Describes the message Authentication.Download.
 * Use `create(DownloadSchema)` to create a new message.
 */
export const DownloadSchema: GenMessage<Download> =
  /*@__PURE__*/
  messageDesc(file_api_request, 145);

/**
 * @generated from message Authentication.DeleteUserRequest
 */
export type DeleteUserRequest = Message<"Authentication.DeleteUserRequest"> & {
  /**
   * @generated from field: string reason = 1;
   */
  reason: string;
};

/**
 * Describes the message Authentication.DeleteUserRequest.
 * Use `create(DeleteUserRequestSchema)` to create a new message.
 */
export const DeleteUserRequestSchema: GenMessage<DeleteUserRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 146);

/**
 * @generated from message Authentication.ChangeMasterPasswordRequest
 */
export type ChangeMasterPasswordRequest = Message<"Authentication.ChangeMasterPasswordRequest"> & {
  /**
   * @generated from field: bytes authVerifier = 1;
   */
  authVerifier: Uint8Array;

  /**
   * @generated from field: bytes encryptionParams = 2;
   */
  encryptionParams: Uint8Array;

  /**
   * @generated from field: bool fromServiceProvider = 3;
   */
  fromServiceProvider: boolean;

  /**
   * @generated from field: bool iterationsChange = 4;
   */
  iterationsChange: boolean;
};

/**
 * Describes the message Authentication.ChangeMasterPasswordRequest.
 * Use `create(ChangeMasterPasswordRequestSchema)` to create a new message.
 */
export const ChangeMasterPasswordRequestSchema: GenMessage<ChangeMasterPasswordRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 147);

/**
 * @generated from message Authentication.ChangeMasterPasswordResponse
 */
export type ChangeMasterPasswordResponse =
  Message<"Authentication.ChangeMasterPasswordResponse"> & {
    /**
     * @generated from field: bytes encryptedSessionToken = 1;
     */
    encryptedSessionToken: Uint8Array;
  };

/**
 * Describes the message Authentication.ChangeMasterPasswordResponse.
 * Use `create(ChangeMasterPasswordResponseSchema)` to create a new message.
 */
export const ChangeMasterPasswordResponseSchema: GenMessage<ChangeMasterPasswordResponse> =
  /*@__PURE__*/
  messageDesc(file_api_request, 148);

/**
 * @generated from message Authentication.AccountRecoverySetupRequest
 */
export type AccountRecoverySetupRequest = Message<"Authentication.AccountRecoverySetupRequest"> & {
  /**
   * @generated from field: bytes recoveryEncryptedDataKey = 1;
   */
  recoveryEncryptedDataKey: Uint8Array;

  /**
   * @generated from field: bytes recoveryAuthHash = 2;
   */
  recoveryAuthHash: Uint8Array;
};

/**
 * Describes the message Authentication.AccountRecoverySetupRequest.
 * Use `create(AccountRecoverySetupRequestSchema)` to create a new message.
 */
export const AccountRecoverySetupRequestSchema: GenMessage<AccountRecoverySetupRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 149);

/**
 * @generated from message Authentication.AccountRecoveryVerifyCodeResponse
 */
export type AccountRecoveryVerifyCodeResponse =
  Message<"Authentication.AccountRecoveryVerifyCodeResponse"> & {
    /**
     * @generated from field: Authentication.BackupKeyType backupKeyType = 1;
     */
    backupKeyType: BackupKeyType;

    /**
     * @generated from field: int64 backupKeyDate = 2;
     */
    backupKeyDate: bigint;

    /**
     * @generated from field: string securityQuestion = 3;
     */
    securityQuestion: string;

    /**
     * @generated from field: bytes salt = 4;
     */
    salt: Uint8Array;

    /**
     * @generated from field: int32 iterations = 5;
     */
    iterations: number;
  };

/**
 * Describes the message Authentication.AccountRecoveryVerifyCodeResponse.
 * Use `create(AccountRecoveryVerifyCodeResponseSchema)` to create a new message.
 */
export const AccountRecoveryVerifyCodeResponseSchema: GenMessage<AccountRecoveryVerifyCodeResponse> =
  /*@__PURE__*/
  messageDesc(file_api_request, 150);

/**
 * @generated from message Authentication.EmergencyAccessLoginRequest
 */
export type EmergencyAccessLoginRequest = Message<"Authentication.EmergencyAccessLoginRequest"> & {
  /**
   * @generated from field: string owner = 1;
   */
  owner: string;
};

/**
 * Describes the message Authentication.EmergencyAccessLoginRequest.
 * Use `create(EmergencyAccessLoginRequestSchema)` to create a new message.
 */
export const EmergencyAccessLoginRequestSchema: GenMessage<EmergencyAccessLoginRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 151);

/**
 * @generated from message Authentication.EmergencyAccessLoginResponse
 */
export type EmergencyAccessLoginResponse =
  Message<"Authentication.EmergencyAccessLoginResponse"> & {
    /**
     * @generated from field: bytes sessionToken = 1;
     */
    sessionToken: Uint8Array;

    /**
     * @generated from field: Enterprise.TypedKey dataKey = 2;
     */
    dataKey?: TypedKey;

    /**
     * @generated from field: Enterprise.TypedKey rsaPrivateKey = 3;
     */
    rsaPrivateKey?: TypedKey;

    /**
     * @generated from field: Enterprise.TypedKey eccPrivateKey = 4;
     */
    eccPrivateKey?: TypedKey;
  };

/**
 * Describes the message Authentication.EmergencyAccessLoginResponse.
 * Use `create(EmergencyAccessLoginResponseSchema)` to create a new message.
 */
export const EmergencyAccessLoginResponseSchema: GenMessage<EmergencyAccessLoginResponse> =
  /*@__PURE__*/
  messageDesc(file_api_request, 152);

/**
 * @generated from message Authentication.UserTeamKey
 */
export type UserTeamKey = Message<"Authentication.UserTeamKey"> & {
  /**
   * @generated from field: bytes teamUid = 1;
   */
  teamUid: Uint8Array;

  /**
   * @generated from field: string username = 2;
   */
  username: string;

  /**
   * @generated from field: int64 enterpriseUserId = 3;
   */
  enterpriseUserId: bigint;

  /**
   * @generated from field: bytes encryptedTeamKeyRSA = 4;
   */
  encryptedTeamKeyRSA: Uint8Array;

  /**
   * @generated from field: bytes encryptedTeamKeyEC = 5;
   */
  encryptedTeamKeyEC: Uint8Array;

  /**
   * @generated from field: Authentication.GenericStatus status = 6;
   */
  status: GenericStatus;
};

/**
 * Describes the message Authentication.UserTeamKey.
 * Use `create(UserTeamKeySchema)` to create a new message.
 */
export const UserTeamKeySchema: GenMessage<UserTeamKey> =
  /*@__PURE__*/
  messageDesc(file_api_request, 153);

/**
 * @generated from message Authentication.GenericRequestResponse
 */
export type GenericRequestResponse = Message<"Authentication.GenericRequestResponse"> & {
  /**
   * @generated from field: repeated bytes request = 1;
   */
  request: Uint8Array[];
};

/**
 * Describes the message Authentication.GenericRequestResponse.
 * Use `create(GenericRequestResponseSchema)` to create a new message.
 */
export const GenericRequestResponseSchema: GenMessage<GenericRequestResponse> =
  /*@__PURE__*/
  messageDesc(file_api_request, 154);

/**
 * @generated from message Authentication.PasskeyRegistrationRequest
 */
export type PasskeyRegistrationRequest = Message<"Authentication.PasskeyRegistrationRequest"> & {
  /**
   * @generated from field: Authentication.AuthenticatorAttachment authenticatorAttachment = 1;
   */
  authenticatorAttachment: AuthenticatorAttachment;
};

/**
 * Describes the message Authentication.PasskeyRegistrationRequest.
 * Use `create(PasskeyRegistrationRequestSchema)` to create a new message.
 */
export const PasskeyRegistrationRequestSchema: GenMessage<PasskeyRegistrationRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 155);

/**
 * @generated from message Authentication.PasskeyRegistrationResponse
 */
export type PasskeyRegistrationResponse = Message<"Authentication.PasskeyRegistrationResponse"> & {
  /**
   * @generated from field: bytes challengeToken = 1;
   */
  challengeToken: Uint8Array;

  /**
   * @generated from field: string pkCreationOptions = 2;
   */
  pkCreationOptions: string;
};

/**
 * Describes the message Authentication.PasskeyRegistrationResponse.
 * Use `create(PasskeyRegistrationResponseSchema)` to create a new message.
 */
export const PasskeyRegistrationResponseSchema: GenMessage<PasskeyRegistrationResponse> =
  /*@__PURE__*/
  messageDesc(file_api_request, 156);

/**
 * @generated from message Authentication.PasskeyRegistrationFinalization
 */
export type PasskeyRegistrationFinalization =
  Message<"Authentication.PasskeyRegistrationFinalization"> & {
    /**
     * @generated from oneof Authentication.PasskeyRegistrationFinalization._friendlyName
     */
    FriendlyName:
      | {
          /**
           * @generated from field: string friendlyName = 3;
           */
          value: string;
          case: "friendlyName";
        }
      | { case: undefined; value?: undefined };

    /**
     * @generated from field: bytes challengeToken = 1;
     */
    challengeToken: Uint8Array;

    /**
     * @generated from field: string authenticatorResponse = 2;
     */
    authenticatorResponse: string;
  };

/**
 * Describes the message Authentication.PasskeyRegistrationFinalization.
 * Use `create(PasskeyRegistrationFinalizationSchema)` to create a new message.
 */
export const PasskeyRegistrationFinalizationSchema: GenMessage<PasskeyRegistrationFinalization> =
  /*@__PURE__*/
  messageDesc(file_api_request, 157);

/**
 * @generated from message Authentication.PasskeyAuthenticationRequest
 */
export type PasskeyAuthenticationRequest =
  Message<"Authentication.PasskeyAuthenticationRequest"> & {
    /**
     * @generated from oneof Authentication.PasskeyAuthenticationRequest._username
     */
    Username:
      | {
          /**
           * @generated from field: string username = 5;
           */
          value: string;
          case: "username";
        }
      | { case: undefined; value?: undefined };

    /**
     * @generated from oneof Authentication.PasskeyAuthenticationRequest._encryptedLoginToken
     */
    EncryptedLoginToken:
      | {
          /**
           * @generated from field: bytes encryptedLoginToken = 6;
           */
          value: Uint8Array;
          case: "encryptedLoginToken";
        }
      | { case: undefined; value?: undefined };

    /**
     * @generated from field: Authentication.AuthenticatorAttachment authenticatorAttachment = 1;
     */
    authenticatorAttachment: AuthenticatorAttachment;

    /**
     * @generated from field: Authentication.PasskeyPurpose passkeyPurpose = 2;
     */
    passkeyPurpose: PasskeyPurpose;

    /**
     * @generated from field: string clientVersion = 3;
     */
    clientVersion: string;

    /**
     * @generated from field: bytes encryptedDeviceToken = 4;
     */
    encryptedDeviceToken: Uint8Array;
  };

/**
 * Describes the message Authentication.PasskeyAuthenticationRequest.
 * Use `create(PasskeyAuthenticationRequestSchema)` to create a new message.
 */
export const PasskeyAuthenticationRequestSchema: GenMessage<PasskeyAuthenticationRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 158);

/**
 * @generated from message Authentication.PasskeyAuthenticationResponse
 */
export type PasskeyAuthenticationResponse =
  Message<"Authentication.PasskeyAuthenticationResponse"> & {
    /**
     * @generated from oneof Authentication.PasskeyAuthenticationResponse._encryptedLoginToken
     */
    EncryptedLoginToken:
      | {
          /**
           * @generated from field: bytes encryptedLoginToken = 3;
           */
          value: Uint8Array;
          case: "encryptedLoginToken";
        }
      | { case: undefined; value?: undefined };

    /**
     * @generated from field: string pkRequestOptions = 1;
     */
    pkRequestOptions: string;

    /**
     * @generated from field: bytes challengeToken = 2;
     */
    challengeToken: Uint8Array;
  };

/**
 * Describes the message Authentication.PasskeyAuthenticationResponse.
 * Use `create(PasskeyAuthenticationResponseSchema)` to create a new message.
 */
export const PasskeyAuthenticationResponseSchema: GenMessage<PasskeyAuthenticationResponse> =
  /*@__PURE__*/
  messageDesc(file_api_request, 159);

/**
 * @generated from message Authentication.PasskeyValidationRequest
 */
export type PasskeyValidationRequest = Message<"Authentication.PasskeyValidationRequest"> & {
  /**
   * @generated from oneof Authentication.PasskeyValidationRequest._encryptedLoginToken
   */
  EncryptedLoginToken:
    | {
        /**
         * @generated from field: bytes encryptedLoginToken = 4;
         */
        value: Uint8Array;
        case: "encryptedLoginToken";
      }
    | { case: undefined; value?: undefined };

  /**
   * @generated from field: bytes challengeToken = 1;
   */
  challengeToken: Uint8Array;

  /**
   * @generated from field: bytes assertionResponse = 2;
   */
  assertionResponse: Uint8Array;

  /**
   * @generated from field: Authentication.PasskeyPurpose passkeyPurpose = 3;
   */
  passkeyPurpose: PasskeyPurpose;
};

/**
 * Describes the message Authentication.PasskeyValidationRequest.
 * Use `create(PasskeyValidationRequestSchema)` to create a new message.
 */
export const PasskeyValidationRequestSchema: GenMessage<PasskeyValidationRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 160);

/**
 * @generated from message Authentication.PasskeyValidationResponse
 */
export type PasskeyValidationResponse = Message<"Authentication.PasskeyValidationResponse"> & {
  /**
   * @generated from field: bool isValid = 1;
   */
  isValid: boolean;

  /**
   * @generated from field: bytes encryptedLoginToken = 2;
   */
  encryptedLoginToken: Uint8Array;
};

/**
 * Describes the message Authentication.PasskeyValidationResponse.
 * Use `create(PasskeyValidationResponseSchema)` to create a new message.
 */
export const PasskeyValidationResponseSchema: GenMessage<PasskeyValidationResponse> =
  /*@__PURE__*/
  messageDesc(file_api_request, 161);

/**
 * @generated from message Authentication.UpdatePasskeyRequest
 */
export type UpdatePasskeyRequest = Message<"Authentication.UpdatePasskeyRequest"> & {
  /**
   * @generated from oneof Authentication.UpdatePasskeyRequest._friendlyName
   */
  FriendlyName:
    | {
        /**
         * @generated from field: string friendlyName = 3;
         */
        value: string;
        case: "friendlyName";
      }
    | { case: undefined; value?: undefined };

  /**
   * @generated from field: int32 userId = 1;
   */
  userId: number;

  /**
   * @generated from field: bytes credentialId = 2;
   */
  credentialId: Uint8Array;
};

/**
 * Describes the message Authentication.UpdatePasskeyRequest.
 * Use `create(UpdatePasskeyRequestSchema)` to create a new message.
 */
export const UpdatePasskeyRequestSchema: GenMessage<UpdatePasskeyRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 162);

/**
 * @generated from message Authentication.PasskeyListRequest
 */
export type PasskeyListRequest = Message<"Authentication.PasskeyListRequest"> & {
  /**
   * @generated from field: bool includeDisabled = 1;
   */
  includeDisabled: boolean;
};

/**
 * Describes the message Authentication.PasskeyListRequest.
 * Use `create(PasskeyListRequestSchema)` to create a new message.
 */
export const PasskeyListRequestSchema: GenMessage<PasskeyListRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 163);

/**
 * @generated from message Authentication.PasskeyInfo
 */
export type PasskeyInfo = Message<"Authentication.PasskeyInfo"> & {
  /**
   * @generated from field: int32 userId = 1;
   */
  userId: number;

  /**
   * @generated from field: bytes credentialId = 2;
   */
  credentialId: Uint8Array;

  /**
   * @generated from field: string friendlyName = 3;
   */
  friendlyName: string;

  /**
   * @generated from field: string AAGUID = 4;
   */
  AAGUID: string;

  /**
   * @generated from field: int64 createdAtMillis = 5;
   */
  createdAtMillis: bigint;

  /**
   * @generated from field: int64 lastUsedMillis = 6;
   */
  lastUsedMillis: bigint;

  /**
   * @generated from field: int64 disabledAtMillis = 7;
   */
  disabledAtMillis: bigint;
};

/**
 * Describes the message Authentication.PasskeyInfo.
 * Use `create(PasskeyInfoSchema)` to create a new message.
 */
export const PasskeyInfoSchema: GenMessage<PasskeyInfo> =
  /*@__PURE__*/
  messageDesc(file_api_request, 164);

/**
 * @generated from message Authentication.PasskeyListResponse
 */
export type PasskeyListResponse = Message<"Authentication.PasskeyListResponse"> & {
  /**
   * @generated from field: repeated Authentication.PasskeyInfo passkeyInfo = 1;
   */
  passkeyInfo: PasskeyInfo[];
};

/**
 * Describes the message Authentication.PasskeyListResponse.
 * Use `create(PasskeyListResponseSchema)` to create a new message.
 */
export const PasskeyListResponseSchema: GenMessage<PasskeyListResponse> =
  /*@__PURE__*/
  messageDesc(file_api_request, 165);

/**
 * @generated from message Authentication.TranslationInfo
 */
export type TranslationInfo = Message<"Authentication.TranslationInfo"> & {
  /**
   * @generated from field: string translationKey = 1;
   */
  translationKey: string;

  /**
   * @generated from field: string translationValue = 2;
   */
  translationValue: string;
};

/**
 * Describes the message Authentication.TranslationInfo.
 * Use `create(TranslationInfoSchema)` to create a new message.
 */
export const TranslationInfoSchema: GenMessage<TranslationInfo> =
  /*@__PURE__*/
  messageDesc(file_api_request, 166);

/**
 * @generated from message Authentication.TranslationRequest
 */
export type TranslationRequest = Message<"Authentication.TranslationRequest"> & {
  /**
   * @generated from field: repeated string translationKey = 1;
   */
  translationKey: string[];
};

/**
 * Describes the message Authentication.TranslationRequest.
 * Use `create(TranslationRequestSchema)` to create a new message.
 */
export const TranslationRequestSchema: GenMessage<TranslationRequest> =
  /*@__PURE__*/
  messageDesc(file_api_request, 167);

/**
 * @generated from message Authentication.TranslationResponse
 */
export type TranslationResponse = Message<"Authentication.TranslationResponse"> & {
  /**
   * @generated from field: repeated Authentication.TranslationInfo translationInfo = 1;
   */
  translationInfo: TranslationInfo[];
};

/**
 * Describes the message Authentication.TranslationResponse.
 * Use `create(TranslationResponseSchema)` to create a new message.
 */
export const TranslationResponseSchema: GenMessage<TranslationResponse> =
  /*@__PURE__*/
  messageDesc(file_api_request, 168);

/**
 * @generated from enum Authentication.SupportedLanguage
 */
export enum SupportedLanguage {
  /**
   * @generated from enum value: ENGLISH = 0;
   */
  ENGLISH = 0,

  /**
   * @generated from enum value: ARABIC = 1;
   */
  ARABIC = 1,

  /**
   * @generated from enum value: BRITISH = 2;
   */
  BRITISH = 2,

  /**
   * @generated from enum value: CHINESE = 3;
   */
  CHINESE = 3,

  /**
   * @generated from enum value: CHINESE_HONG_KONG = 4;
   */
  CHINESE_HONG_KONG = 4,

  /**
   * @generated from enum value: CHINESE_TAIWAN = 5;
   */
  CHINESE_TAIWAN = 5,

  /**
   * @generated from enum value: DUTCH = 6;
   */
  DUTCH = 6,

  /**
   * @generated from enum value: FRENCH = 7;
   */
  FRENCH = 7,

  /**
   * @generated from enum value: GERMAN = 8;
   */
  GERMAN = 8,

  /**
   * @generated from enum value: GREEK = 9;
   */
  GREEK = 9,

  /**
   * @generated from enum value: HEBREW = 10;
   */
  HEBREW = 10,

  /**
   * @generated from enum value: ITALIAN = 11;
   */
  ITALIAN = 11,

  /**
   * @generated from enum value: JAPANESE = 12;
   */
  JAPANESE = 12,

  /**
   * @generated from enum value: KOREAN = 13;
   */
  KOREAN = 13,

  /**
   * @generated from enum value: POLISH = 14;
   */
  POLISH = 14,

  /**
   * @generated from enum value: PORTUGUESE = 15;
   */
  PORTUGUESE = 15,

  /**
   * @generated from enum value: PORTUGUESE_BRAZIL = 16;
   */
  PORTUGUESE_BRAZIL = 16,

  /**
   * @generated from enum value: ROMANIAN = 17;
   */
  ROMANIAN = 17,

  /**
   * @generated from enum value: RUSSIAN = 18;
   */
  RUSSIAN = 18,

  /**
   * @generated from enum value: SLOVAK = 19;
   */
  SLOVAK = 19,

  /**
   * @generated from enum value: SPANISH = 20;
   */
  SPANISH = 20,

  /**
   * @generated from enum value: FINNISH = 21;
   */
  FINNISH = 21,

  /**
   * @generated from enum value: SWEDISH = 22;
   */
  SWEDISH = 22,
}

/**
 * Describes the enum Authentication.SupportedLanguage.
 */
export const SupportedLanguageSchema: GenEnum<SupportedLanguage> =
  /*@__PURE__*/
  enumDesc(file_api_request, 0);

/**
 * @generated from enum Authentication.LoginType
 */
export enum LoginType {
  /**
   * @generated from enum value: NORMAL = 0;
   */
  NORMAL = 0,

  /**
   * @generated from enum value: SSO = 1;
   */
  SSO = 1,

  /**
   * @generated from enum value: BIO = 2;
   */
  BIO = 2,

  /**
   * @generated from enum value: ALTERNATE = 3;
   */
  ALTERNATE = 3,

  /**
   * @generated from enum value: OFFLINE = 4;
   */
  OFFLINE = 4,

  /**
   * @generated from enum value: FORGOT_PASSWORD = 5;
   */
  FORGOT_PASSWORD = 5,

  /**
   * @generated from enum value: PASSKEY_BIO = 6;
   */
  PASSKEY_BIO = 6,
}

/**
 * Describes the enum Authentication.LoginType.
 */
export const LoginTypeSchema: GenEnum<LoginType> = /*@__PURE__*/ enumDesc(file_api_request, 1);

/**
 * @generated from enum Authentication.DeviceStatus
 */
export enum DeviceStatus {
  /**
   * @generated from enum value: DEVICE_NEEDS_APPROVAL = 0;
   */
  DEVICE_NEEDS_APPROVAL = 0,

  /**
   * @generated from enum value: DEVICE_OK = 1;
   */
  DEVICE_OK = 1,

  /**
   * @generated from enum value: DEVICE_DISABLED_BY_USER = 2;
   */
  DEVICE_DISABLED_BY_USER = 2,

  /**
   * @generated from enum value: DEVICE_LOCKED_BY_ADMIN = 3;
   */
  DEVICE_LOCKED_BY_ADMIN = 3,
}

/**
 * Describes the enum Authentication.DeviceStatus.
 */
export const DeviceStatusSchema: GenEnum<DeviceStatus> =
  /*@__PURE__*/
  enumDesc(file_api_request, 2);

/**
 * @generated from enum Authentication.LicenseStatus
 */
export enum LicenseStatus {
  /**
   * @generated from enum value: OTHER = 0;
   */
  OTHER = 0,

  /**
   * @generated from enum value: ACTIVE = 1;
   */
  ACTIVE = 1,

  /**
   * @generated from enum value: EXPIRED = 2;
   */
  EXPIRED = 2,

  /**
   * @generated from enum value: DISABLED = 3;
   */
  DISABLED = 3,
}

/**
 * Describes the enum Authentication.LicenseStatus.
 */
export const LicenseStatusSchema: GenEnum<LicenseStatus> =
  /*@__PURE__*/
  enumDesc(file_api_request, 3);

/**
 * @generated from enum Authentication.AccountType
 */
export enum AccountType {
  /**
   * @generated from enum value: CONSUMER = 0;
   */
  CONSUMER = 0,

  /**
   * @generated from enum value: FAMILY = 1;
   */
  FAMILY = 1,

  /**
   * @generated from enum value: ENTERPRISE = 2;
   */
  ENTERPRISE = 2,
}

/**
 * Describes the enum Authentication.AccountType.
 */
export const AccountTypeSchema: GenEnum<AccountType> = /*@__PURE__*/ enumDesc(file_api_request, 4);

/**
 * @generated from enum Authentication.SessionTokenType
 */
export enum SessionTokenType {
  /**
   * @generated from enum value: NO_RESTRICTION = 0;
   */
  NO_RESTRICTION = 0,

  /**
   * @generated from enum value: ACCOUNT_RECOVERY = 1;
   */
  ACCOUNT_RECOVERY = 1,

  /**
   * @generated from enum value: SHARE_ACCOUNT = 2;
   */
  SHARE_ACCOUNT = 2,

  /**
   * @generated from enum value: PURCHASE = 3;
   */
  PURCHASE = 3,

  /**
   * @generated from enum value: RESTRICT = 4;
   */
  RESTRICT = 4,

  /**
   * @generated from enum value: ACCEPT_INVITE = 5;
   */
  ACCEPT_INVITE = 5,

  /**
   * @generated from enum value: SUPPORT_SERVER = 6;
   */
  SUPPORT_SERVER = 6,

  /**
   * @generated from enum value: ENTERPRISE_CREATION = 7;
   */
  ENTERPRISE_CREATION = 7,

  /**
   * @generated from enum value: EXPIRED_BUT_ALLOWED_TO_SYNC = 8;
   */
  EXPIRED_BUT_ALLOWED_TO_SYNC = 8,

  /**
   * @generated from enum value: ACCEPT_FAMILY_INVITE = 9;
   */
  ACCEPT_FAMILY_INVITE = 9,

  /**
   * @generated from enum value: ENTERPRISE_CREATION_PURCHASED = 10;
   */
  ENTERPRISE_CREATION_PURCHASED = 10,

  /**
   * @generated from enum value: EMERGENCY_ACCESS = 11;
   */
  EMERGENCY_ACCESS = 11,
}

/**
 * Describes the enum Authentication.SessionTokenType.
 */
export const SessionTokenTypeSchema: GenEnum<SessionTokenType> =
  /*@__PURE__*/
  enumDesc(file_api_request, 5);

/**
 * @generated from enum Authentication.Version
 */
export enum Version {
  /**
   * @generated from enum value: invalid_version = 0;
   */
  invalid_version = 0,

  /**
   * @generated from enum value: default_version = 1;
   */
  default_version = 1,

  /**
   * @generated from enum value: second_version = 2;
   */
  second_version = 2,
}

/**
 * Describes the enum Authentication.Version.
 */
export const VersionSchema: GenEnum<Version> = /*@__PURE__*/ enumDesc(file_api_request, 6);

/**
 * @generated from enum Authentication.MasterPasswordReentryActionType
 */
export enum MasterPasswordReentryActionType {
  /**
   * @generated from enum value: UNMASK = 0;
   */
  UNMASK = 0,

  /**
   * @generated from enum value: COPY = 1;
   */
  COPY = 1,
}

/**
 * Describes the enum Authentication.MasterPasswordReentryActionType.
 */
export const MasterPasswordReentryActionTypeSchema: GenEnum<MasterPasswordReentryActionType> =
  /*@__PURE__*/
  enumDesc(file_api_request, 7);

/**
 * @generated from enum Authentication.LoginMethod
 */
export enum LoginMethod {
  /**
   * @generated from enum value: INVALID_LOGINMETHOD = 0;
   */
  INVALID_LOGINMETHOD = 0,

  /**
   * @generated from enum value: EXISTING_ACCOUNT = 1;
   */
  EXISTING_ACCOUNT = 1,

  /**
   * @generated from enum value: SSO_DOMAIN = 2;
   */
  SSO_DOMAIN = 2,

  /**
   * @generated from enum value: AFTER_SSO = 3;
   */
  AFTER_SSO = 3,

  /**
   * @generated from enum value: NEW_ACCOUNT = 4;
   */
  NEW_ACCOUNT = 4,
}

/**
 * Describes the enum Authentication.LoginMethod.
 */
export const LoginMethodSchema: GenEnum<LoginMethod> = /*@__PURE__*/ enumDesc(file_api_request, 8);

/**
 * @generated from enum Authentication.LoginState
 */
export enum LoginState {
  /**
   * @generated from enum value: INVALID_LOGINSTATE = 0;
   */
  INVALID_LOGINSTATE = 0,

  /**
   * @generated from enum value: LOGGED_OUT = 1;
   */
  LOGGED_OUT = 1,

  /**
   * @generated from enum value: DEVICE_APPROVAL_REQUIRED = 2;
   */
  DEVICE_APPROVAL_REQUIRED = 2,

  /**
   * @generated from enum value: DEVICE_LOCKED = 3;
   */
  DEVICE_LOCKED = 3,

  /**
   * @generated from enum value: ACCOUNT_LOCKED = 4;
   */
  ACCOUNT_LOCKED = 4,

  /**
   * @generated from enum value: DEVICE_ACCOUNT_LOCKED = 5;
   */
  DEVICE_ACCOUNT_LOCKED = 5,

  /**
   * @generated from enum value: UPGRADE = 6;
   */
  UPGRADE = 6,

  /**
   * @generated from enum value: LICENSE_EXPIRED = 7;
   */
  LICENSE_EXPIRED = 7,

  /**
   * @generated from enum value: REGION_REDIRECT = 8;
   */
  REGION_REDIRECT = 8,

  /**
   * @generated from enum value: REDIRECT_CLOUD_SSO = 9;
   */
  REDIRECT_CLOUD_SSO = 9,

  /**
   * @generated from enum value: REDIRECT_ONSITE_SSO = 10;
   */
  REDIRECT_ONSITE_SSO = 10,

  /**
   * @generated from enum value: REQUIRES_2FA = 12;
   */
  REQUIRES_2FA = 12,

  /**
   * @generated from enum value: REQUIRES_AUTH_HASH = 13;
   */
  REQUIRES_AUTH_HASH = 13,

  /**
   * @generated from enum value: REQUIRES_USERNAME = 14;
   */
  REQUIRES_USERNAME = 14,

  /**
   * @generated from enum value: AFTER_CLOUD_SSO_LOGIN = 15;
   */
  AFTER_CLOUD_SSO_LOGIN = 15,

  /**
   * @generated from enum value: REQUIRES_ACCOUNT_CREATION = 16;
   */
  REQUIRES_ACCOUNT_CREATION = 16,

  /**
   * @generated from enum value: REQUIRES_DEVICE_ENCRYPTED_DATA_KEY = 17;
   */
  REQUIRES_DEVICE_ENCRYPTED_DATA_KEY = 17,

  /**
   * @generated from enum value: LOGIN_TOKEN_EXPIRED = 18;
   */
  LOGIN_TOKEN_EXPIRED = 18,

  /**
   * @generated from enum value: PASSKEY_INITIATE_CHALLENGE = 19;
   */
  PASSKEY_INITIATE_CHALLENGE = 19,

  /**
   * @generated from enum value: PASSKEY_AUTH_REQUIRED = 20;
   */
  PASSKEY_AUTH_REQUIRED = 20,

  /**
   * @generated from enum value: PASSKEY_VERIFY_AUTHENTICATION = 21;
   */
  PASSKEY_VERIFY_AUTHENTICATION = 21,

  /**
   * @generated from enum value: AFTER_PASSKEY_LOGIN = 22;
   */
  AFTER_PASSKEY_LOGIN = 22,

  /**
   * @generated from enum value: LOGGED_IN = 99;
   */
  LOGGED_IN = 99,
}

/**
 * Describes the enum Authentication.LoginState.
 */
export const LoginStateSchema: GenEnum<LoginState> = /*@__PURE__*/ enumDesc(file_api_request, 9);

/**
 * @generated from enum Authentication.EncryptedDataKeyType
 */
export enum EncryptedDataKeyType {
  /**
   * @generated from enum value: NO_KEY = 0;
   */
  NO_KEY = 0,

  /**
   * @generated from enum value: BY_DEVICE_PUBLIC_KEY = 1;
   */
  BY_DEVICE_PUBLIC_KEY = 1,

  /**
   * @generated from enum value: BY_PASSWORD = 2;
   */
  BY_PASSWORD = 2,

  /**
   * @generated from enum value: BY_ALTERNATE = 3;
   */
  BY_ALTERNATE = 3,

  /**
   * @generated from enum value: BY_BIO = 4;
   */
  BY_BIO = 4,
}

/**
 * Describes the enum Authentication.EncryptedDataKeyType.
 */
export const EncryptedDataKeyTypeSchema: GenEnum<EncryptedDataKeyType> =
  /*@__PURE__*/
  enumDesc(file_api_request, 10);

/**
 * @generated from enum Authentication.PasswordMethod
 */
export enum PasswordMethod {
  /**
   * @generated from enum value: ENTERED = 0;
   */
  ENTERED = 0,

  /**
   * @generated from enum value: BIOMETRICS = 1;
   */
  BIOMETRICS = 1,
}

/**
 * Describes the enum Authentication.PasswordMethod.
 */
export const PasswordMethodSchema: GenEnum<PasswordMethod> =
  /*@__PURE__*/
  enumDesc(file_api_request, 11);

/**
 * @generated from enum Authentication.TwoFactorPushType
 */
export enum TwoFactorPushType {
  /**
   * @generated from enum value: TWO_FA_PUSH_NONE = 0;
   */
  TWO_FA_PUSH_NONE = 0,

  /**
   * @generated from enum value: TWO_FA_PUSH_SMS = 1;
   */
  TWO_FA_PUSH_SMS = 1,

  /**
   * @generated from enum value: TWO_FA_PUSH_KEEPER = 2;
   */
  TWO_FA_PUSH_KEEPER = 2,

  /**
   * @generated from enum value: TWO_FA_PUSH_DUO_PUSH = 3;
   */
  TWO_FA_PUSH_DUO_PUSH = 3,

  /**
   * @generated from enum value: TWO_FA_PUSH_DUO_TEXT = 4;
   */
  TWO_FA_PUSH_DUO_TEXT = 4,

  /**
   * @generated from enum value: TWO_FA_PUSH_DUO_CALL = 5;
   */
  TWO_FA_PUSH_DUO_CALL = 5,

  /**
   * @generated from enum value: TWO_FA_PUSH_DNA = 6;
   */
  TWO_FA_PUSH_DNA = 6,
}

/**
 * Describes the enum Authentication.TwoFactorPushType.
 */
export const TwoFactorPushTypeSchema: GenEnum<TwoFactorPushType> =
  /*@__PURE__*/
  enumDesc(file_api_request, 12);

/**
 * @generated from enum Authentication.TwoFactorValueType
 */
export enum TwoFactorValueType {
  /**
   * @generated from enum value: TWO_FA_CODE_NONE = 0;
   */
  TWO_FA_CODE_NONE = 0,

  /**
   * @generated from enum value: TWO_FA_CODE_TOTP = 1;
   */
  TWO_FA_CODE_TOTP = 1,

  /**
   * @generated from enum value: TWO_FA_CODE_SMS = 2;
   */
  TWO_FA_CODE_SMS = 2,

  /**
   * @generated from enum value: TWO_FA_CODE_DUO = 3;
   */
  TWO_FA_CODE_DUO = 3,

  /**
   * @generated from enum value: TWO_FA_CODE_RSA = 4;
   */
  TWO_FA_CODE_RSA = 4,

  /**
   * @generated from enum value: TWO_FA_RESP_U2F = 5;
   */
  TWO_FA_RESP_U2F = 5,

  /**
   * @generated from enum value: TWO_FA_RESP_WEBAUTHN = 6;
   */
  TWO_FA_RESP_WEBAUTHN = 6,

  /**
   * @generated from enum value: TWO_FA_CODE_DNA = 7;
   */
  TWO_FA_CODE_DNA = 7,
}

/**
 * Describes the enum Authentication.TwoFactorValueType.
 */
export const TwoFactorValueTypeSchema: GenEnum<TwoFactorValueType> =
  /*@__PURE__*/
  enumDesc(file_api_request, 13);

/**
 * @generated from enum Authentication.TwoFactorChannelType
 */
export enum TwoFactorChannelType {
  /**
   * @generated from enum value: TWO_FA_CT_NONE = 0;
   */
  TWO_FA_CT_NONE = 0,

  /**
   * @generated from enum value: TWO_FA_CT_TOTP = 1;
   */
  TWO_FA_CT_TOTP = 1,

  /**
   * @generated from enum value: TWO_FA_CT_SMS = 2;
   */
  TWO_FA_CT_SMS = 2,

  /**
   * @generated from enum value: TWO_FA_CT_DUO = 3;
   */
  TWO_FA_CT_DUO = 3,

  /**
   * @generated from enum value: TWO_FA_CT_RSA = 4;
   */
  TWO_FA_CT_RSA = 4,

  /**
   * @generated from enum value: TWO_FA_CT_BACKUP = 5;
   */
  TWO_FA_CT_BACKUP = 5,

  /**
   * @generated from enum value: TWO_FA_CT_U2F = 6;
   */
  TWO_FA_CT_U2F = 6,

  /**
   * @generated from enum value: TWO_FA_CT_WEBAUTHN = 7;
   */
  TWO_FA_CT_WEBAUTHN = 7,

  /**
   * @generated from enum value: TWO_FA_CT_KEEPER = 8;
   */
  TWO_FA_CT_KEEPER = 8,

  /**
   * @generated from enum value: TWO_FA_CT_DNA = 9;
   */
  TWO_FA_CT_DNA = 9,
}

/**
 * Describes the enum Authentication.TwoFactorChannelType.
 */
export const TwoFactorChannelTypeSchema: GenEnum<TwoFactorChannelType> =
  /*@__PURE__*/
  enumDesc(file_api_request, 14);

/**
 * @generated from enum Authentication.TwoFactorExpiration
 */
export enum TwoFactorExpiration {
  /**
   * @generated from enum value: TWO_FA_EXP_IMMEDIATELY = 0;
   */
  TWO_FA_EXP_IMMEDIATELY = 0,

  /**
   * @generated from enum value: TWO_FA_EXP_5_MINUTES = 1;
   */
  TWO_FA_EXP_5_MINUTES = 1,

  /**
   * @generated from enum value: TWO_FA_EXP_12_HOURS = 2;
   */
  TWO_FA_EXP_12_HOURS = 2,

  /**
   * @generated from enum value: TWO_FA_EXP_24_HOURS = 3;
   */
  TWO_FA_EXP_24_HOURS = 3,

  /**
   * @generated from enum value: TWO_FA_EXP_30_DAYS = 4;
   */
  TWO_FA_EXP_30_DAYS = 4,

  /**
   * @generated from enum value: TWO_FA_EXP_NEVER = 5;
   */
  TWO_FA_EXP_NEVER = 5,
}

/**
 * Describes the enum Authentication.TwoFactorExpiration.
 */
export const TwoFactorExpirationSchema: GenEnum<TwoFactorExpiration> =
  /*@__PURE__*/
  enumDesc(file_api_request, 15);

/**
 * @generated from enum Authentication.LicenseType
 */
export enum LicenseType {
  /**
   * @generated from enum value: VAULT = 0;
   */
  VAULT = 0,

  /**
   * @generated from enum value: CHAT = 1;
   */
  CHAT = 1,

  /**
   * @generated from enum value: STORAGE = 2;
   */
  STORAGE = 2,

  /**
   * @generated from enum value: BREACHWATCH = 3;
   */
  BREACHWATCH = 3,
}

/**
 * Describes the enum Authentication.LicenseType.
 */
export const LicenseTypeSchema: GenEnum<LicenseType> = /*@__PURE__*/ enumDesc(file_api_request, 16);

/**
 * @generated from enum Authentication.ObjectTypes
 */
export enum ObjectTypes {
  /**
   * @generated from enum value: RECORD = 0;
   */
  RECORD = 0,

  /**
   * @generated from enum value: SHARED_FOLDER_USER = 1;
   */
  SHARED_FOLDER_USER = 1,

  /**
   * @generated from enum value: SHARED_FOLDER_TEAM = 2;
   */
  SHARED_FOLDER_TEAM = 2,

  /**
   * @generated from enum value: USER_FOLDER = 3;
   */
  USER_FOLDER = 3,

  /**
   * @generated from enum value: TEAM_USER = 4;
   */
  TEAM_USER = 4,
}

/**
 * Describes the enum Authentication.ObjectTypes.
 */
export const ObjectTypesSchema: GenEnum<ObjectTypes> = /*@__PURE__*/ enumDesc(file_api_request, 17);

/**
 * @generated from enum Authentication.EncryptedObjectType
 */
export enum EncryptedObjectType {
  /**
   * @generated from enum value: EOT_UNSPECIFIED = 0;
   */
  EOT_UNSPECIFIED = 0,

  /**
   * @generated from enum value: EOT_RECORD_KEY = 1;
   */
  EOT_RECORD_KEY = 1,

  /**
   * @generated from enum value: EOT_SHARED_FOLDER_USER_KEY = 2;
   */
  EOT_SHARED_FOLDER_USER_KEY = 2,

  /**
   * @generated from enum value: EOT_SHARED_FOLDER_TEAM_KEY = 3;
   */
  EOT_SHARED_FOLDER_TEAM_KEY = 3,

  /**
   * @generated from enum value: EOT_TEAM_USER_KEY = 4;
   */
  EOT_TEAM_USER_KEY = 4,

  /**
   * @generated from enum value: EOT_USER_FOLDER_KEY = 5;
   */
  EOT_USER_FOLDER_KEY = 5,

  /**
   * @generated from enum value: EOT_SECURITY_DATA = 6;
   */
  EOT_SECURITY_DATA = 6,

  /**
   * @generated from enum value: EOT_SECURITY_DATA_MASTER_PASSWORD = 7;
   */
  EOT_SECURITY_DATA_MASTER_PASSWORD = 7,

  /**
   * @generated from enum value: EOT_EMERGENCY_ACCESS_KEY = 8;
   */
  EOT_EMERGENCY_ACCESS_KEY = 8,

  /**
   * @generated from enum value: EOT_V2_RECORD_KEY = 9;
   */
  EOT_V2_RECORD_KEY = 9,
}

/**
 * Describes the enum Authentication.EncryptedObjectType.
 */
export const EncryptedObjectTypeSchema: GenEnum<EncryptedObjectType> =
  /*@__PURE__*/
  enumDesc(file_api_request, 18);

/**
 * @generated from enum Authentication.MasterPasswordReentryStatus
 */
export enum MasterPasswordReentryStatus {
  /**
   * @generated from enum value: MP_UNKNOWN = 0;
   */
  MP_UNKNOWN = 0,

  /**
   * @generated from enum value: MP_SUCCESS = 1;
   */
  MP_SUCCESS = 1,

  /**
   * @generated from enum value: MP_FAILURE = 2;
   */
  MP_FAILURE = 2,
}

/**
 * Describes the enum Authentication.MasterPasswordReentryStatus.
 */
export const MasterPasswordReentryStatusSchema: GenEnum<MasterPasswordReentryStatus> =
  /*@__PURE__*/
  enumDesc(file_api_request, 19);

/**
 * @generated from enum Authentication.AlternateAuthenticationType
 */
export enum AlternateAuthenticationType {
  /**
   * @generated from enum value: ALTERNATE_MASTER_PASSWORD = 0;
   */
  ALTERNATE_MASTER_PASSWORD = 0,

  /**
   * @generated from enum value: BIOMETRIC = 1;
   */
  BIOMETRIC = 1,

  /**
   * @generated from enum value: ACCOUNT_RECOVER = 2;
   */
  ACCOUNT_RECOVER = 2,
}

/**
 * Describes the enum Authentication.AlternateAuthenticationType.
 */
export const AlternateAuthenticationTypeSchema: GenEnum<AlternateAuthenticationType> =
  /*@__PURE__*/
  enumDesc(file_api_request, 20);

/**
 * @generated from enum Authentication.ThrottleType
 */
export enum ThrottleType {
  /**
   * @generated from enum value: PASSWORD_RETRY_THROTTLE = 0;
   */
  PASSWORD_RETRY_THROTTLE = 0,

  /**
   * @generated from enum value: PASSWORD_RETRY_LEGACY_THROTTLE = 1;
   */
  PASSWORD_RETRY_LEGACY_THROTTLE = 1,

  /**
   * @generated from enum value: TWO_FA_THROTTLE = 2;
   */
  TWO_FA_THROTTLE = 2,

  /**
   * @generated from enum value: TWO_FA_LEGACY_THROTTLE = 3;
   */
  TWO_FA_LEGACY_THROTTLE = 3,

  /**
   * @generated from enum value: QA_RETRY_THROTTLE = 4;
   */
  QA_RETRY_THROTTLE = 4,

  /**
   * @generated from enum value: ACCOUNT_RECOVER_THROTTLE = 5;
   */
  ACCOUNT_RECOVER_THROTTLE = 5,

  /**
   * @generated from enum value: VALIDATE_DEVICE_VERIFICATION_CODE_THROTTLE = 6;
   */
  VALIDATE_DEVICE_VERIFICATION_CODE_THROTTLE = 6,

  /**
   * @generated from enum value: VALIDATE_CREATE_USER_VERIFICATION_CODE_THROTTLE = 7;
   */
  VALIDATE_CREATE_USER_VERIFICATION_CODE_THROTTLE = 7,
}

/**
 * Describes the enum Authentication.ThrottleType.
 */
export const ThrottleTypeSchema: GenEnum<ThrottleType> =
  /*@__PURE__*/
  enumDesc(file_api_request, 21);

/**
 * @generated from enum Authentication.Region
 */
export enum Region {
  /**
   * @generated from enum value: UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: eu = 1;
   */
  eu = 1,

  /**
   * @generated from enum value: us = 2;
   */
  us = 2,

  /**
   * @generated from enum value: usgov = 3;
   */
  usgov = 3,

  /**
   * @generated from enum value: au = 4;
   */
  au = 4,

  /**
   * @generated from enum value: jp = 5;
   */
  jp = 5,

  /**
   * @generated from enum value: ca = 6;
   */
  ca = 6,
}

/**
 * Describes the enum Authentication.Region.
 */
export const RegionSchema: GenEnum<Region> = /*@__PURE__*/ enumDesc(file_api_request, 22);

/**
 * @generated from enum Authentication.ApplicationShareType
 */
export enum ApplicationShareType {
  /**
   * @generated from enum value: SHARE_TYPE_RECORD = 0;
   */
  SHARE_TYPE_RECORD = 0,

  /**
   * @generated from enum value: SHARE_TYPE_FOLDER = 1;
   */
  SHARE_TYPE_FOLDER = 1,
}

/**
 * Describes the enum Authentication.ApplicationShareType.
 */
export const ApplicationShareTypeSchema: GenEnum<ApplicationShareType> =
  /*@__PURE__*/
  enumDesc(file_api_request, 23);

/**
 * @generated from enum Authentication.TimeLimitedAccessType
 */
export enum TimeLimitedAccessType {
  /**
   * @generated from enum value: INVALID_TIME_LIMITED_ACCESS_TYPE = 0;
   */
  INVALID_TIME_LIMITED_ACCESS_TYPE = 0,

  /**
   * @generated from enum value: USER_ACCESS_TO_RECORD = 1;
   */
  USER_ACCESS_TO_RECORD = 1,

  /**
   * @generated from enum value: USER_OR_TEAM_ACCESS_TO_SHAREDFOLDER = 2;
   */
  USER_OR_TEAM_ACCESS_TO_SHAREDFOLDER = 2,

  /**
   * @generated from enum value: RECORD_ACCESS_TO_SHAREDFOLDER = 3;
   */
  RECORD_ACCESS_TO_SHAREDFOLDER = 3,
}

/**
 * Describes the enum Authentication.TimeLimitedAccessType.
 */
export const TimeLimitedAccessTypeSchema: GenEnum<TimeLimitedAccessType> =
  /*@__PURE__*/
  enumDesc(file_api_request, 24);

/**
 * @generated from enum Authentication.BackupKeyType
 */
export enum BackupKeyType {
  /**
   * @generated from enum value: BKT_SEC_ANSWER = 0;
   */
  BKT_SEC_ANSWER = 0,

  /**
   * @generated from enum value: BKT_PASSPHRASE_HASH = 1;
   */
  BKT_PASSPHRASE_HASH = 1,
}

/**
 * Describes the enum Authentication.BackupKeyType.
 */
export const BackupKeyTypeSchema: GenEnum<BackupKeyType> =
  /*@__PURE__*/
  enumDesc(file_api_request, 25);

/**
 * @generated from enum Authentication.GenericStatus
 */
export enum GenericStatus {
  /**
   * @generated from enum value: SUCCESS = 0;
   */
  SUCCESS = 0,

  /**
   * @generated from enum value: INVALID_OBJECT = 1;
   */
  INVALID_OBJECT = 1,

  /**
   * @generated from enum value: ALREADY_EXISTS = 2;
   */
  ALREADY_EXISTS = 2,

  /**
   * @generated from enum value: ACCESS_DENIED = 3;
   */
  ACCESS_DENIED = 3,
}

/**
 * Describes the enum Authentication.GenericStatus.
 */
export const GenericStatusSchema: GenEnum<GenericStatus> =
  /*@__PURE__*/
  enumDesc(file_api_request, 26);

/**
 * @generated from enum Authentication.AuthenticatorAttachment
 */
export enum AuthenticatorAttachment {
  /**
   * @generated from enum value: CROSS_PLATFORM = 0;
   */
  CROSS_PLATFORM = 0,

  /**
   * @generated from enum value: PLATFORM = 1;
   */
  PLATFORM = 1,

  /**
   * @generated from enum value: ALL_SUPPORTED = 2;
   */
  ALL_SUPPORTED = 2,
}

/**
 * Describes the enum Authentication.AuthenticatorAttachment.
 */
export const AuthenticatorAttachmentSchema: GenEnum<AuthenticatorAttachment> =
  /*@__PURE__*/
  enumDesc(file_api_request, 27);

/**
 * @generated from enum Authentication.PasskeyPurpose
 */
export enum PasskeyPurpose {
  /**
   * @generated from enum value: PK_LOGIN = 0;
   */
  PK_LOGIN = 0,

  /**
   * @generated from enum value: PK_REAUTH = 1;
   */
  PK_REAUTH = 1,
}

/**
 * Describes the enum Authentication.PasskeyPurpose.
 */
export const PasskeyPurposeSchema: GenEnum<PasskeyPurpose> =
  /*@__PURE__*/
  enumDesc(file_api_request, 28);

/**
 * @generated from enum Authentication.ClientFormFactor
 */
export enum ClientFormFactor {
  /**
   * @generated from enum value: FF_EMPTY = 0;
   */
  FF_EMPTY = 0,

  /**
   * @generated from enum value: FF_PHONE = 1;
   */
  FF_PHONE = 1,

  /**
   * @generated from enum value: FF_TABLET = 2;
   */
  FF_TABLET = 2,

  /**
   * @generated from enum value: FF_WATCH = 3;
   */
  FF_WATCH = 3,
}

/**
 * Describes the enum Authentication.ClientFormFactor.
 */
export const ClientFormFactorSchema: GenEnum<ClientFormFactor> =
  /*@__PURE__*/
  enumDesc(file_api_request, 29);
